(function() {
  'use strict';

  if (!window.JIR_CONFIG) {
    console.warn('[JIR] JIR_CONFIG not found.');
    return;
  }

  const CFG = window.JIR_CONFIG;
  const BUILD_PARAM = CFG.buildParam || 'jir_build';
  const DEFAULT_APP_STATE_KEY = 'jir:ring-builder:last-state';
  const FETCH_DEBOUNCE_MS = 150;
  const DIAMOND_PAGE_CACHE_TTL_MS = Math.max(1, Number(CFG.cacheTtlMinutes || 5)) * 60 * 1000;
  const SETTING_PRICE_CACHE_TTL_MS = 30 * 60 * 1000;
  const CURATED_RANKING_POOL_MAX = 50;
  const WINTER_CONTEXT_KEY = 'jir:winter-event-entry';
  const WINTER_CONTEXT_TTL_MS = 30 * 60 * 1000;
  const WINTER_CONTEXT = getWinterEventContext();
  const APP_STATE_KEY = WINTER_CONTEXT.templateActive ? 'jir:ring-builder:winter-state' : DEFAULT_APP_STATE_KEY;

  function safeCollectionPath(value, fallback) {
    var defaultPath = String(fallback || '/collections/winter-sale-2026');
    try {
      var url = new URL(String(value || defaultPath), window.location.origin);
      if (url.origin !== window.location.origin || url.pathname.indexOf('/collections/') !== 0) return defaultPath;
      return url.pathname + url.search;
    } catch (e) {
      return defaultPath;
    }
  }

  function getWinterEventContext() {
    var config = CFG.winterEvent || {};
    var params = new URLSearchParams(window.location.search);
    var urlActive = params.get('winter_event') === '1' || window.location.hash === '#winter-event';
    var templateActive = config.forceActive === true || window.location.pathname === '/pages/winter-sale-ring-builder';
    var saved = null;
    try {
      saved = JSON.parse(window.sessionStorage.getItem(WINTER_CONTEXT_KEY) || 'null');
      if (!saved || Number(saved.savedAt || 0) < Date.now() - WINTER_CONTEXT_TTL_MS) {
        window.sessionStorage.removeItem(WINTER_CONTEXT_KEY);
        saved = null;
      }
    } catch (e) {
      saved = null;
    }
    var savedWinterHandoff = !!(
      saved &&
      (
        saved.flow === 'winter-sale' ||
        (
          saved.winter_step === 'diamonds' &&
          String(saved.return_to || '').indexOf('/collections/winter-sale-2026') === 0
        )
      )
    );
    // The dedicated Winter page may hand off through sessionStorage when an
    // app redirect strips query parameters. Consume it once so later normal
    // Build Your Own visits are not treated as Winter entries.
    var active = urlActive || templateActive || savedWinterHandoff;
    var value = function(key) {
      return params.get(key) || (saved && saved[key]) || '';
    };
    var requestedStep = params.get('winter_step') || (!urlActive && saved && saved.winter_step) || '';
    var nextStep = requestedStep === 'diamonds' ? 'diamonds' : 'pdp';
    var context = {
      active: active,
      settingId: active ? value('settingId') : '',
      settingVariantId: active ? value('settingVariantId') : '',
      settingHandle: active ? value('settingHandle') : '',
      settingShape: active ? value('settingShape') : '',
      settingDetailUrl: active ? value('winter_setting_url') : '',
      recommendedDiamondPriceCents: active ? Number(value('recommendedDiamondPriceCents') || 0) : 0,
      templateActive: templateActive,
      nextStep: active ? nextStep : 'pdp',
      saleTag: String(value('saleTag') || config.saleTag || 'winter-sale-2026').trim(),
      returnLabel: String(config.returnLabel || 'Back to Winter Sale Collection'),
      returnUrl: safeCollectionPath(value('return_to'), config.defaultReturnUrl)
    };
    if (savedWinterHandoff && !templateActive) {
      try {
        window.sessionStorage.removeItem(WINTER_CONTEXT_KEY);
      } catch (e) {}
    }
    return context;
  }

  function textCfg(key, fallback) {
    return (CFG.uiText && CFG.uiText[key]) || fallback;
  }

  function recommendedPriceNote() {
    return 'Complete ring price with a recommended centre diamond.';
  }

  function livePricePending() {
    return !!(CFG.proxyUrl && (S.settingPriceStatus === 'idle' || S.settingPriceStatus === 'loading'));
  }

  function unavailablePriceNote() {
    return 'Recommended complete ring pricing is currently unavailable.';
  }

  function imageCfg(key) {
    return (CFG.uiImages && CFG.uiImages[key]) || '';
  }

  function getDefaultLeadTime() {
    return textCfg('defaultLeadTime', '4–6 weeks');
  }

  function getSettingLeadTime(setting) {
    return (setting && setting.leadTime) || getDefaultLeadTime();
  }

  function themeImageMarkup(src, alt, className) {
    if (!src) return '';
    return '<img src="' + escapeHtml(src) + '" alt="' + escapeHtml(alt || '') + '" class="' + escapeHtml(className || 'jir-theme-asset') + '" loading="lazy">';
  }

  function trackBuilderEvent(name, params) {
    var payload = Object.assign({
      event: name,
      setting_id: S.setting && S.setting.id ? S.setting.id : undefined,
      shape: S.shape || undefined,
      size_range: S.sizeRange || undefined,
      decision_mode: S.decisionMode || undefined
    }, params || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent('jir:builder:event', { detail: payload }));
  }

  function nowMs() {
    return (window.performance && typeof window.performance.now === 'function')
      ? window.performance.now()
      : Date.now();
  }

  function hashString(value) {
    var str = String(value || '');
    var hash = 0;
    for (var i = 0; i < str.length; i += 1) {
      hash = ((hash << 5) - hash) + str.charCodeAt(i);
      hash |= 0;
    }
    return Math.abs(hash).toString(36);
  }

  function renderCertificateLabIcon(lab) {
    var node = el('jir-cert-icon');
    if (!node) return;
    var labCode = String(lab || '').trim().toUpperCase();
    var imageSrc = labCode === 'IGI'
      ? (imageCfg('certificateIgi') || imageCfg('certificate'))
      : labCode === 'GIA'
        ? (imageCfg('certificateGia') || imageCfg('certificate'))
        : imageCfg('certificate');
    if (imageSrc) {
      node.innerHTML =
        '<span class="jir-cert-icon-badge">' +
          themeImageMarkup(imageSrc, labCode ? (labCode + ' certificate icon') : 'Certificate icon', 'jir-theme-inline-icon jir-theme-inline-icon--sm') +
        '</span>';
      return;
    }
    node.innerHTML =
      '<span class="jir-cert-icon-badge">' +
        escapeHtml(labCode === 'IGI' || labCode === 'GIA' ? labCode : 'CERT') +
      '</span>';
  }

  /* Holds a reference to the filter-bar scroll updateButtons fn.
   * Set by initSettingsFilterScroller(), called by goto('settings')
   * after the page becomes visible so scrollWidth/clientWidth are real. */
  var _filterScrollUpdate = null;

  const S = {
    settings: [],
    setting: null,
    metal: '18k Yellow Gold',
    metalP: 0,
    metalVariantId: null,
    shape: 'Round',
    size: null,
    profile: 'Standard',
    sizeRange: 'classic',
    qualityPreference: 'balanced',
    decisionMode: 'exact',

    diamonds: [],
    allFetchedDiamonds: [],
    filteredDiamonds: [],
    diamond: null,
    dIdx: 0,

    dLoading: false,
    isAppending: false,
    visibleDiamondCount: 0,
    offset: 0,
    pageSize: 24,
    browseMorePageSize: 20,
    totalCount: 0,
    hasMore: false,
    allPagesLoaded: false,
    countingTotal: false,
    browseMoreOpened: false,
    advancedFiltersOpened: false,
    selectedTier: 'recommended',
    morePageNumber: 0,
    lastResponseMs: 0,
    recommendationsEventKey: '',
    priceMatchEventKey: '',
    lastDiamondFetchKey: '',
    diamondFetchTimer: null,
    diamondFetchAbort: null,
    diamondRequestSeq: 0,

    adminRules: null,
    customerFilters: null,
    lowestDiamondPriceByShape: {},
    settingPriceFetchToken: 0,
    settingPriceStatus: 'idle',
    mediaValidationCache: {},
    gradeGuideState: {},

    settingFilters: {
      shape: 'All',
      style: 'All',
      col: 'All'
    },
    settingSort: 'collection',

    pendingRestore: null,
    pendingRestoreToken: 0,
    lastSelectedDiamondId: null,
    currentPage: 'landing',
    mediaResizeTimer: null,

    /* IntersectionObserver instances for sticky CTA visibility */
    _pdpObserver:  null,
    _dpdpObserver: null
  };

  const SHAPE_SVG = {
    Round:    `<svg viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="1.5"/></svg>`,
    Oval:     `<svg viewBox="0 0 20 20" fill="none"><ellipse cx="10" cy="10" rx="6" ry="8.5" stroke="currentColor" stroke-width="1.5"/></svg>`,
    Pear:     `<svg viewBox="0 0 20 20" fill="none"><path d="M10 1.5C14.2 1.5 17 5 17 9C17 14 13 18.5 10 18.5C7 18.5 3 14 3 9C3 5 5.8 1.5 10 1.5Z" stroke="currentColor" stroke-width="1.5"/></svg>`,
    Cushion:  `<svg viewBox="0 0 20 20" fill="none"><rect x="2" y="2" width="16" height="16" rx="4" stroke="currentColor" stroke-width="1.5"/></svg>`,
    Emerald:  `<svg viewBox="0 0 20 20" fill="none"><polygon points="5.5,2 14.5,2 18,6 18,14 14.5,18 5.5,18 2,14 2,6" stroke="currentColor" stroke-width="1.5"/></svg>`,
    Marquise: `<svg viewBox="0 0 20 20" fill="none"><path d="M10 2C15 5.5 16.5 10 10 18C3.5 10 5 5.5 10 2Z" stroke="currentColor" stroke-width="1.5"/></svg>`,
    Princess: `<svg viewBox="0 0 20 20" fill="none"><rect x="2" y="2" width="16" height="16" stroke="currentColor" stroke-width="1.5"/></svg>`,
    Radiant:  `<svg viewBox="0 0 20 20" fill="none"><polygon points="5,2 15,2 18,5 18,15 15,18 5,18 2,15 2,5" stroke="currentColor" stroke-width="1.5"/></svg>`
  };

  const SHAPE_CODE_MAP = {
    Round: 'ROUND', Oval: 'OVAL', Pear: 'PEAR', Cushion: 'CUSHION',
    Emerald: 'EMERALD', Marquise: 'MARQUISE', Princess: 'PRINCESS', Radiant: 'RADIANT'
  };

  const SHAPE_IMAGE_KEY_MAP = {
    Round: 'shapeRound',
    Oval: 'shapeOval',
    Pear: 'shapePear',
    Cushion: 'shapeCushion',
    Emerald: 'shapeEmerald',
    Marquise: 'shapeMarquise',
    Princess: 'shapePrincess',
    Radiant: 'shapeRadiant'
  };

  const CUT_CODE_MAP = {
    'Excellent': 'EX', 'Ideal': 'ID', 'Very Good': 'VG',
    'Good': 'G', 'Fair': 'F', 'Poor': 'P'
  };

  const FLUOR_CODE_MAP = {
    'None': 'NON', 'Faint': 'FNT', 'Very Slight': 'VSL',
    'Slight': 'SLT', 'Medium': 'MED', 'Strong': 'STG'
  };

  const CUT_GRADE_MAP = {
    EX: 'Excellent', ID: 'Ideal', VG: 'Very Good',
    G: 'Good', F: 'Fair', P: 'Poor'
  };

  const COLOUR_GRADE_ORDER = ['D', 'E', 'F', 'G', 'H', 'I', 'J'];
  const CLARITY_GRADE_ORDER = ['FL', 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2'];
  const CUT_GRADE_ORDER = ['IDEAL', 'EXCELLENT', 'VERY GOOD', 'GOOD', 'FAIR', 'POOR'];

  const GRADE_MAP = {
    ID: 'Ideal',
    EX: 'Excellent',
    Ex: 'Excellent',
    VG: 'Very Good',
    Gd: 'Good',
    GD: 'Good',
    Fr: 'Fair',
    FR: 'Fair',
    Po: 'Poor',
    EXC: 'Excellent',
    VGD: 'Very Good',
    GOO: 'Good'
  };

  function parseGradeRows(value) {
    return String(value || '').split('\n').map(function(line) {
      var parts = line.split('|');
      return { g: String(parts[0] || '').trim(), d: String(parts.slice(1).join('|') || '').trim() };
    }).filter(function(row) { return row.g && row.d; });
  }

  const GRADE_ED = {
    carat: {
      title: (CFG.gradeEducation && CFG.gradeEducation.carat && CFG.gradeEducation.carat.title) || 'Carat',
      intro: (CFG.gradeEducation && CFG.gradeEducation.carat && CFG.gradeEducation.carat.intro) || 'Carat measures weight, not visible size. One carat equals 0.2 grams, and cut proportions strongly influence how large a diamond looks face-up.',
      rows:  parseGradeRows(CFG.gradeEducation && CFG.gradeEducation.carat && CFG.gradeEducation.carat.rows)
    },
    cut: {
      title: (CFG.gradeEducation && CFG.gradeEducation.cut && CFG.gradeEducation.cut.title) || 'Cut',
      intro: (CFG.gradeEducation && CFG.gradeEducation.cut && CFG.gradeEducation.cut.intro) || 'Cut has the strongest influence on sparkle because it determines brightness, fire, and scintillation.',
      rows:  parseGradeRows(CFG.gradeEducation && CFG.gradeEducation.cut && CFG.gradeEducation.cut.rows)
    },
    colour: {
      title: (CFG.gradeEducation && CFG.gradeEducation.colour && CFG.gradeEducation.colour.title) || 'Colour',
      intro: (CFG.gradeEducation && CFG.gradeEducation.colour && CFG.gradeEducation.colour.intro) || 'Colour grades measure how little body colour a white diamond shows.',
      rows:  parseGradeRows(CFG.gradeEducation && CFG.gradeEducation.colour && CFG.gradeEducation.colour.rows)
    },
    clarity: {
      title: (CFG.gradeEducation && CFG.gradeEducation.clarity && CFG.gradeEducation.clarity.title) || 'Clarity',
      intro: (CFG.gradeEducation && CFG.gradeEducation.clarity && CFG.gradeEducation.clarity.intro) || 'Clarity describes inclusions and blemishes, graded under 10x magnification.',
      rows:  parseGradeRows(CFG.gradeEducation && CFG.gradeEducation.clarity && CFG.gradeEducation.clarity.rows)
    },
    fluor: {
      title: (CFG.gradeEducation && CFG.gradeEducation.fluor && CFG.gradeEducation.fluor.title) || 'Fluorescence',
      intro: (CFG.gradeEducation && CFG.gradeEducation.fluor && CFG.gradeEducation.fluor.intro) || 'Fluorescence is the glow under UV light.',
      rows:  parseGradeRows(CFG.gradeEducation && CFG.gradeEducation.fluor && CFG.gradeEducation.fluor.rows)
    }
  };

  const GRADE_TAB_ORDER = ['carat', 'colour', 'clarity', 'cut'];
  const GRADE_TAB_LABELS = {
    carat: 'Carat',
    cut: 'Cut',
    colour: 'Colour',
    clarity: 'Clarity',
    fluor: 'Fluorescence'
  };
  const FLUOR_TAB_ORDER = ['fluor'];
  const DETAIL_GUIDE_ORDER = ['carat', 'colour', 'clarity', 'cut'];
  const CURATED_VISIBLE_MAX = 8;
  const DEFAULT_SIZE_RANGES = {
    petite: { label: 'Petite', min: 0.70, max: 0.99 },
    classic: { label: 'Classic', min: 1.00, max: 1.49 },
    statement: { label: 'Statement', min: 1.50, max: 1.99 },
    heirloom: { label: 'Heirloom', min: 2.00, max: 99 }
  };
  const SIZE_RANGES = Object.assign({}, DEFAULT_SIZE_RANGES, (CFG.curatedSpecs && CFG.curatedSpecs.sizeRanges) || {});

  function formatSizeRangeLabel(range) {
    if (!range) return '';
    var min = Number(range.min || 0);
    var max = Number(range.max || 0);
    if (!min && !max) return '';
    if (max >= 99) return min.toFixed(2) + 'ct+';
    return min.toFixed(2) + '-' + max.toFixed(2) + 'ct';
  }

  const GUIDE_VISUALS = (function() {
    var result = { fallback: {}, stop: { carat: {}, colour: {}, clarity: {}, cut: {} } };
    (CFG.guideVisualBlocks || []).forEach(function(block) {
      if (!block || !block.image) return;
      var type = String(block.guideType || '').toLowerCase();
      var stopKey = String(block.stopKey || '').toUpperCase();
      if (type === 'carat') stopKey = String(block.stopKey || '');
      if (block.type === 'guide_visual_fallback' && type) {
        result.fallback[type] = block.image;
        return;
      }
      if ((block.type === 'guide_visual_carat' || block.type === 'guide_visual_colour' || block.type === 'guide_visual_clarity') && type && stopKey) {
        result.stop[type][stopKey] = block.image;
      }
    });
    return result;
  })();

  function getGradeModalTabOrder(type) {
    return type === 'fluor' ? FLUOR_TAB_ORDER : GRADE_TAB_ORDER;
  }

  function getGuideStopImage(type, item) {
    var itemKey = item && item.key ? String(item.key).toUpperCase() : '';
    if (type === 'carat' && item && item.key) itemKey = String(item.key);
    return (GUIDE_VISUALS.stop[type] && GUIDE_VISUALS.stop[type][itemKey]) || '';
  }

  function getGuideFallbackImage(type) {
    return GUIDE_VISUALS.fallback[type] || '';
  }

  function buildGradeRowsFromGuideItems(type) {
    var items = getGuideItems(type) || [];
    return items.map(function(item) {
      return {
        g: item.label || item.key || '—',
        d: item.note || item.intro || ''
      };
    }).filter(function(row) {
      return row.g && row.d;
    });
  }

  function getGradeModalContent(type) {
    if (type === 'fluor') return GRADE_ED.fluor;
    var fallbackTitle = type === 'carat' ? 'Carat' : (type === 'colour' ? 'Colour' : (type === 'clarity' ? 'Clarity' : 'Cut'));
    var fallbackIntro = type === 'carat'
      ? 'Carat measures weight, not visible size. One carat equals 0.2 grams, and cut proportions strongly influence how large a diamond looks face-up.'
      : type === 'colour'
        ? 'Colour grades measure how little body colour a white diamond shows. Higher grades appear whiter and icier face-up.'
        : type === 'clarity'
          ? 'Clarity describes inclusions and blemishes, graded under 10x magnification. Many buyers focus on whether the stone appears eye-clean.'
          : 'Cut has the strongest influence on sparkle because it controls how efficiently light returns to the eye.';
    var configured = GRADE_ED[type] || {};
    var guideRows = buildGradeRowsFromGuideItems(type);
    return {
      title: configured.title || fallbackTitle,
      intro: configured.intro || fallbackIntro,
      rows: configured.rows && configured.rows.length ? configured.rows : guideRows
    };
  }

  function el(id) { return document.getElementById(id); }
  function q(sel) { return document.querySelector(sel); }
  function qAll(sel) { return document.querySelectorAll(sel); }

  /* ── Currency helpers ────────────────────────────────────────────────────
   * getActiveCurrency() / getCurrencyRate() read Shopify.currency when
   * Shopify Markets multi-currency is enabled. If not enabled (or the JS
   * object isn't present) they fall back to the store's base currency.
   *
   * HOW SHOPIFY MARKETS CURRENCY WORKS:
   *  • Shopify.currency.active  = the currency the customer has selected
   *  • Shopify.currency.rate    = exchange rate FROM the store base currency
   *  • Diamond prices from Nivoda are in AUD cents (we specify preferred_currency: AUD)
   *  • Setting/metal prices in JIR_SETTINGS are in the store's base currency (dollars)
   *  • Both are multiplied by rate before display so labels match the storefront
   * ─────────────────────────────────────────────────────────────────────── */
  function getActiveCurrency() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    return CFG.currency || 'AUD';
  }

  function getCurrencyRate() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
      return parseFloat(window.Shopify.currency.rate) || 1;
    }
    return 1;
  }

  /* fmtPrice: input is cents in base currency (AUD or store base) */
  function fmtPrice(cents) {
    var rate = getCurrencyRate();
    return new Intl.NumberFormat(CFG.locale || 'en-AU', {
      style: 'currency', currency: getActiveCurrency(),
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 0, maximumFractionDigits: 0
    }).format(((Number(cents) || 0) / 100) * rate);
  }

  /* fmtPriceNum: input is dollars in base currency */
  function fmtPriceNum(dollars) {
    var rate = getCurrencyRate();
    return new Intl.NumberFormat(CFG.locale || 'en-AU', {
      style: 'currency', currency: getActiveCurrency(),
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 0, maximumFractionDigits: 0
    }).format((Number(dollars) || 0) * rate);
  }

  function roundDisplayCents(cents) {
    return Math.round((Number(cents) || 0) / 100) * 100;
  }

  /* fmtSliderPrice: formats a slider dollar value (base currency) for display */
  function fmtSliderPrice(dollars) {
    return fmtPriceNum(dollars);
  }

  function getCachedRecommendedDiamondPriceForShape(setting, shape) {
    if (!setting) return 0;
    var shapeKey = normaliseShapeToken(shape || '');
    var byShape = setting.recommendedDiamondPriceCentsByShape;
    if (byShape && typeof byShape === 'object' && shapeKey) {
      var exact = Number(byShape[shapeKey] || byShape[shapeKey.toLowerCase()] || byShape[shapeKey.toUpperCase()] || 0);
      if (exact > 0) return exact;
    }
    var settingPrice = Number(setting.recommendedDiamondPriceCents || 0);
    return settingPrice > 0 ? settingPrice : 0;
  }

  function getCachedRecommendedDiamondPriceForSetting(setting) {
    if (!setting) return 0;
    return normaliseShapes(setting.shapes).reduce(function(min, shape) {
      var next = getCachedRecommendedDiamondPriceForShape(setting, shape);
      if (!next) return min;
      if (!min) return next;
      return Math.min(min, next);
    }, 0);
  }

  function getLowestDiamondPriceForSetting(setting) {
    if (!setting) return 0;
    var livePrice = normaliseShapes(setting.shapes).reduce(function(min, shape) {
      var next = Number(S.lowestDiamondPriceByShape[shape] || 0);
      if (!next) return min;
      if (!min) return next;
      return Math.min(min, next);
    }, 0);
    if (livePrice > 0) return livePrice;
    if (CFG.proxyUrl && (S.settingPriceStatus === 'idle' || S.settingPriceStatus === 'loading')) return 0;
    return getCachedRecommendedDiamondPriceForSetting(setting);
  }

  function getLowestDiamondPriceForSelectedShape(setting) {
    if (!setting) return 0;
    var selectedShape = normaliseShapeToken(S.shape || '');
    var settingShapes = normaliseShapes(setting.shapes);
    if (selectedShape && settingShapes.indexOf(selectedShape) > -1) {
      var liveShapePrice = Number(S.lowestDiamondPriceByShape[selectedShape] || 0);
      if (liveShapePrice > 0) return liveShapePrice;
      if (CFG.proxyUrl && (S.settingPriceStatus === 'idle' || S.settingPriceStatus === 'loading')) return 0;
      return getCachedRecommendedDiamondPriceForShape(setting, selectedShape);
    }
    return getLowestDiamondPriceForSetting(setting);
  }

  function getSettingFromPrice(setting) {
    if (!setting) return 0;
    var liveLowestDiamondCents = getLowestDiamondPriceForSetting(setting);
    if (liveLowestDiamondCents > 0) {
      return Number(setting.basePrice || 0) + (liveLowestDiamondCents / 100);
    }
    return null;
  }

  function getSelectedSettingFromPrice(setting) {
    if (!setting) return 0;
    var liveLowestDiamondCents = getLowestDiamondPriceForSelectedShape(setting);
    if (liveLowestDiamondCents > 0) {
      return getSelectedSettingPrice(setting) + (liveLowestDiamondCents / 100);
    }
    return null;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function safeJsonStringify(v) { try { return JSON.stringify(v); } catch (e) { return ''; } }

  function readSessionCache(key, ttlMs) {
    try {
      if (!window.sessionStorage || !key) return null;
      var raw = window.sessionStorage.getItem(key);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return null;
      if (ttlMs && Number(parsed.ts || 0) < Date.now() - ttlMs) {
        window.sessionStorage.removeItem(key);
        return null;
      }
      return parsed.data;
    } catch (e) {
      return null;
    }
  }

  function writeSessionCache(key, data) {
    try {
      if (!window.sessionStorage || !key) return;
      window.sessionStorage.setItem(key, JSON.stringify({ ts: Date.now(), data: data }));
    } catch (e) {}
  }

  function getSettingPriceCacheKey() {
    return 'jir:setting-recommended-prices:v6:' +
      safeJsonStringify(normaliseAdminRules(CFG.diamondRules || {})) + ':' +
      String(getConfiguredDefaultSizeRange());
  }

  function getDiamondPageCacheKey(fetchKey) {
    return 'jir:diamonds:v8:' + String(fetchKey || '');
  }

  function getDiamondInventoryCacheKey(query) {
    return 'jir:diamond-inventory:v1:' + hashString(query);
  }

  function getBuildCacheKey(state) {
    if (!state || !state.settingId || !state.diamondId) return '';
    return 'jir-build-cache:' + String(state.settingId) + ':' + String(state.diamondId);
  }

  function writeBuildSnapshot(state, diamond) {
    var key = getBuildCacheKey(state);
    if (!key || !diamond) return;
    try {
      var payload = {
        savedAt: Date.now(),
        state: {
          settingId: state.settingId,
          metal: state.metal || null,
          shape: state.shape || null,
          size: state.size || null,
          profile: state.profile || 'Standard',
          diamondId: state.diamondId
        },
        diamond: diamond
      };
      if (window.sessionStorage) window.sessionStorage.setItem(key, JSON.stringify(payload));
      if (window.localStorage) window.localStorage.setItem(key, JSON.stringify(payload));
    } catch (e) {}
  }

  function readBuildSnapshot(state) {
    var key = getBuildCacheKey(state);
    if (!key) return null;
    try {
      var raw = (window.sessionStorage && window.sessionStorage.getItem(key))
        || (window.localStorage && window.localStorage.getItem(key));
      if (!raw) return null;
      var payload = JSON.parse(raw);
      if (!payload || !payload.diamond) return null;
      return payload.diamond;
    } catch (e) {
      return null;
    }
  }

  function hydrateDiamondDetailFromRecord(diamond) {
    if (!diamond) return;
    S.allFetchedDiamonds = [diamond];
    S.filteredDiamonds = [diamond];
    S.diamonds = [diamond];
    S.visibleDiamondCount = 1;
    selectDiamond(0);
  }

  function getShopDomain() {
    if (window.Shopify && typeof window.Shopify.shop === 'string' && window.Shopify.shop) return window.Shopify.shop;
    if (CFG.shopDomain) return CFG.shopDomain;
    return window.location.hostname;
  }

  function cleanArray(arr) {
    return (arr || []).map(function(v) { return String(v).trim(); }).filter(Boolean);
  }

  function isRoundShape(shape) {
    return normaliseShapeToken(shape).toLowerCase() === 'round';
  }

  function normalizedValueInList(value, allowed) {
    var normalized = String(value || '').trim().toUpperCase();
    return cleanArray(allowed).some(function(candidate) {
      return String(candidate).trim().toUpperCase() === normalized;
    });
  }

  function getSettingCollectionOptions() {
    var configured = cleanArray(CFG.settingCollections || []);
    if (configured.length) return configured;
    return S.settings.map(function(item) { return String(item.collection || '').trim(); })
      .filter(Boolean)
      .filter(function(v, i, arr) { return arr.indexOf(v) === i; });
  }

  function getNivodaDisplayPrice(item) {
    var salePrice = Number(item && item.price || 0);
    var markupPrice = Number(item && item.markup_price || 0);
    var baseDiamondPrice = Number(item && item.diamond_price || 0);

    if (markupPrice > 0) {
      return Math.max(markupPrice, salePrice, baseDiamondPrice);
    }

    if (salePrice > 0) return salePrice;
    if (baseDiamondPrice > 0) return baseDiamondPrice;
    return 0;
  }

  function buildRecommendedDiamondPriceQuery(shape, opts) {
    opts = opts || {};
    var effective = getEffectiveDiamondFilters();
    var shapeCode = SHAPE_CODE_MAP[shape] || String(shape || '').toUpperCase().trim();
    var supportsCutGrade = isRoundShape(shape);
    var cutCodes = cleanArray(effective.cuts || []).map(function(c) { return CUT_CODE_MAP[c] || 'EX'; });
    var fluorCodes = cleanArray(effective.fluors || []).map(function(f) { return FLUOR_CODE_MAP[f] || 'NON'; });
    var queryLines = [
      'query RecommendedDiamondPrice {',
      '  diamonds_by_query(',
      '    offset: 0',
      '    limit: ' + getCuratedFetchLimit(),
      '    query: {',
      '      shapes: '           + gqlStrList([shapeCode]),
      '      labgrown: true',
      '      availability: AVAILABLE',
      '      color: '            + gqlEnumList(cleanArray(effective.colours || [])),
      '      clarity: '          + gqlEnumList(cleanArray(effective.clarities || [])),
      '      flouresence: '      + gqlEnumList(fluorCodes),
      '      certificate_lab: '  + gqlEnumList(cleanArray(effective.labs || [])),
      '      sizes: { from: '    + Number(effective.carat_min) + ', to: ' + Number(effective.carat_max) + ' }',
      '      preferred_currency: AUD',
      '      search_on_preferred_currency: true',
      '    }',
      '    order: { type: price, direction: ASC }',
      '  ) {',
      '    items {',
      '      id price diamond_price markup_price',
      '      diamond {',
      '        id availability image video',
      '        certificate {',
      '          lab certNumber shape carats',
      '          clarity color cut polish symmetry',
      '          masked_pdf_url pdfUrl',
      '          length width depth depthPercentage table',
      '        }',
      '      }',
      '    }',
      '  }',
      '}'
    ];

    function gqlStr(v)      { return JSON.stringify(String(v)); }
    function gqlStrList(arr)  { return '[' + arr.map(gqlStr).join(', ') + ']'; }
    function gqlEnumList(arr) { return '[' + arr.map(function(v) { return String(v).trim(); }).join(', ') + ']'; }

    if (!opts.omitCut && supportsCutGrade && cutCodes.length) {
      queryLines.splice(10, 0, '      cut: ' + gqlEnumList(cutCodes));
    }

    return queryLines.join('\n');
  }

  function getLowestRecommendedDiamondPriceFromDiamonds(diamonds) {
    var eligibleDiamonds = (diamonds || []).filter(function(diamond) {
      return diamond && Number(diamond.price || 0) > 0;
    }).sort(function(a, b) {
      return Number(a.price || 0) - Number(b.price || 0);
    });
    return eligibleDiamonds.reduce(function(min, diamond) {
      var price = Number(diamond.price || 0);
      if (!price) return min;
      if (!min) return price;
      return Math.min(min, price);
    }, 0);
  }

  function fetchRecommendedDiamondPriceForShape(shape) {
    function requestPrice(query) {
      var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timeout = controller ? setTimeout(function() { controller.abort(); }, 12000) : null;
      return fetch(CFG.proxyUrl + '/diamonds', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Shop-Domain': getShopDomain(),
          'x-jir-token': CFG.proxyToken || ''
        },
        body: JSON.stringify({ query: query }),
        signal: controller ? controller.signal : undefined
      })
      .then(function(r) {
        if (!r.ok) return r.text().then(function(text) { throw new Error('Proxy returned ' + r.status + ' :: ' + text); });
        return r.json();
      })
      .then(function(data) {
        var items = data && data.data && data.data.diamonds_by_query && data.data.diamonds_by_query.items
          ? data.data.diamonds_by_query.items
          : [];
        return filterDiamondsWithValidMedia(items.map(mapDiamondItem))
          .then(getLowestRecommendedDiamondPriceFromDiamonds);
      })
      .finally(function() {
        if (timeout) clearTimeout(timeout);
      });
    }

    return requestPrice(buildRecommendedDiamondPriceQuery(shape)).then(function(price) {
      if (price > 0) return price;
      if (String(shape || '').trim().toLowerCase() === 'round') return 0;
      return requestPrice(buildRecommendedDiamondPriceQuery(shape, { omitCut: true }));
    });
  }

  function updateSettingFromPrices() {
    S.settings.forEach(function(setting) {
      var lowestDiamondCents = getLowestDiamondPriceForSetting(setting);
      if (lowestDiamondCents > 0) {
        setting.dynamicFromPrice = Number(setting.basePrice || 0) + (lowestDiamondCents / 100);
        syncWinterLandingSettingPrice(setting, setting.dynamicFromPrice);
      } else {
        setting.dynamicFromPrice = null;
      }
    });
    syncAllWinterLandingSettingPrices();
  }

  function winterLandingShapes(card) {
    var configured = normaliseShapes(card && card.dataset.settingShapes || '');
    if (configured.length) return configured;
    var title = String(card && card.querySelector('.winter-event__product-title') && card.querySelector('.winter-event__product-title').textContent || '').toLowerCase();
    var supported = ['Round', 'Oval', 'Pear', 'Cushion', 'Emerald', 'Marquise', 'Princess', 'Radiant'];
    var inferred = supported.filter(function(shape) { return title.indexOf(shape.toLowerCase()) !== -1; });
    return inferred.length ? inferred : ['Round'];
  }

  function syncAllWinterLandingSettingPrices() {
    var updated = false;
    qAll('[data-winter-product].winter-event__product--setting').forEach(function(card) {
      var lowestDiamondCents = winterLandingShapes(card).reduce(function(lowest, shape) {
        var price = Number(S.lowestDiamondPriceByShape[normaliseShapeToken(shape)] || 0);
        if (!price) return lowest;
        return !lowest ? price : Math.min(lowest, price);
      }, 0);
      var settingPriceCents = Number(card.dataset.settingBasePrice || 0);
      if (!lowestDiamondCents || !settingPriceCents) return;
      var completePrice = (settingPriceCents + lowestDiamondCents) / 100;
      card.dataset.price = String(settingPriceCents + lowestDiamondCents);
      var price = card.querySelector('[data-winter-product-price]');
      if (price) price.textContent = 'From ' + fmtPriceNum(completePrice);
      updated = true;
    });
    if (updated) {
      qAll('[data-winter-event]').forEach(function(section) {
        if (section.winterEvent && typeof section.winterEvent.filterProducts === 'function') {
          section.winterEvent.filterProducts();
        }
      });
    }
  }

  function preloadImportedWinterSettingPrice(setting) {
    if (!setting || !CFG.proxyUrl) return;
    normaliseShapes(setting.shapes).forEach(function(shape) {
      var shapeKey = normaliseShapeToken(shape);
      if (Number(S.lowestDiamondPriceByShape[shapeKey] || 0) > 0) return;
      fetchRecommendedDiamondPriceForShape(shapeKey).then(function(price) {
        if (Number(price || 0) <= 0) return;
        S.lowestDiamondPriceByShape[shapeKey] = Number(price);
        updateSettingFromPrices();
        updateBSB();
      }).catch(function(error) {
        console.warn('[JIR] Winter setting price could not be loaded:', error.message);
      });
    });
  }

  function syncWinterLandingSettingPrice(setting, completePrice) {
    if (!setting || !completePrice) return;
    qAll('[data-winter-product][data-product-id="' + String(setting.id) + '"]').forEach(function(card) {
      card.dataset.price = String(Math.round(Number(completePrice) * 100));
      var price = card.querySelector('[data-winter-product-price]');
      if (price) price.textContent = 'From ' + fmtPriceNum(completePrice);
    });
  }

  function preloadSettingCardPrices() {
    if (!S.settings.length) return;
    updateSettingFromPrices();
    renderSettings();
    updatePriceSliderBounds();
    if (S.setting) updateBSB();
    if (!CFG.proxyUrl) return;
    var cacheKey = getSettingPriceCacheKey();
    var cachedPrices = readSessionCache(cacheKey, SETTING_PRICE_CACHE_TTL_MS);
    var uniqueShapes = S.settings.reduce(function(acc, setting) {
      normaliseShapes(setting.shapes).forEach(function(shape) {
        if (acc.indexOf(shape) === -1) acc.push(shape);
      });
      return acc;
    }, []);
    qAll('[data-winter-product].winter-event__product--setting').forEach(function(card) {
      winterLandingShapes(card).forEach(function(shape) {
        if (uniqueShapes.indexOf(shape) === -1) uniqueShapes.push(shape);
      });
    });
    var cachedHasLivePrice = uniqueShapes.length && cachedPrices && typeof cachedPrices === 'object' && uniqueShapes.every(function(shape) {
      return Number(cachedPrices[shape] || 0) > 0;
    });
    if (cachedHasLivePrice) {
      S.lowestDiamondPriceByShape = Object.assign({}, cachedPrices);
      S.settingPriceStatus = 'ready';
      updateSettingFromPrices();
      renderSettings();
      updatePriceSliderBounds();
      if (S.setting) updateBSB();
      return;
    }

    if (cachedPrices && typeof cachedPrices === 'object') {
      S.lowestDiamondPriceByShape = Object.assign({}, cachedPrices);
      updateSettingFromPrices();
    }
    S.settingPriceStatus = 'loading';
    var token = ++S.settingPriceFetchToken;
    if (!uniqueShapes.length) {
      S.settingPriceStatus = 'ready';
      return;
    }
    var completed = 0;
    var hadSuccess = false;

    function applyPartialResult(shape, price) {
      S.lowestDiamondPriceByShape[shape] = Number(price || 0);
      if (Number(price || 0) > 0) writeSessionCache(cacheKey, S.lowestDiamondPriceByShape);
      updateSettingFromPrices();
      renderSettings();
      updatePriceSliderBounds();
      if (S.setting) updateBSB();
    }

    uniqueShapes.forEach(function(shape) {
      fetchRecommendedDiamondPriceForShape(shape)
        .then(function(price) {
          if (token !== S.settingPriceFetchToken) return;
          if (Number(price) > 0) hadSuccess = true;
          applyPartialResult(shape, price);
        })
        .catch(function(err) {
          if (token !== S.settingPriceFetchToken) return;
          console.error('[JIR] Setting from-price preload error for shape ' + shape + ':', err);
          applyPartialResult(shape, 0);
        })
        .finally(function() {
          if (token !== S.settingPriceFetchToken) return;
          completed += 1;
          if (completed >= uniqueShapes.length) {
            S.settingPriceStatus = hadSuccess ? 'ready' : 'error';
            renderSettings();
            if (S.setting) updateBSB();
          }
        });
    });
  }

  function normaliseShapeToken(value) {
    var v = String(value || '').trim().replace(/^\[/, '').replace(/\]$/, '').replace(/^["']+|["']+$/g, '').trim();
    if (!v) return '';
    var map = { round:'Round', oval:'Oval', pear:'Pear', cushion:'Cushion', emerald:'Emerald', asscher:'Asscher', marquise:'Marquise', princess:'Princess', radiant:'Radiant' };
    var low = v.toLowerCase();
    return map[low] || (low.charAt(0).toUpperCase() + low.slice(1));
  }

  function normaliseShapes(shapes) {
    if (Array.isArray(shapes)) {
      return shapes.reduce(function(acc, value) {
        if (typeof value === 'string' && value.trim().charAt(0) === '[') {
          try { return acc.concat(normaliseShapes(JSON.parse(value))); } catch (e) {}
        }
        return acc.concat(String(value || '').split(',').map(normaliseShapeToken).filter(Boolean));
      }, []).filter(function(v, i, arr) { return arr.indexOf(v) === i; });
    }
    if (typeof shapes === 'string') {
      var trimmed = shapes.trim();
      if (trimmed.charAt(0) === '[') { try { return normaliseShapes(JSON.parse(trimmed)); } catch (e) {} }
      return trimmed.split(',').map(normaliseShapeToken).filter(Boolean).filter(function(v, i, arr) { return arr.indexOf(v) === i; });
    }
    return [];
  }

  function normaliseAdminRules(rules) {
    return {
      caratMin:  Number(rules && rules.caratMin  || 0.5),
      caratMax:  Number(rules && rules.caratMax  || 3),
      colors:    cleanArray(rules && rules.colors    || ['D', 'E', 'F', 'G']),
      clarities: cleanArray(rules && rules.clarities || ['IF', 'VVS1', 'VVS2', 'VS1', 'VS2']),
      cuts:      cleanArray(rules && rules.cuts      || ['Excellent', 'Very Good']),
      fluors:    cleanArray(rules && rules.fluors    || ['None', 'Faint']),
      labs:      cleanArray(rules && rules.labs      || ['IGI', 'GIA']),
      requireMedia: !(rules && rules.requireMedia === false),
      pageSize:  Number(rules && rules.pageSize || 6),
      browseMorePageSize: Number(rules && rules.browseMorePageSize || 20)
    };
  }

  function currentPageIs(name) {
    var page = el('jir-pg-' + name);
    return !!(page && page.classList.contains('jir-on'));
  }

  function setText(id, txt) { var node = el(id); if (node) node.textContent = txt; }
  function setHtml(id, html) { var node = el(id); if (node) node.innerHTML = html || ''; }

  function showToast(msg) {
    var t = el('jir-toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('jir-show');
    clearTimeout(showToast._timer);
    showToast._timer = setTimeout(function() { t.classList.remove('jir-show'); }, 2600);
  }

  function setButtonResponse(button, message, duration) {
    if (!button) return;
    button.classList.add('jir-pressed');
    if (message) showToast(message);
    clearTimeout(button._jirResponseTimer);
    button._jirResponseTimer = setTimeout(function() {
      button.classList.remove('jir-pressed');
    }, duration || 900);
  }

  function clearRingSizeValidation() {
    var wrap = document.querySelector('.jir-size-select-wrap');
    if (wrap) wrap.classList.remove('jir-invalid');
  }

  function hasValidRingSizeSelection() {
    return !!(S.size && String(S.size).trim());
  }

  function validateRingSizeSelection() {
    var select = el('jir-size-select');
    var wrap = document.querySelector('.jir-size-select-wrap');
    if (hasValidRingSizeSelection()) {
      clearRingSizeValidation();
      return true;
    }
    if (wrap) wrap.classList.add('jir-invalid');
    showToast('Choose a ring size');
    if (select && typeof select.focus === 'function') select.focus();
    return false;
  }

  function goToDiamondsFromPdp() {
    if (!validateRingSizeSelection()) return;
    collectSidebarFilters();
    trackBuilderEvent('stone_filters_selected', {
      stone_type: 'lab_diamond',
      quality_preference: S.qualityPreference
    });
    trackBuilderEvent('byor_required_steps_completed', {
      setting_id: S.setting ? S.setting.id : '',
      stone_type: 'lab_diamond',
      shape: S.shape,
      size_range: S.sizeRange
    });
    goto('diamonds');
  }

  function ringSVG(sz) {
    sz = sz || 220;
    return '<svg width="' + sz + '" height="' + sz + '" viewBox="0 0 160 160" fill="none">' +
      '<circle cx="80" cy="92" r="42" stroke="#C9A96E" stroke-width="2.5"/>' +
      '<circle cx="80" cy="92" r="30" stroke="#C9A96E" stroke-width="1" opacity=".5"/>' +
      '<ellipse cx="80" cy="92" rx="42" ry="15" stroke="#C9A96E" stroke-width="1.5" opacity=".6"/>' +
      '<rect x="56" y="42" width="48" height="20" rx="3" stroke="#C9A96E" stroke-width="2"/>' +
      '<polygon points="80,18 93,30 89,44 71,44 67,30" fill="rgba(201,169,110,.2)" stroke="#C9A96E" stroke-width="1.8"/>' +
      '</svg>';
  }

  function ringPlaceholderMarkup(sz, className) {
    var src = imageCfg('placeholderSetting');
    return src ? themeImageMarkup(src, 'Setting placeholder', className || 'jir-theme-asset') : ringSVG(sz);
  }

  function diamondSVG(sz) {
    sz = sz || 200;
    return '<svg width="' + sz + '" height="' + sz + '" viewBox="0 0 200 200" fill="none">' +
      '<polygon points="100,20 162,68 162,132 100,180 38,132 38,68" fill="rgba(201,169,110,.06)" stroke="#C9A96E" stroke-width="1.8"/>' +
      '<polygon points="100,36 148,76 148,124 100,164 52,124 52,76" fill="rgba(201,169,110,.1)" stroke="#C9A96E" stroke-width="1.2"/>' +
      '<polygon points="100,52 134,80 134,120 100,148 66,120 66,80" fill="rgba(201,169,110,.14)" stroke="#C9A96E" stroke-width=".9"/>' +
      '<circle cx="100" cy="100" r="7" fill="rgba(201,169,110,.4)"/>' +
      '</svg>';
  }

  function diamondPlaceholderMarkup(sz, className) {
    var src = imageCfg('placeholderDiamond');
    return src ? themeImageMarkup(src, 'Diamond placeholder', className || 'jir-theme-asset') : diamondSVG(sz);
  }

  function miniRingSVG() {
    return '<svg width="28" height="28" viewBox="0 0 30 30" fill="none">' +
      '<circle cx="15" cy="18" r="7.5" stroke="#C9A96E" stroke-width="1.5"/>' +
      '<rect x="9" y="9" width="12" height="6" rx="1" stroke="#C9A96E" stroke-width="1.1"/>' +
      '<polygon points="15,3 19,7 17,11 13,11 11,7" fill="rgba(201,169,110,.2)" stroke="#C9A96E" stroke-width=".9"/>' +
      '</svg>';
  }

  function miniRingMarkup() {
    var src = imageCfg('placeholderSetting');
    return src ? themeImageMarkup(src, 'Setting thumbnail', 'jir-theme-asset') : miniRingSVG();
  }

  function shapeIconMarkup(shape, sizeClass) {
    var src = imageCfg(SHAPE_IMAGE_KEY_MAP[shape]);
    return src ? themeImageMarkup(src, shape + ' shape', sizeClass || 'jir-theme-asset') : (SHAPE_SVG[shape] || '');
  }

  function updatePhase(pg) {
    var active = ({ landing: 1, settings: 1, pdp: 1, diamonds: 2, dpdp: 2 }[pg]) || 1;
    [1, 2, 3].forEach(function(i) {
      var p = el('jir-ph' + i);
      if (!p) return;
      p.classList.remove('jir-active', 'jir-done');
      if (i < active) p.classList.add('jir-done');
      if (i === active) p.classList.add('jir-active');
    });
    if (el('jir-ph1s')) el('jir-ph1s').textContent = pg === 'pdp' ? 'Your setting' : 'Browse & configure';
    if (el('jir-ph2s')) el('jir-ph2s').textContent = pg === 'dpdp' ? 'Review stone' : (pg === 'diamonds' ? 'Browse & compare' : 'Browse stones');
  }

  /* ── initStickyCtaObserver ───────────────────────────────────────────────
   * WHY scroll event instead of IntersectionObserver:
   * IntersectionObserver fires immediately on obs.observe() with the current
   * intersection state. Because goto() calls window.scrollTo({ behavior:'smooth' })
   * before setting up the observer, the page may still be mid-scroll at a
   * position where the main CTA is off-screen — so the observer immediately
   * fires isIntersecting:false and shows the sticky bar on page load. Wrong.
   *
   * A scroll event listener only fires on actual USER scroll, not on the
   * programmatic smooth-scroll triggered by navigation. This matches the
   * stated behaviour exactly:
   *   • Page loads  → sticky hidden (no scroll event yet)
   *   • User scrolls past main CTA → scroll event fires → sticky shows
   *   • User scrolls back up, main CTA enters view → scroll event fires → sticky hides
   *
   * Returns an object with .disconnect() so the existing cleanup in goto()
   * works without any other changes.
   * ─────────────────────────────────────────────────────────────────────── */
  /* ── initStickyCtaObserver ───────────────────────────────────────────────
   * Correct implementation after full debug. Previous bugs:
   *
   * 1. Fixed 600ms delay was unreliable — smooth scroll speed ≈ 500px/s, so
   *    scrolling from 800px to section top at 80px takes ~1,440ms. The 600ms
   *    timer fired mid-scroll. onScroll() read getBoundingClientRect() at a
   *    wrong intermediate position, causing sticky to flash on or stay off
   *    incorrectly on initial load.
   *
   * 2. No cross-browser API tells us when smooth scroll ends. 'scrollend'
   *    event is not supported in Safari (major Shopify mobile browser).
   *
   * Solution — poll window.scrollY every 50ms until it stops changing:
   *   • Once stable (navigation scroll has settled), do the initial visibility
   *     check with getBoundingClientRect() at the correct resting position.
   *   • Then attach the scroll listener for real user scroll.
   *   • Works correctly for zero-distance scrolls (already at top), short
   *     scrolls, and long scrolls from deep in the page.
   *   • Applies equally to BOTH the setting PDP and diamond detail page
   *     since both use this same shared function.
   * ─────────────────────────────────────────────────────────────────────── */
  function initStickyCtaObserver(stickyId, watchSel, ownerPage) {
    var sticky = el(stickyId);
    var target = watchSel.charAt(0) === '#' ? el(watchSel.slice(1)) : q(watchSel);
    if (!sticky || !target) return null;

    /* Always start hidden on every page navigation */
    sticky.classList.remove('jir-show');

    var pollTimer = null;
    var disconnected = false;

    function checkVisibility() {
      if (disconnected || (ownerPage && S.currentPage !== ownerPage)) {
        sticky.classList.remove('jir-show');
        return;
      }
      var rect = target.getBoundingClientRect();
      /* Show sticky ONLY when the main CTA has been scrolled ABOVE the viewport
       * (user scrolled down past it). rect.bottom <= 0 means the element's
       * bottom edge has passed the top of the screen — it is fully above.
       *
       * Do NOT show when the main CTA is below the fold (not yet reached):
       * that would make the sticky appear on page load before the user has
       * scrolled at all, which is wrong.
       *
       * States:
       *   rect.bottom <= 0                      → above viewport (scrolled past) → show ✓
       *   rect.top < vh && rect.bottom > 0      → in viewport (visible)          → hide ✓
       *   rect.top >= vh                        → below fold (not yet reached)   → hide ✓
       */
      var scrolledPast = rect.bottom <= 0;
      sticky.classList.toggle('jir-show', scrolledPast);
    }

    /* Poll until window.scrollY stops changing — indicates navigation
     * smooth scroll has finished. Then do initial check + attach listener. */
    function waitForScrollEnd(callback) {
      var lastY = window.scrollY;
      pollTimer = setTimeout(function poll() {
        var currentY = window.scrollY;
        if (currentY === lastY) {
          /* Position stable — scroll has ended */
          callback();
        } else {
          lastY = currentY;
          pollTimer = setTimeout(poll, 50);
        }
      }, 50);
    }

    waitForScrollEnd(function() {
      if (disconnected || (ownerPage && S.currentPage !== ownerPage)) return;
      checkVisibility(); /* correct initial state at resting scroll position */
      window.addEventListener('scroll', checkVisibility, { passive: true });
    });

    return {
      disconnect: function() {
        disconnected = true;
        if (pollTimer) { clearTimeout(pollTimer); pollTimer = null; }
        window.removeEventListener('scroll', checkVisibility);
        sticky.classList.remove('jir-show');
      }
    };
  }

  function goto(pg) {
    S.currentPage = pg;
    document.documentElement.setAttribute('data-jir-page', pg);
    ['landing', 'settings', 'pdp', 'diamonds', 'dpdp'].forEach(function(name) {
      var page = el('jir-pg-' + name);
      if (page) page.classList.toggle('jir-on', name === pg);
    });
    updatePhase(pg);
    updateExternalStepSections(pg);
    scrollToCurrentPageTop(pg);

    /* ── Sticky CTA bars — scroll-event driven ──────────────────────────
     * When leaving a page: remove scroll listener, force-hide sticky bar.
     * When entering a page: attach scroll listener immediately (no rAF needed —
     * the listener only fires on user scroll, not on programmatic scrollTo).
     * CSS handles desktop (display:none !important on both bars at ≥901px).
     * ─────────────────────────────────────────────────────────────────── */
    if (pg !== 'pdp') {
      if (S._pdpObserver) { S._pdpObserver.disconnect(); S._pdpObserver = null; }
      var pdpBar = el('jir-pdp-sticky-cta');
      if (pdpBar) pdpBar.classList.remove('jir-show');
    }
    if (pg !== 'dpdp') {
      if (S._dpdpObserver) { S._dpdpObserver.disconnect(); S._dpdpObserver = null; }
      var dpdpBar = el('jir-dpdp-sticky-cta');
      if (dpdpBar) dpdpBar.classList.remove('jir-show');
    }
    if (pg === 'pdp') {
      S._pdpObserver = initStickyCtaObserver('jir-pdp-sticky-cta', '.jir-pdp-actions', 'pdp');
    }
    if (pg === 'dpdp') {
      var dpdpBar = el('jir-dpdp-sticky-cta');
      if (window.innerWidth <= 768) {
        if (dpdpBar) dpdpBar.classList.add('jir-show');
      } else {
        S._dpdpObserver = initStickyCtaObserver('jir-dpdp-sticky-cta', '#jir-add-btn', 'dpdp');
      }
    }
    if (pg === 'settings') {
      renderSettings();
      /* Re-run after layout is computed — the page was display:none at init
       * so scrollWidth/clientWidth were 0 and both buttons were disabled. */
      requestAnimationFrame(function() { if (_filterScrollUpdate) _filterScrollUpdate(); });
    }
    if (pg === 'diamonds') { updateSSB(); ensureDiamondResultsReady(); }
    saveAppSessionState();
  }

  function getScrollTopForPage(pg) {
    var page = el('jir-pg-' + pg);
    var root = el('jir-ring-builder');
    var phaseBar = document.querySelector('.jir-phase-bar');
    var docStyle = window.getComputedStyle(document.documentElement);
    var stickyHeaderOffset = parseFloat(docStyle.getPropertyValue('--menu-height-sticky')) || 0;
    var phaseBarOffset = phaseBar ? phaseBar.offsetHeight : 0;
    var target = page || root;
    if (!target) return 0;
    return Math.max(
      Math.round(target.getBoundingClientRect().top + window.scrollY - stickyHeaderOffset - phaseBarOffset),
      0
    );
  }

  function scrollToCurrentPageTop(pg) {
    window.scrollTo({
      top: getScrollTopForPage(pg),
      behavior: 'smooth'
    });
  }

  function updateExternalStepSections(pg) {
    document.querySelectorAll('[data-jir-visible-on]').forEach(function(node) {
      var visibleOn = String(node.getAttribute('data-jir-visible-on') || '').trim();
      var shouldShow = visibleOn === pg;
      node.classList.toggle('jidf-visible', shouldShow);
      node.hidden = !shouldShow;
    });
  }

  function cancelPendingRestore() {
    S.pendingRestore = null;
    S.pendingRestoreToken += 1;
  }

  function goBackToDiamonds() {
    cancelPendingRestore();
    goto('diamonds');
    if (S.setting && S.filteredDiamonds.length <= 1) {
      S.visibleDiamondCount = Math.min(CURATED_VISIBLE_MAX, Number(S.pageSize || CURATED_VISIBLE_MAX));
      scheduleDiamondFetch(true);
      return;
    }
    if (S.filteredDiamonds.length > 1) {
      S.visibleDiamondCount = Math.max(
        Number(S.visibleDiamondCount || 0),
        Math.min(CURATED_VISIBLE_MAX, Number(S.pageSize || CURATED_VISIBLE_MAX))
      );
      renderDiamondGrid(getVisibleDiamonds());
    }
  }

  function startBuilding() {
    trackBuilderEvent('builder_start', { source_page: window.location.pathname });
    goto('settings');
  }

  function backFromSettingPdp() {
    if (WINTER_CONTEXT.active) {
      try {
        window.sessionStorage.removeItem(WINTER_CONTEXT_KEY);
      } catch (e) {}
      window.location.assign(WINTER_CONTEXT.returnUrl);
      return;
    }
    goto('settings');
  }

  function editSetting() {
    if (!WINTER_CONTEXT.active) {
      goto('pdp');
      return;
    }

    var setting = S.setting;
    var handle = String(setting && setting.handle || WINTER_CONTEXT.settingHandle || '').trim();
    if (!handle && !WINTER_CONTEXT.settingDetailUrl) {
      window.location.assign(WINTER_CONTEXT.returnUrl);
      return;
    }

    var url;
    try {
      url = new URL(WINTER_CONTEXT.settingDetailUrl || '/products/' + encodeURIComponent(handle), window.location.origin);
      if (url.origin !== window.location.origin || url.pathname.indexOf('/products/') !== 0) {
        throw new Error('Invalid Winter setting URL');
      }
    } catch (e) {
      if (!handle) {
        window.location.assign(WINTER_CONTEXT.returnUrl);
        return;
      }
      url = new URL('/products/' + encodeURIComponent(handle), window.location.origin);
    }
    url.searchParams.set('view', 'winter-sale-setting');
    url.searchParams.set('winter_event', '1');
    url.searchParams.set('winter_edit', '1');
    url.searchParams.set('settingId', String(setting && setting.id || WINTER_CONTEXT.settingId || ''));
    url.searchParams.set('settingVariantId', String(S.metalVariantId || WINTER_CONTEXT.settingVariantId || ''));
    url.searchParams.set('settingHandle', handle);
    url.searchParams.set('settingShape', S.shape || WINTER_CONTEXT.settingShape || '');
    url.searchParams.set('return_to', WINTER_CONTEXT.returnUrl);

    var recommendedDiamondPriceCents = getCachedRecommendedDiamondPriceForShape(setting, S.shape) || WINTER_CONTEXT.recommendedDiamondPriceCents;
    if (recommendedDiamondPriceCents > 0) {
      url.searchParams.set('recommendedDiamondPriceCents', String(recommendedDiamondPriceCents));
    }

    window.location.assign(url.pathname + url.search);
  }

  function goToSettingStep() {
    if (WINTER_CONTEXT.active) {
      editSetting();
      return;
    }
    goto('landing');
  }

  function inferWinterSettingShapes(product) {
    var title = String(product && product.title || '').toLowerCase();
    var supported = ['Round', 'Oval', 'Pear', 'Cushion', 'Emerald', 'Marquise', 'Princess', 'Radiant'];
    var matches = supported.filter(function(shape) {
      return title.indexOf(shape.toLowerCase()) !== -1;
    });
    return matches.length ? matches : ['Round'];
  }

  function mapWinterProductToSetting(product) {
    var variants = Array.isArray(product && product.variants) ? product.variants : [];
    var metals = variants.map(function(variant) {
      return variant.option1 || (variant.options && variant.options[0]) || '';
    }).filter(function(value, index, values) {
      return value && values.indexOf(value) === index;
    });
    return {
      id: product.id,
      handle: product.handle || WINTER_CONTEXT.settingHandle,
      name: product.title || 'Winter Sale Setting',
      collection: product.vendor || 'Winter Sale',
      style: 'Setting',
      shapes: inferWinterSettingShapes(product),
      leadTime: getDefaultLeadTime(),
      badge: 'Winter Sale',
      basePrice: Math.round(Number(product.price || 0) / 100),
      recommendedDiamondPriceCents: WINTER_CONTEXT.recommendedDiamondPriceCents,
      recommendedDiamondPriceCentsByShape: null,
      image: product.featured_image || (product.images && product.images[0]) || null,
      images: Array.isArray(product.images) ? product.images.slice(0, 4) : [],
      accordion1Title: 'Setting details',
      accordion1Body: product.description || '',
      accordion2Title: 'Shipping & delivery',
      accordion2Body: '',
      accordion3Title: 'Care & warranty',
      accordion3Body: '',
      metals: metals,
      variants: variants.map(function(variant) {
        return {
          id: variant.id,
          title: variant.title || '',
          option1: variant.option1 || (variant.options && variant.options[0]) || '',
          option2: variant.option2 || (variant.options && variant.options[1]) || '',
          price: Math.round(Number(variant.price || 0) / 100),
          available: variant.available !== false
        };
      })
    };
  }

  function selectWinterContextSetting(setting) {
    var variant = Array.isArray(setting.variants)
      ? setting.variants.find(function(item) {
          return String(item.id) === String(WINTER_CONTEXT.settingVariantId);
        })
      : null;
    selectSetting(setting.id, {
      preserveState: true,
      metal: variant && variant.option1 ? variant.option1 : null,
      shape: WINTER_CONTEXT.settingShape || null,
      size: variant && variant.option2 ? variant.option2 : null,
      restorePage: WINTER_CONTEXT.nextStep
    });
  }

  function importWinterSetting() {
    if (!WINTER_CONTEXT.settingHandle) return Promise.resolve(null);
    function fetchProduct(attempt) {
      return fetch('/products/' + encodeURIComponent(WINTER_CONTEXT.settingHandle) + '.js', {
        cache: 'no-store',
        headers: { 'Cache-Control': 'no-cache', 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function(response) {
        if (!response.ok) throw new Error('Winter setting product could not be loaded');
        return response.json();
      }).catch(function(error) {
        if (attempt >= 3) throw error;
        return new Promise(function(resolve) {
          setTimeout(resolve, attempt * 250);
        }).then(function() {
          return fetchProduct(attempt + 1);
        });
      });
    }

    return fetchProduct(1).then(function(product) {
      var setting = mapWinterProductToSetting(product);
      S.settings.push(setting);
      selectWinterContextSetting(setting);
      applyWinterEventChrome();
      preloadImportedWinterSettingPrice(setting);
      return setting;
    }).catch(function(error) {
      console.warn('[JIR] ' + error.message);
      window.location.assign(WINTER_CONTEXT.returnUrl);
      return null;
    });
  }

  function applyWinterEventChrome() {
    if (!WINTER_CONTEXT.active) return;
    document.documentElement.classList.add('jir-winter-entry');
    var root = el('jir-ring-builder');
    if (root) root.classList.add('jir-winter-event-mode');
    setText('jir-pdp-back-label', WINTER_CONTEXT.returnLabel);
    var back = el('jir-pdp-back');
    if (back) back.setAttribute('aria-label', WINTER_CONTEXT.returnLabel);
  }

  function initWinterEventEntry() {
    if (!WINTER_CONTEXT.active) return false;
    applyWinterEventChrome();
    if (window.JIRContinueShoppingMemory && typeof window.JIRContinueShoppingMemory.setUrl === 'function') {
      window.JIRContinueShoppingMemory.setUrl(WINTER_CONTEXT.returnUrl);
    }

    var setting = S.settings.find(function(item) {
      return String(item.id) === String(WINTER_CONTEXT.settingId);
    });
    if (!setting) {
      importWinterSetting();
      return true;
    }

    selectWinterContextSetting(setting);
    applyWinterEventChrome();
    return true;
  }

  function getAppSessionState() {
    try {
      if (!window.sessionStorage) return null;
      var raw = window.sessionStorage.getItem(APP_STATE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return null;
      return parsed;
    } catch (e) {
      return null;
    }
  }

  function saveAppSessionState() {
    try {
      if (!window.sessionStorage) return;
      var payload = {
        page: S.currentPage || 'landing',
        settingId: S.setting ? S.setting.id : null,
        metal: S.metal || null,
        shape: S.shape || null,
        size: S.size || null,
        profile: S.profile || 'Standard',
        sizeRange: S.sizeRange || getConfiguredDefaultSizeRange(),
        qualityPreference: S.qualityPreference || getConfiguredDefaultQualityPreference(),
        decisionMode: S.decisionMode || 'exact',
        diamondId: S.diamond
          ? (S.diamond.diamondId || S.diamond.nivodaId || null)
          : (S.lastSelectedDiamondId || null),
        savedAt: Date.now()
      };
      window.sessionStorage.setItem(APP_STATE_KEY, JSON.stringify(payload));
    } catch (e) {}
  }

  function revealRestoredBuilder() {
    document.documentElement.classList.remove('jir-restore-booting');
    var root = el('jir-ring-builder');
    if (root) root.classList.add('jir-ready');
  }

  function restoreAppSessionState() {
    var state = getAppSessionState();
    if (!state || !state.page) return false;
    var page = String(state.page || 'landing');
    if (['landing', 'settings', 'pdp', 'diamonds', 'dpdp'].indexOf(page) === -1) return false;
    if (page === 'landing') return false;
    if (page === 'settings') {
      goto('settings');
      return true;
    }
    if (!state.settingId) return false;
    var setting = S.settings.find(function(s) { return String(s.id) === String(state.settingId); });
    if (!setting) return false;
    S.sizeRange = SIZE_RANGES[state.sizeRange] ? state.sizeRange : getConfiguredDefaultSizeRange();
    S.qualityPreference = ['balanced', 'brightest', 'largest'].indexOf(state.qualityPreference) > -1
      ? state.qualityPreference
      : getConfiguredDefaultQualityPreference();
    S.decisionMode = state.decisionMode === 'team' ? 'team' : 'exact';
    S.lastSelectedDiamondId = state.diamondId || null;
    initDiamondRuleUI();
    collectSidebarFilters();
    renderDiamondMobileChips();

    if (page === 'dpdp' && state.diamondId) {
      var restoreToken = S.pendingRestoreToken + 1;
      S.pendingRestore = {
        settingId: state.settingId,
        metal: state.metal || null,
        shape: state.shape || null,
        size: state.size || null,
        profile: state.profile || 'Standard',
        diamondId: state.diamondId || null
      };
      S.pendingRestoreToken = restoreToken;
    }

    selectSetting(state.settingId, {
      preserveState: true,
      metal: state.metal,
      shape: state.shape,
      size: state.size,
      profile: state.profile,
      diamondId: state.diamondId,
      restorePage: page
    });

    return true;
  }

  function renderSettings() {
    var grid = el('jir-settings-grid');
    if (!grid) return;
    var filtered = S.settings.filter(function(s) {
      var shapeList = normaliseShapes(s.shapes);
      if (S.settingFilters.shape !== 'All' && shapeList.indexOf(S.settingFilters.shape) === -1) return false;
      if (S.settingFilters.style !== 'All' && s.style !== S.settingFilters.style) return false;
      if (S.settingFilters.col   !== 'All' && s.collection !== S.settingFilters.col) return false;
      return true;
    });
    if (S.settingSort === 'price-asc' || S.settingSort === 'price-desc') {
      filtered = filtered.slice().sort(function(a, b) {
        var priceA = getSettingFromPrice(a);
        var priceB = getSettingFromPrice(b);
        if (priceA == null && priceB == null) return String(a.name || '').localeCompare(String(b.name || ''));
        if (priceA == null) return 1;
        if (priceB == null) return -1;
        if (priceA === priceB) return String(a.name || '').localeCompare(String(b.name || ''));
        return S.settingSort === 'price-desc' ? priceB - priceA : priceA - priceB;
      });
    }
    if (!filtered.length) {
      grid.innerHTML = '<div style="grid-column:1/-1;padding:60px;text-align:center;font-family:var(--jir-sf);font-size:20px;color:var(--jir-ins)">No settings match your filters</div>';
      return;
    }
    grid.innerHTML = filtered.map(function(s) {
      var combinedFromPrice = getSettingFromPrice(s);
      var imgHtml = s.image
        ? '<img src="' + escapeHtml(s.image) + '" alt="' + escapeHtml(s.name) + '" loading="lazy" style="width:100%;height:100%;object-fit:cover;position:absolute;inset:0;">'
        : ringPlaceholderMarkup(200, 'jir-theme-asset');
      var shapePips = normaliseShapes(s.shapes).map(function(sh) {
        return '<div class="jir-sc-shape"><div style="width:18px;height:18px;color:var(--jir-ins)">' + shapeIconMarkup(sh, 'jir-theme-asset') + '</div><span class="jir-sc-shape-lbl">' + escapeHtml(sh) + '</span></div>';
      }).join('');
      return '' +
        '<div class="jir-sc" data-setting-id="' + escapeHtml(String(s.id)) + '" tabindex="0" role="button" aria-label="Select ' + escapeHtml(s.name) + '">' +
          '<div class="jir-sc-vis-wrap"><div class="jir-sc-vis">' +
            imgHtml +
            (s.badge ? '<div class="jir-sc-badge">' + escapeHtml(s.badge) + '</div>' : '') +
          '</div></div>' +
          '<div class="jir-sc-body">' +
            '<div class="jir-sc-shapes">' + shapePips + '</div>' +
            '<div class="jir-sc-name">' + escapeHtml(s.name) + '</div>' +
            '<div class="jir-sc-studio-row"><span class="jir-sc-studio-txt">Melbourne Handcrafted</span></div>' +
            '<div class="jir-sc-price-row"><span class="jir-sc-from">From</span><span class="jir-sc-price">' + (combinedFromPrice != null ? fmtPriceNum(combinedFromPrice) : '—') + '</span></div>' +
            '<div class="jir-sc-price-note">' + (combinedFromPrice != null ? recommendedPriceNote() : (livePricePending() ? 'Loading recommended complete ring pricing' : unavailablePriceNote())) + '</div>' +
            '<button class="jir-sc-cta" type="button">Choose This Setting</button>' +
          '</div>' +
        '</div>';
    }).join('');
    qAll('.jir-sc').forEach(function(card) {
      card.addEventListener('click', function() { selectSetting(this.dataset.settingId); });
      card.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectSetting(this.dataset.settingId); }
      });
    });
  }

  function renderPDPImages(s) {
    var main   = el('jir-pdp-main');
    var thumbs = el('jir-pdp-thumbs');
    if (!main) return;
    if (s.images && s.images.length) {
      main.innerHTML = '<img class="jir-pdp-main-img" src="' + s.images[0] + '" alt="' + escapeHtml(s.name || '') + '">';
    } else {
      main.innerHTML = '<div class="jir-pdp-main-placeholder">' + ringPlaceholderMarkup(460, 'jir-theme-asset') + '</div>';
    }
    if (thumbs) {
      if (s.images && s.images.length > 1) {
        thumbs.innerHTML = s.images.slice(0, 4).map(function(img, i) {
          return '<div class="jir-pdp-th' + (i === 0 ? ' jir-on' : '') + '" data-img="' + img + '"><img src="' + img + '" alt="View ' + (i + 1) + '"></div>';
        }).join('');
        thumbs.querySelectorAll('.jir-pdp-th').forEach(function(th) {
          th.addEventListener('click', function() {
            thumbs.querySelectorAll('.jir-pdp-th').forEach(function(t) { t.classList.remove('jir-on'); });
            this.classList.add('jir-on');
            main.innerHTML = '<img class="jir-pdp-main-img" src="' + this.dataset.img + '" alt="">';
          });
        });
      } else { thumbs.innerHTML = ''; }
    }
  }

  function renderPDPAccordions(s) {
    if (!s) return;
    setText('jir-acc1-title', s.accordion1Title || textCfg('acc1Title', 'Setting details'));
    setText('jir-acc2-title', s.accordion2Title || textCfg('acc2Title', 'Shipping & delivery'));
    setText('jir-acc3-title', s.accordion3Title || textCfg('acc3Title', 'Care & warranty'));
    setHtml('jir-acc1-body', s.accordion1Body || '<p>' + escapeHtml(textCfg('acc1Body', 'Handcrafted in our Melbourne studio using recycled precious metals. Each setting is made to order — allow 4–6 weeks from order confirmation.')) + '</p>');
    setHtml('jir-acc2-body', s.accordion2Body || '<p>' + escapeHtml(textCfg('acc2Body', 'Free express shipping Australia-wide. International shipping calculated at checkout.')) + '</p>');
    setHtml('jir-acc3-body', s.accordion3Body || '<p>' + escapeHtml(textCfg('acc3Body', "Lifetime resize guarantee. 2-year manufacturer's warranty. Complimentary first professional clean included.")) + '</p>');
  }

  function renderPDPMetals(s) {
    var wrap = el('jir-metal-pills');
    if (!wrap || !Array.isArray(s.metals) || !s.metals.length) return;
    wrap.innerHTML = s.metals.map(function(m) {
      var price = getSettingPriceForMetal(s, m, S.size);
      return '<div class="jir-metal-pill' + (m === S.metal ? ' jir-on' : '') + '" data-metal="' + escapeHtml(m) + '" data-price="' + price + '">' +
        '<div class="jir-metal-dot" style="background:' + getMetalSwatchColor(m) + '"></div>' + escapeHtml(m) + '</div>';
    }).join('');
    S.metalP = getSettingPriceForMetal(s, S.metal, S.size);
    setText('jir-metal-sel', S.metal);
    setText('jir-bsb-m', S.metal);
    wrap.querySelectorAll('.jir-metal-pill').forEach(function(pill) {
      pill.addEventListener('click', function() {
        wrap.querySelectorAll('.jir-metal-pill').forEach(function(p) { p.classList.remove('jir-on'); });
        this.classList.add('jir-on');
        S.metal  = this.dataset.metal;
        setText('jir-metal-sel', S.metal);
        setText('jir-bsb-m', S.metal);
        syncSizeSelect();
        updateMetalVariant();
        updateBSB();
        updateSSB();
        saveAppSessionState();
        if (currentPageIs('diamonds') || currentPageIs('dpdp')) scheduleDiamondFetch(true);
      });
    });
  }

  function renderPDPShapes(s) {
    var wrap      = el('jir-pdp-shape-pills');
    var shapeList = normaliseShapes(s.shapes);
    if (!wrap || !shapeList.length) return;
    var shape = shapeList.indexOf(S.shape) > -1 ? S.shape : shapeList[0];
    S.shape = shape;
    wrap.innerHTML = '<div class="jir-spill jir-on" data-shape="' + escapeHtml(shape) + '">' +
      '<div style="width:20px;height:20px">' + shapeIconMarkup(shape, 'jir-theme-asset') + '</div>' +
      '<span class="jir-sp-nm">' + escapeHtml(shape) + '</span>' +
    '</div>';
    setText('jir-shape-sel', shape);
    setText('jir-bsb-sh', shape);
  }

  function getMetalSwatchColor(metal) {
    var name = String(metal || '').toLowerCase();
    if (name.indexOf('white') !== -1) return '#E0E0E0';
    if (name.indexOf('rose') !== -1) return '#DBA89A';
    if (name.indexOf('platinum') !== -1) return '#C8C8CC';
    return '#E8C96A';
  }

  function getVariantsForMetal(setting, metal, size, opts) {
    opts = opts || {};
    if (!setting || !Array.isArray(setting.variants)) return [];
    var nm = String(metal || '').trim().toLowerCase();
    var ns = String(size || '').trim().toLowerCase();
    return setting.variants.filter(function(v) {
      if (!v) return false;
      if (!opts.includeUnavailable && v.available === false) return false;
      if (String(v.option1 || '').trim().toLowerCase() !== nm) return false;
      return !ns || String(v.option2 || '').trim().toLowerCase() === ns;
    });
  }

  function getSettingPriceForMetal(setting, metal, size) {
    var variants = getVariantsForMetal(setting, metal, size, { includeUnavailable: true });
    if (!variants.length && size) variants = getVariantsForMetal(setting, metal, null, { includeUnavailable: true });
    if (variants.length) {
      return variants.reduce(function(min, variant) {
        var price = Number(variant.price || 0);
        if (!min) return price;
        return price > 0 ? Math.min(min, price) : min;
      }, 0) || Number(setting.basePrice || 0);
    }
    return Number(setting && setting.basePrice || 0);
  }

  function getSelectedSettingPrice(setting) {
    if (setting && S.setting && String(setting.id) === String(S.setting.id)) {
      return getSettingPriceForMetal(setting, S.metal, S.size);
    }
    return Number(setting && setting.basePrice || 0);
  }

  function updateMetalVariant() {
    if (!S.setting || !Array.isArray(S.setting.variants) || !S.setting.variants.length) {
      S.metalVariantId = null;
      S.metalP = Number(S.setting && S.setting.basePrice || 0);
      return;
    }
    var nm = String(S.metal || '').trim().toLowerCase();
    var ns = String(S.size  || '').trim().toLowerCase();
    var exact = S.setting.variants.find(function(v) { return v.available !== false && String(v.option1||'').trim().toLowerCase()===nm && (!ns||String(v.option2||'').trim().toLowerCase()===ns); });
    var mOnly = S.setting.variants.find(function(v) { return v.available !== false && String(v.option1||'').trim().toLowerCase()===nm; });
    S.metalVariantId = exact ? exact.id : (mOnly ? mOnly.id : null);
    S.metalP = getSettingPriceForMetal(S.setting, S.metal, S.size);
  }

  function getAvailableSizesForCurrentSetting() {
    if (!S.setting || !Array.isArray(S.setting.variants) || !S.setting.variants.length) return [];
    var nm = String(S.metal || '').trim().toLowerCase();
    var sizes = S.setting.variants
      .filter(function(variant) {
        if (!variant || variant.available === false) return false;
        return String(variant.option1 || '').trim().toLowerCase() === nm;
      })
      .map(function(variant) { return String(variant.option2 || '').trim(); })
      .filter(Boolean);

    return sizes.filter(function(size, index, arr) {
      return arr.indexOf(size) === index;
    });
  }

  function syncSizeSelect() {
    var select = el('jir-size-select');
    var availableSizes = getAvailableSizesForCurrentSetting();
    if (!select) return;
    if (S.size && availableSizes.indexOf(S.size) === -1) {
      S.size = null;
    }
    select.innerHTML =
      '<option value="">' + escapeHtml(availableSizes.length ? 'Select size' : 'Size unavailable') + '</option>' +
      availableSizes.map(function(size) {
        return '<option value="' + escapeHtml(size) + '"' + (S.size === size ? ' selected' : '') + '>' + escapeHtml(size) + '</option>';
      }).join('');
    select.disabled = !availableSizes.length;
    select.value = S.size || '';
    setText('jir-size-sel', S.size || 'Select size');
    setText('jir-bsb-sz', S.size || 'To be confirmed');
  }

  function updateBSB() {
    if (!S.setting) return;
    setText('jir-bsb-s',  S.setting.name || '');
    setText('jir-bsb-m',  S.metal);
    setText('jir-bsb-sh', S.shape);
    setText('jir-bsb-sz', S.size || 'To be confirmed');
    setText('jir-bsb-lead', getSettingLeadTime(S.setting));
    var fromPrice = getSelectedSettingFromPrice(S.setting);
    setText('jir-pdp-price-amt', fromPrice != null ? ('From ' + fmtPriceNum(fromPrice)) : (livePricePending() ? 'Loading live price…' : 'Price unavailable'));
    setText('jir-pdp-price-note', fromPrice != null ? recommendedPriceNote() : (livePricePending() ? 'Loading recommended complete ring pricing' : unavailablePriceNote()));
    setText('jir-bsb-amt', fromPrice != null ? fmtPriceNum(fromPrice) : '—');
    setText('jir-bsb-price-note', fromPrice != null ? recommendedPriceNote() : (livePricePending() ? 'Loading recommended complete ring pricing' : unavailablePriceNote()));
  }

  function updateSSB() {
    if (!S.setting) return;
    ['jir-ssb', 'jir-dpdp-ssb'].forEach(function(prefix) {
      var n = el(prefix + '-name');
      var m = el(prefix + '-meta');
      var t = el(prefix + '-thumb');
      if (n) n.textContent = S.setting.name + ' \u00b7 ' + S.metal;
      if (m) m.textContent = S.shape + (S.size ? ' \u00b7 Size ' + S.size : '');
      if (t) t.innerHTML = S.setting.image ? '<img src="' + escapeHtml(S.setting.image) + '" alt="" style="width:100%;height:100%;object-fit:cover;">' : miniRingMarkup();
    });
  }

  function renderDiamondDetailRestoreState(hasCachedDiamond) {
    if (hasCachedDiamond) return;
    setText('jir-d-eye', 'Restoring your saved diamond');
    setText('jir-d-title', 'Loading diamond details…');
    renderCertificateLabIcon('');
    setText('jir-cert-lab', 'Certificate');
    setText('jir-cert-no', 'Certificate #—');
    updateCertificatePdfLink(null);
    setText('jir-ph-price', '—');
    setText('jir-ph-includes', 'Restoring your saved setting and centre diamond');
    setText('jir-ph-setting-price', '—');
    setText('jir-ph-diamond-price', '—');
    setText('jir-ph-total-price', '—');
    setText('jir-ph-finance', 'Flexible payment options available at checkout');
    setText('jir-dpdp-sticky-summary', 'Restoring your diamond');
    setText('jir-dpdp-sticky-price', '—');
    var fourC = el('jir-fourC-grid');
    if (fourC) fourC.innerHTML = '';
    var guideTabs = el('jir-gdg-tabs');
    if (guideTabs) guideTabs.innerHTML = '';
    var guidePanel = el('jir-gdg-panel');
    if (guidePanel) guidePanel.innerHTML = '<div class="jir-gdg-copy">We are restoring the exact diamond from your saved build.</div>';
    var guideContent = el('jir-gdg-content');
    if (guideContent) guideContent.hidden = false;
    var guideToggle = el('jir-gdg-toggle');
    if (guideToggle) guideToggle.removeAttribute('aria-expanded');
    var specGrid = el('jir-spec-grid');
    if (specGrid) specGrid.innerHTML = '';
    var mediaMain = el('jir-dpdp-media-main');
    if (mediaMain) mediaMain.innerHTML = '<div class="jir-d-loading"><div class="jir-d-loading-spinner"></div><span class="jir-micro" style="color:var(--jir-ins)">Loading diamond media…</span></div>';
    var addBtn = el('jir-add-btn');
    if (addBtn) addBtn.disabled = true;
    var stickyAddBtn = el('jir-dpdp-sticky-add');
    if (stickyAddBtn) stickyAddBtn.disabled = true;
    updateAddToCartCtas(null);
  }

  function selectSetting(id, opts) {
    opts = opts || {};
    var s = S.settings.find(function(item) { return String(item.id) === String(id); });
    if (!s) return;
    if (!opts.preserveState) clearBuildFromURL();
    var shapeList   = normaliseShapes(s.shapes);
    var singleShape = shapeList[0] || 'Round';
    S.setting  = s;
    S.diamond  = null;
    S.lastSelectedDiamondId = opts.preserveState ? (opts.diamondId || S.lastSelectedDiamondId || null) : null;
    S.dIdx     = 0;
    S.allFetchedDiamonds = [];
    S.diamonds           = [];
    S.filteredDiamonds   = [];
    S.lastDiamondFetchKey = '';
    S.offset     = 0;
    S.totalCount = 0;
    S.hasMore    = false;
    S.visibleDiamondCount = 0;
    S.allPagesLoaded = false;
    S.countingTotal = false;
    S.browseMoreOpened = false;
    S.advancedFiltersOpened = false;
    S.selectedTier = 'recommended';
    S.metal   = (opts.preserveState && opts.metal && s.metals.indexOf(opts.metal) > -1) ? opts.metal : (s.metals && s.metals.length ? s.metals[0] : '18k Yellow Gold');
    S.shape   = (opts.preserveState && opts.shape && shapeList.indexOf(opts.shape) > -1) ? opts.shape : singleShape;
    S.size    = opts.preserveState ? (opts.size || null) : null;
    S.profile = opts.preserveState ? (opts.profile || 'Standard') : 'Standard';
    S.metalP  = getSettingPriceForMetal(s, S.metal, S.size);
    setText('jir-pdp-title',  s.name || '');
    setText('jir-pdp-compat', 'Compatible: ' + singleShape);
    setText('jir-pdp-lead',   'Ready in ' + getSettingLeadTime(s));
    renderPDPImages(s);
    renderPDPAccordions(s);
    renderPDPMetals(s);
    renderPDPShapes(s);
    syncSizeSelect();
    updateMetalVariant();
    updateBSB();
    updateSSB();
    trackBuilderEvent('setting_selected', {
      setting_id: S.setting.id,
      style: S.setting.style,
      metal: S.metal
    });
    var restorePage = ['pdp', 'diamonds', 'dpdp'].indexOf(opts.restorePage) > -1 ? opts.restorePage : '';
    var isDirectDiamondRestore = !!(opts.preserveState && restorePage === 'dpdp' && S.pendingRestore && S.pendingRestore.diamondId);
    if (isDirectDiamondRestore) {
      var cachedDiamond = readBuildSnapshot({
        settingId: S.pendingRestore.settingId,
        diamondId: S.pendingRestore.diamondId
      });
      renderDiamondDetailRestoreState(!!cachedDiamond);
      goto('dpdp');
      scheduleDiamondFetch(true, { silent: true });
    } else if (restorePage === 'diamonds') {
      goto('diamonds');
    } else {
      goto('pdp');
    }
  }

  function initPDPSizeSelector() {
    var select = el('jir-size-select');
    if (!select) return;
    select.addEventListener('change', function() {
      S.size = this.value || null;
      clearRingSizeValidation();
      syncSizeSelect();
      updateMetalVariant();
      updateBSB();
      updateSSB();
      saveAppSessionState();
    });
  }

  function collectSidebarFilters() {
    var colors = [], clarities = [], cuts = [], fluors = [], labs = [], polishes = [];
    document.querySelectorAll('[data-filter-group="colour"] input:checked').forEach(function(n) { colors.push(n.value); });
    document.querySelectorAll('[data-filter-group="clarity"] input:checked').forEach(function(n) { clarities.push(n.value); });
    document.querySelectorAll('[data-filter-group="cut"] input:checked').forEach(function(n) { cuts.push(n.value); });
    document.querySelectorAll('[data-filter-group="fluor"] input:checked').forEach(function(n) { fluors.push(n.value); });
    document.querySelectorAll('[data-filter-group="lab"] input:checked').forEach(function(n) { labs.push(n.value); });
    document.querySelectorAll('[data-filter-group="polish"] input:checked').forEach(function(n) { polishes.push(n.value); });
    var range = SIZE_RANGES[S.sizeRange] || SIZE_RANGES.classic;
    S.customerFilters.caratMin = Math.max(Number(S.adminRules.caratMin || 0), Number(range.min || 0));
    S.customerFilters.caratMax = Math.min(Number(S.adminRules.caratMax || range.max), Number(range.max || S.adminRules.caratMax));
    S.customerFilters.qualityPreference = S.qualityPreference || 'balanced';
    S.customerFilters.colors    = colors.length    ? colors    : S.adminRules.colors.slice();
    S.customerFilters.clarities = clarities.length ? clarities : S.adminRules.clarities.slice();
    S.customerFilters.cuts      = cuts.length      ? cuts      : S.adminRules.cuts.slice();
    S.customerFilters.fluors    = fluors.length    ? fluors    : S.adminRules.fluors.slice();
    S.customerFilters.labs      = labs.length      ? labs      : S.adminRules.labs.slice();
    S.customerFilters.polish    = polishes;
  }

  function getEffectiveDiamondFilters() {
    return {
      carat_min: Math.max(Number(S.adminRules.caratMin || 0), Number(S.customerFilters.caratMin || S.adminRules.caratMin)),
      carat_max: Math.min(Number(S.adminRules.caratMax || 99), Number(S.customerFilters.caratMax || S.adminRules.caratMax)),
      colours:   S.customerFilters.colors.slice(),
      clarities: S.customerFilters.clarities.slice(),
      cuts:      S.customerFilters.cuts.slice(),
      fluors:    S.customerFilters.fluors.slice(),
      labs:      S.customerFilters.labs.slice()
    };
  }

  function narrowGradesToThreshold(allowed, order, threshold) {
    var configured = String(threshold || 'no_limit').trim().toUpperCase();
    if (!configured || configured === 'NO_LIMIT') return cleanArray(allowed);
    var thresholdIndex = order.indexOf(configured);
    if (thresholdIndex === -1) return cleanArray(allowed);
    return cleanArray(allowed).filter(function(value) {
      var index = order.indexOf(String(value || '').trim().toUpperCase());
      return index > -1 && index <= thresholdIndex;
    });
  }

  function getRecommendedGradeRules() {
    var effective = getEffectiveDiamondFilters();
    var engine = (CFG.curatedSpecs && CFG.curatedSpecs.recommendationEngine) || {};
    return {
      colours: narrowGradesToThreshold(effective.colours, COLOUR_GRADE_ORDER, engine.lowestColour),
      clarities: narrowGradesToThreshold(effective.clarities, CLARITY_GRADE_ORDER, engine.minimumClarity),
      cuts: narrowGradesToThreshold(effective.cuts, CUT_GRADE_ORDER, engine.minimumCut)
    };
  }

  function isRecommendedGradeEligible(diamond) {
    var rules = getRecommendedGradeRules();
    if (!normalizedValueInList(diamond && diamond.color, rules.colours)) return false;
    if (!normalizedValueInList(diamond && diamond.clarity, rules.clarities)) return false;
    if (isRoundShape(diamond && diamond.shape) && !normalizedValueInList(diamond && diamond.cut, rules.cuts)) return false;
    return true;
  }

  function isRecommendedOnlyResultScope() {
    return !S.browseMoreOpened && !S.advancedFiltersOpened;
  }

  function hasRecommendedGradePoolForShape(shape) {
    var rules = getRecommendedGradeRules();
    return !!(rules.colours.length && rules.clarities.length && (!isRoundShape(shape) || rules.cuts.length));
  }

  function diamondFetchKey() {
    return safeJsonStringify({
      settingId: S.setting ? S.setting.id : null,
      metal: S.metal, shape: S.shape,
      sizeRange: S.sizeRange,
      qualityPreference: S.qualityPreference,
      resultScope: isRecommendedOnlyResultScope() ? 'recommended' : 'layer_1',
      recommendationPriority: getRecommendationPriority(S.qualityPreference || 'balanced').join('_'),
      candidateLimit: getCuratedFetchLimit(),
      recommendedGradeRules: getRecommendedGradeRules(),
      requireMedia: S.adminRules ? S.adminRules.requireMedia : true,
      effectiveFilters: getEffectiveDiamondFilters()
    });
  }

  function getCuratedFetchLimit() {
    var baseLimit = Math.max(getRecommendedLimit(), Math.min(30, Number(S.browseMorePageSize || 20)));
    /* Nivoda's proven API order is price ascending. Quality-first and size-first
     * therefore need a wider candidate pool before client-side ranking, or they
     * merely reorder the same small group of cheapest stones. */
    if (isRecommendedOnlyResultScope() && S.qualityPreference !== 'balanced') {
      return Math.max(baseLimit, CURATED_RANKING_POOL_MAX);
    }
    return baseLimit;
  }

  function getRecommendedLimit() {
    return Math.max(3, Math.min(CURATED_VISIBLE_MAX, Number(S.pageSize || CURATED_VISIBLE_MAX)));
  }

  function getRecommendedCount() {
    var eligibleCount = S.filteredDiamonds.filter(isRecommendedGradeEligible).length;
    return Math.min(getRecommendedLimit(), eligibleCount);
  }

  function getConfiguredDefaultSizeRange() {
    var key = (CFG.curatedSpecs && CFG.curatedSpecs.defaultSizeRange) || 'classic';
    return SIZE_RANGES[key] ? key : 'classic';
  }

  function getConfiguredDefaultQualityPreference() {
    var key = (CFG.curatedSpecs && CFG.curatedSpecs.defaultQualityPreference) || 'balanced';
    return ['balanced', 'brightest', 'largest'].indexOf(key) > -1 ? key : 'balanced';
  }

  function getQualityPreferenceOptions() {
    var configured = (CFG.curatedSpecs && CFG.curatedSpecs.qualityPreferences) || {};
    return [
      { value: 'balanced', label: (configured.balanced && configured.balanced.label) || 'Best value' },
      { value: 'brightest', label: (configured.brightest && configured.brightest.label) || 'Quality first' },
      { value: 'largest', label: (configured.largest && configured.largest.label) || 'Size first' }
    ];
  }

  function buildNivodaQuery() {
    /*
     * IMPORTANT: this query now reflects only theme-editor controls and the
     * visible frontend quality filters. The ring-price filter was removed from
     * both the UI and the client-side filtering path so total_count stays
     * aligned with the real matching Nivoda inventory.
     */
    var effective    = getEffectiveDiamondFilters();
    var queryGrades  = isRecommendedOnlyResultScope() ? getRecommendedGradeRules() : effective;
    var shapeCode    = SHAPE_CODE_MAP[S.shape] || String(S.shape).toUpperCase().trim();
    var cutCodes     = queryGrades.cuts.map(function(c) { return CUT_CODE_MAP[c] || 'EX'; });
    var fluorCodes   = effective.fluors.map(function(f) { return FLUOR_CODE_MAP[f] || 'NON'; });
    var supportsCutGrade = isRoundShape(S.shape);

    function gqlStr(v)      { return JSON.stringify(String(v)); }
    function gqlStrList(arr)  { return '[' + arr.map(gqlStr).join(', ') + ']'; }
    function gqlEnumList(arr) { return '[' + arr.map(function(v) { return String(v).trim(); }).join(', ') + ']'; }

    var queryLines = [
      'query DiamondSearch {',
      '  diamonds_by_query(',
      '    offset: ' + Number(S.offset || 0),
      '    limit: '  + getCuratedFetchLimit(),
      '    query: {',
      '      shapes: '           + gqlStrList([shapeCode]),
      '      labgrown: true',
      '      availability: AVAILABLE',
      /* has_v360:true removed — it limited Nivoda total_count to only 360°
       * diamonds, so if inventory had 50 with video, total_count=50 and
       * S.hasMore was always false. Diamonds without 360° show a static image. */
      '      color: '            + gqlEnumList(queryGrades.colours),
      '      clarity: '          + gqlEnumList(queryGrades.clarities),
      '      flouresence: '      + gqlEnumList(fluorCodes),
      '      certificate_lab: '  + gqlEnumList(effective.labs),
      '      sizes: { from: '    + Number(effective.carat_min) + ', to: ' + Number(effective.carat_max) + ' }',
      '      preferred_currency: AUD',
      '      search_on_preferred_currency: true',
      '    }',
      '    order: { type: price, direction: ASC }',
      '  ) {',
      '    items {',
      '      id price diamond_price markup_price',
      '      diamond {',
        '        id availability image video',
        '        certificate {',
      '          lab certNumber shape carats',
      '          clarity color cut polish symmetry',
      '          masked_pdf_url pdfUrl',
      '          length width depth depthPercentage table',
      '        }',
      '      }',
      '    }',
      '    total_count',
      '  }',
      '}'
    ];

    if (supportsCutGrade && cutCodes.length) {
      queryLines.splice(12, 0, '      cut: ' + gqlEnumList(cutCodes));
    }

    return queryLines.join('\n');
  }

  function renderDiamondLoading() {
    var grid = el('jir-d-grid');
    if (!grid) return;
    if (S.isAppending && S.filteredDiamonds.length) return;
    grid.innerHTML = '<div class="jir-d-loading"><div class="jir-d-loading-spinner"></div><span class="jir-micro" style="color:var(--jir-ins)">Searching approved diamonds\u2026</span></div>';
  }

  function renderDiamondError(msg) {
    var grid = el('jir-d-grid');
    if (!grid) return;
    grid.innerHTML = '<div class="jir-d-error"><div class="jir-d-error-title">' + escapeHtml(textCfg('diamondLoadErrorTitle', 'Unable to load diamonds')) + '</div><p class="jir-d-error-body">' + escapeHtml(msg) + '</p><button class="jir-btn-ghost" style="margin-top:16px" onclick="window.JIR.retryDiamonds()">Try Again</button></div>';
    renderDiamondResultsFooter();
  }

  function expandGrade(val) {
    var raw = String(val || '').trim();
    return GRADE_MAP[raw] || raw;
  }

  function mapCutGrade(code) {
    var expanded = expandGrade(code);
    return CUT_GRADE_MAP[expanded] || expanded || capitalise(code);
  }

  function capitalise(str) {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase().replace(/_/g, ' ');
  }

  function getMaskedCertificateNumber(certNo) {
    var raw = String(certNo || '').replace(/^#/, '').trim();
    if (!raw) return '#—';
    return '#' + raw.slice(0, 5) + raw.slice(5).replace(/./g, '*');
  }

  function updateCertificatePdfLink(diamond) {
    var link = el('jir-cert-pdf-link');
    if (!link) return;
    var href = diamond && diamond.certPdfUrl ? String(diamond.certPdfUrl) : '';
    var canAttemptFetch = !!(diamond && diamond.nivodaId);
    if (href) {
      link.setAttribute('href', href);
      link.setAttribute('target', '_self');
      link.setAttribute('rel', 'noopener');
      link.removeAttribute('aria-disabled');
      link.classList.remove('jir-disabled');
      link.style.pointerEvents = '';
      link.style.opacity = '';
    } else {
      link.setAttribute('href', '#');
      if (canAttemptFetch) {
        link.removeAttribute('aria-disabled');
        link.classList.remove('jir-disabled');
        link.style.pointerEvents = '';
        link.style.opacity = '';
      } else {
        link.setAttribute('aria-disabled', 'true');
        link.classList.add('jir-disabled');
        link.style.pointerEvents = 'none';
        link.style.opacity = '0.45';
      }
    }
  }

  function openCertificate() {
    if (!S.diamond) {
      showToast('Certificate is not available for this diamond.');
      return false;
    }
    if (!S.diamond.certPdfUrl && S.diamond.nivodaId) {
      showToast('Loading certificate…');
      fetchDiamondById(S.diamond.diamondId || S.diamond.nivodaId).then(function(diamond) {
        if (!diamond) {
          showToast('Certificate PDF is not available for this diamond.');
          return;
        }
        S.diamond = Object.assign({}, diamond, {
          offerId: S.diamond.offerId || diamond.offerId || '',
          diamondId: diamond.diamondId || S.diamond.diamondId || S.diamond.nivodaId || '',
          nivodaId: diamond.diamondId || S.diamond.diamondId || S.diamond.nivodaId || ''
        });
        updateCertificatePdfLink(S.diamond);
        if (!S.diamond.certPdfUrl) {
          showToast('Certificate PDF is not available for this diamond.');
          return;
        }
        openCertificate();
      });
      return false;
    }
    if (!S.diamond.certPdfUrl) {
      showToast('Certificate PDF is not available for this diamond.');
      return false;
    }
    var frame = el('jir-cert-frame');
    var fallback = el('jir-cert-open-tab');
    if (frame) frame.setAttribute('src', String(S.diamond.certPdfUrl));
    if (fallback) fallback.setAttribute('href', String(S.diamond.certPdfUrl));
    openOverlay('jir-cert-overlay');
    return false;
  }

  function closeCertificate() {
    var frame = el('jir-cert-frame');
    if (frame) frame.setAttribute('src', 'about:blank');
    closeOverlay('jir-cert-overlay');
  }

  /* ─── EXTRACT DIAMONDS ───────────────────────────────────────────────────
   * FIX: Store BOTH videoBase (plain URL, used for card hover-play) AND
   * videoUrl (URL + '/autoplay', used for the detail page autoplay iframe).
   * Both come from d.video; we just append '/autoplay' for the detail view.
   * ─────────────────────────────────────────────────────────────────────── */
  function mapDiamondItem(item) {
    var d    = item && item.diamond ? item.diamond : {};
    var cert = d.certificate || {};
    var videoBase = d.video ? String(d.video) : null;
    var videoUrl  = videoBase ? videoBase + '/autoplay' : null;
    var lengthMm = Number(cert.length || 0);
    var widthMm = Number(cert.width || 0);
    var depthMm = Number(cert.depth || 0);
    var measurementParts = [lengthMm, widthMm, depthMm].filter(function(value) {
      return Number.isFinite(value) && value > 0;
    });
    return {
      offerId:     item && item.id || '',
      diamondId:   d && d.id ? String(d.id) : '',
      nivodaId:    d && d.id ? String(d.id) : '',
      availability: d.availability || '',
      shape:       normaliseShapeToken(cert.shape || ''),
      carat:       Number(cert.carats || 0),
      color:       cert.color    || '',
      clarity:     cert.clarity  || '',
      cut:         mapCutGrade(cert.cut     || ''),
      polish:      mapCutGrade(cert.polish  || ''),
      symmetry:    mapCutGrade(cert.symmetry || ''),
      lengthMm:    lengthMm,
      widthMm:     widthMm,
      depthMm:     depthMm,
      measurements: measurementParts.length ? measurementParts.join(' × ') : '',
      lwRatio:     lengthMm > 0 && widthMm > 0 ? (lengthMm / widthMm) : 0,
      tablePct:    Number(cert.table || 0),
      depthPct:    Number(cert.depthPercentage || 0),
      fluorescence: '',
      lab:         cert.lab       || '',
      certNo:      cert.certNumber || '',
      certPdfUrl:  cert.masked_pdf_url || cert.pdfUrl || '',
      price:       getNivodaDisplayPrice(item),
      rawPrice:    Number(item && item.price || 0),
      markupPrice: Number(item && item.markup_price || 0),
      diamondPrice: Number(item && item.diamond_price || 0),
      imageUrl:    d.image  || null,
      videoBase:   videoBase,
      videoUrl:    videoUrl
    };
  }

  function extractDiamonds(data) {
    if (!data || !data.data || !data.data.diamonds_by_query) return [];
    var items = data.data.diamonds_by_query.items || [];
    return items.map(mapDiamondItem).sort(function(a, b) {
      return Number(a.price || 0) - Number(b.price || 0);
    });
    /* All quality-matching diamonds are returned. Those with videoBase get
     * 360° rotation; those without show a static poster image. */
  }

  function fetchDiamondById(diamondId) {
    if (!CFG.proxyUrl || !diamondId) return Promise.resolve(null);
    var detailQuery = [
      'query DiamondDetail {',
      '  get_diamond_by_id(',
      '    diamond_id: ' + JSON.stringify(String(diamondId)),
      '    preferred_currency: AUD',
      '  ) {',
      '    id price diamond_price markup_price',
      '    diamond {',
      '      id availability image video',
      '      certificate {',
      '        lab certNumber shape carats',
      '        clarity color cut polish symmetry',
      '        masked_pdf_url pdfUrl',
      '        length width depth depthPercentage table',
      '      }',
      '    }',
      '  }',
      '}'
    ].join('\n');

    return fetch(CFG.proxyUrl + '/diamonds', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Shop-Domain': getShopDomain(), 'x-jir-token': CFG.proxyToken || '' },
      body: JSON.stringify({ query: detailQuery })
    })
    .then(function(r) {
      if (!r.ok) return r.text().then(function(text) { throw new Error('detail failed ' + r.status + ' :: ' + text); });
      return r.json();
    })
    .then(function(data) {
      return data && data.data && data.data.get_diamond_by_id ? mapDiamondItem(data.data.get_diamond_by_id) : null;
    })
    .catch(function(err) {
      console.warn('[JIR] Direct diamond restore failed:', err);
      return null;
    });
  }

  function applyClientSideDiamondFilters() {
    var effective = getEffectiveDiamondFilters();
    var polishFilters = cleanArray(S.customerFilters.polish || []);
    var seenDiamondIds = {};
    S.filteredDiamonds = S.allFetchedDiamonds.filter(function(d) {
      var diamondId = String(d && (d.diamondId || d.nivodaId) || '').trim();
      if (!diamondId || seenDiamondIds[diamondId]) return false;
      if (!d.offerId || Number(d.price || 0) <= 0) return false;
      if (String(d.availability || '').trim().toUpperCase() !== 'AVAILABLE') return false;
      if (normaliseShapeToken(d.shape) !== normaliseShapeToken(S.shape)) return false;
      if (!Number.isFinite(Number(d.carat)) || Number(d.carat) <= 0) return false;
      if (d.carat < Number(effective.carat_min)) return false;
      if (d.carat > Number(effective.carat_max)) return false;
      if (!normalizedValueInList(d.color, effective.colours)) return false;
      if (!normalizedValueInList(d.clarity, effective.clarities)) return false;
      if (!normalizedValueInList(d.lab, effective.labs)) return false;
      if (isRoundShape(d.shape) && effective.cuts.length && !normalizedValueInList(d.cut, effective.cuts)) return false;
      if (polishFilters.length && !normalizedValueInList(d.polish, polishFilters)) return false;
      seenDiamondIds[diamondId] = true;
      return true;
    }).sort(function(a, b) {
      var aRecommended = isRecommendedGradeEligible(a);
      var bRecommended = isRecommendedGradeEligible(b);
      if (aRecommended !== bRecommended) return aRecommended ? -1 : 1;
      return sortCuratedDiamonds(a, b);
    });
    S.diamonds = S.filteredDiamonds.slice();
  }

  function getVisibleDiamonds() {
    if (!S.browseMoreOpened && !S.advancedFiltersOpened) {
      return S.filteredDiamonds.slice(0, getRecommendedCount());
    }
    var count = Number(S.visibleDiamondCount || getRecommendedLimit());
    return S.filteredDiamonds.slice(0, count);
  }

  function syncCurrentFromPriceFromVisibleDiamonds() {
    if (!S.setting || !S.shape) return;
    var recommended = getVisibleDiamonds().slice(0, getRecommendedCount());
    if (!recommended.length) return;
    var lowest = recommended.reduce(function(min, diamond) {
      var price = Number(diamond && diamond.price || 0);
      if (!price) return min;
      if (!min) return price;
      return Math.min(min, price);
    }, 0);
    if (!lowest) return;
    S.lowestDiamondPriceByShape[normaliseShapeToken(S.shape)] = lowest;
    updateSettingFromPrices();
    updateBSB();
  }

  function gradeRank(value, order) {
    var idx = order.indexOf(String(value || '').trim().toUpperCase());
    return idx === -1 ? order.length : idx;
  }

  function finishScore(value) {
    var normalized = String(value || '').trim().toLowerCase();
    if (normalized === 'ideal') return 5;
    if (normalized === 'excellent') return 4;
    if (normalized === 'very good') return 3;
    if (normalized === 'good') return 2;
    return 1;
  }

  function diamondQualityScore(d) {
    var colourScore = Math.max(0, 8 - gradeRank(d.color, ['D', 'E', 'F', 'G', 'H', 'I', 'J']));
    var clarityScore = Math.max(0, 8 - gradeRank(d.clarity, ['FL', 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2']));
    return colourScore + clarityScore + finishScore(d.cut) + finishScore(d.polish) + finishScore(d.symmetry);
  }

  function getRecommendationPriority(pref) {
    var engine = (CFG.curatedSpecs && CFG.curatedSpecs.recommendationEngine) || {};
    var fallback = {
      balanced: 'price_quality_carat',
      brightest: 'quality_price_carat',
      largest: 'carat_price_quality'
    };
    var configured = pref === 'brightest'
      ? engine.brightestPriority
      : (pref === 'largest' ? engine.largestPriority : engine.balancedPriority);
    var fallbackPriority = String(fallback[pref] || fallback.balanced).split('_');
    var allowedMetrics = ['price', 'quality', 'carat'];
    var priority = String(configured || '').split('_').filter(function(metric, index, metrics) {
      return allowedMetrics.indexOf(metric) > -1 && metrics.indexOf(metric) === index;
    });
    fallbackPriority.forEach(function(metric) {
      if (priority.indexOf(metric) === -1) priority.push(metric);
    });
    return priority;
  }

  function compareDiamondRecommendationMetric(metric, a, b) {
    if (metric === 'quality') return diamondQualityScore(b) - diamondQualityScore(a);
    if (metric === 'carat') return Number(b.carat || 0) - Number(a.carat || 0);
    if (metric === 'price') return Number(a.price || 0) - Number(b.price || 0);
    return 0;
  }

  function sortCuratedDiamonds(a, b) {
    var priority = getRecommendationPriority(S.qualityPreference || 'balanced');
    for (var i = 0; i < priority.length; i += 1) {
      var delta = compareDiamondRecommendationMetric(priority[i], a, b);
      if (delta) return delta;
    }
    return String(a.diamondId || a.nivodaId || '').localeCompare(String(b.diamondId || b.nivodaId || ''));
  }

  function getRecommendationNote(d) {
    var pref = S.qualityPreference || 'balanced';
    if (pref === 'largest') return 'Prioritised for higher carat weight within your preferred size range.';
    if (pref === 'brightest') return 'Prioritised for stronger overall quality grades, including cut, polish and symmetry.';
    return 'Prioritised for price, followed by overall quality and carat weight.';
  }

  function getRecommendationBadge(d, index) {
    if (S.qualityPreference === 'largest') return textCfg('badgeFingerCoverage', 'Best Finger Coverage');
    if (S.qualityPreference === 'brightest') return textCfg('badgePremiumChoice', 'Premium Choice');
    return textCfg('badgeBestValue', 'Best Value');
  }

  function getDisplayedDiamondTotal() {
    if (S.allPagesLoaded) return S.filteredDiamonds.length;
    if (Number(S.totalCount || 0) > S.filteredDiamonds.length) return Number(S.totalCount || 0);
    return null;
  }

  function trackCollectionPriceMatch(visibleDiamonds) {
    if (!S.setting || S.browseMoreOpened || S.advancedFiltersOpened) return;
    var fromPrice = getSelectedSettingFromPrice(S.setting);
    if (fromPrice == null) return;
    var recommendedCount = getRecommendedCount();
    var recommended = (visibleDiamonds || []).slice(0, recommendedCount);
    if (!recommended.length) return;
    var settingCents = Math.round(Number(S.metalP || 0) * 100);
    var minimumDisplayedCents = recommended.reduce(function(min, diamond) {
      var total = settingCents + Number(diamond && diamond.price || 0);
      if (!total) return min;
      if (!min) return total;
      return Math.min(min, total);
    }, 0);
    if (!minimumDisplayedCents) return;
    var fromCents = Math.round(Number(fromPrice || 0) * 100);
    var delta = Math.abs(minimumDisplayedCents - fromCents);
    var status = delta <= 100 ? 'matched' : (fromCents > 0 && delta / fromCents <= 0.10 ? 'within_10_percent' : 'outside_10_percent');
    var eventKey = [S.setting.id, S.shape, S.metal, S.size || '', fromCents, minimumDisplayedCents, status].join(':');
    if (S.priceMatchEventKey === eventKey) return;
    S.priceMatchEventKey = eventKey;
    trackBuilderEvent('collection_price_to_builder_match', {
      value: status,
      collection_price_cents: fromCents,
      builder_min_displayed_price_cents: minimumDisplayedCents
    });
  }

  function validateImageUrl(url) {
    if (!url) return Promise.resolve(false);
    if (Object.prototype.hasOwnProperty.call(S.mediaValidationCache, url)) {
      return Promise.resolve(!!S.mediaValidationCache[url]);
    }
    return new Promise(function(resolve) {
      var done = false;
      var img = new Image();
      var timer = setTimeout(function() {
        if (done) return;
        done = true;
        S.mediaValidationCache[url] = false;
        resolve(false);
      }, 1600);
      function finish(ok) {
        if (done) return;
        done = true;
        clearTimeout(timer);
        S.mediaValidationCache[url] = ok;
        resolve(ok);
      }
      img.onload = function() { finish(true); };
      img.onerror = function() { finish(false); };
      img.src = url;
    });
  }

  function filterDiamondsWithValidMedia(diamonds) {
    var candidates = (diamonds || []).filter(Boolean);
    if (S.adminRules && S.adminRules.requireMedia === false) {
      return Promise.resolve(candidates);
    }
    return Promise.all(candidates.map(function(diamond) {
      if (!diamond) return Promise.resolve(null);
      if (!diamond.imageUrl) return Promise.resolve(diamond.videoBase ? diamond : null);
      return validateImageUrl(diamond.imageUrl).then(function(ok) {
        return ok ? diamond : null;
      });
    })).then(function(results) {
      var valid = results.filter(Boolean);
      /* Image validation can time out when the CDN is slow. If every candidate
       * fails at once, keep diamonds that have media URLs rather than turning a
       * valid API response into a false no-results state. */
      if (!valid.length && candidates.length) {
        return candidates.filter(function(diamond) { return !!(diamond.imageUrl || diamond.videoBase); });
      }
      return valid;
    });
  }

  /* ─── RENDER DIAMOND GRID ────────────────────────────────────────────────
   * FIX: Cards now render a <video class="jir-dc-vid"> instead of <img>.
   * The video uses videoBase (plain URL, no /autoplay) so it is controlled
   * by JS play/pause rather than autoplaying. The imageUrl is used as the
   * video poster so the first frame shows immediately without buffering.
   * Hover events (mouseenter/mouseleave) are attached below in the listener.
   * ─────────────────────────────────────────────────────────────────────── */
  function renderDiamondGrid(diamonds) {
    var grid  = el('jir-d-grid');
    if (!grid) return;
    if (!diamonds.length) {
      /* Other UI updates can request a grid render while a replacement fetch
       * is active. Keep the loading state visible until the active request has
       * conclusively returned no matching diamonds. */
      if (S.dLoading) {
        renderDiamondLoading();
        renderDiamondResultsFooter();
        return;
      }
      /* When appending (Load More), getting 0 results means we've reached the
       * end — don't wipe the existing grid. Just hide Load More and update footer. */
      if (S.isAppending) {
        S.hasMore = false;
        renderDiamondResultsFooter();
        return;
      }
      grid.innerHTML = renderExpertSelectionCard(true);
      renderDiamondResultsFooter();
      return;
    }
    var sp = Number(S.metalP || 0);
    var recommendedCount = getRecommendedCount();
    var cards = diamonds.map(function(d, i) {
      var totalCents = d.price + (sp * 100);
      var tier = i < recommendedCount ? 'recommended' : (S.advancedFiltersOpened ? 'advanced' : 'browse_more');
      var badge = tier === 'recommended' ? getRecommendationBadge(d, i) : '';
      var note = tier === 'recommended' ? getRecommendationNote(d) : '';

      /* Card thumbnail — keep the list view static for faster scanning.
       * The richer 360° media experience now lives only on the diamond
       * detail page, where the customer has already chosen to focus on one
       * stone. */
      var thumbHtml = d.imageUrl
        ? '<img class="jir-dc-poster" src="' + escapeHtml(d.imageUrl) + '" alt="' +
            escapeHtml(d.carat + 'ct ' + d.shape + ' diamond') +
            '" loading="lazy">'
        : '<div class="jir-dc-vis-placeholder"><div class="jir-dcvi">' + diamondPlaceholderMarkup(96, 'jir-theme-asset') + '</div></div>';

      return '' +
        '<div class="jir-dc' + (tier === 'recommended' ? ' jir-dc-tier-recommended' : ' jir-dc-tier-more') + '" data-d-idx="' + i + '" data-result-tier="' + escapeHtml(tier) + '" tabindex="0" role="button" aria-label="View ' + escapeHtml(d.carat + 'ct ' + d.shape + ' diamond') + '">' +
          '<div class="jir-dc-vis">' +
            thumbHtml +
            '<button class="jir-dc-heart" data-d-idx="' + i + '" type="button" aria-label="Shortlist">\u2661</button>' +
            '<div class="jir-dc-lab">' + escapeHtml(d.lab) + '</div>' +
          '</div>' +
          '<div class="jir-dc-body">' +
            (badge ? '<div class="jir-dc-rec">' + escapeHtml(badge) + '</div>' : '') +
            '<div class="jir-dc-title">' + escapeHtml(d.carat + 'ct ' + d.shape) + '</div>' +
            '<div class="jir-dc-specs">' + escapeHtml(d.color + ' \u00b7 ' + d.clarity + ' \u00b7 ' + d.cut + ' Cut \u00b7 ' + d.polish + ' Polish') + '</div>' +
            (note ? '<div class="jir-dc-why"><strong>Why we recommend this</strong><span>' + escapeHtml(note) + '</span></div>' : '') +
            '<div class="jir-dc-price-row">' +
              '<div><div class="jir-dc-ring-price">' + fmtPrice(totalCents) + '</div><div class="jir-dc-price-note">Complete ring price</div></div>' +
              '<span class="jir-micro" style="text-align:right">' + escapeHtml(d.lab) + '<br>' + escapeHtml(getMaskedCertificateNumber(d.certNo)) + '</span>' +
            '</div>' +
            '<button class="jir-dc-details-btn" data-d-idx="' + i + '" type="button">' + escapeHtml(textCfg('diamondCardDetailsLabel', 'View Diamond Details')) + '</button>' +
          '</div>' +
        '</div>';
    }).join('');
    grid.innerHTML = cards;
    var recommendationEventKey = diamondFetchKey() + ':' + recommendedCount;
    if (!S.browseMoreOpened && S.recommendationsEventKey !== recommendationEventKey) {
      S.recommendationsEventKey = recommendationEventKey;
      trackBuilderEvent('stone_shortlist_viewed', {
        count_returned: recommendedCount,
        top_stone_ids: diamonds.map(function(d) { return d.diamondId || d.nivodaId || ''; }).filter(Boolean).slice(0, recommendedCount)
      });
      trackBuilderEvent('byor_recommendations_loaded', {
        result_count: recommendedCount,
        response_time_ms: S.lastResponseMs || undefined
      });
      trackBuilderEvent('byor_recommendations_viewed', {
        result_count: recommendedCount,
        response_time_ms: S.lastResponseMs || undefined
      });
    }
    trackCollectionPriceMatch(diamonds);

    /* ── Card event listeners ── */
    grid.querySelectorAll('.jir-dc').forEach(function(card) {
      /* Click: open diamond detail page */
      card.addEventListener('click', function(e) {
        if (!this.dataset || this.dataset.dIdx == null) return;
        if (e.target.closest('.jir-dc-heart') || e.target.closest('.jir-dc-details-btn')) return;
        selectDiamond(Number(this.dataset.dIdx), this.dataset.resultTier || 'recommended');
      });
      card.addEventListener('keydown', function(e) {
        if (!this.dataset || this.dataset.dIdx == null) return;
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectDiamond(Number(this.dataset.dIdx), this.dataset.resultTier || 'recommended'); }
      });

    });

    /* Shortlist heart toggle */
    grid.querySelectorAll('.jir-dc-heart').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        var liked = this.classList.toggle('jir-liked');
        this.textContent = liked ? '\u2665' : '\u2661';
      });
    });
    grid.querySelectorAll('.jir-dc-details-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        var card = this.closest('.jir-dc');
        selectDiamond(Number(this.dataset.dIdx), card && card.dataset ? card.dataset.resultTier : 'recommended');
      });
    });

    renderDiamondResultsFooter();
  }

  function renderTeamPickInlineCard(isLowResult) {
    return '' +
      '<div class="jir-dc jir-expert-card" role="listitem">' +
        '<div class="jir-dc-body">' +
          '<div class="jir-dc-rec">' + escapeHtml(isLowResult ? 'Curated fallback' : 'Prefer expert help?') + '</div>' +
          '<div class="jir-dc-title">' + escapeHtml(textCfg('teamPickTitle', textCfg('shortlistFallbackTitle', 'Find My Perfect Stone'))) + '</div>' +
          '<div class="jir-dc-specs">' + escapeHtml(textCfg('teamPickBody', "We'll recommend the best available stone based on your preferences.")) + '</div>' +
          '<button type="button" class="jir-btn-gem" onclick="window.JIR.chooseExpertSelection(event)">' + escapeHtml(textCfg('shortlistFallbackCta', 'Ask our team to select')) + '</button>' +
        '</div>' +
      '</div>';
  }

  function renderExpertSelectionCard(isEmpty) {
    return renderTeamPickInlineCard(isEmpty);
  }

  function renderDiamondResultsFooter() {
    var footer = el('jir-d-results-footer');
    var meta   = el('jir-d-results-meta');
    var btn    = el('jir-load-more-btn');
    var loadingStatus = el('jir-d-results-loading');
    var advancedBtn = el('jir-advanced-filters-btn');
    var teamBtn = el('jir-team-pick-footer-btn');
    if (!footer || !meta || !btn) return;
    var shown  = getVisibleDiamonds().length;
    var total  = getDisplayedDiamondTotal();
    var recommendedCount = getRecommendedCount();
    var canBrowseLayer1 = CFG.enableBrowseMore !== false && isRecommendedOnlyResultScope();
    footer.style.display = (shown > 0 || total > 0 || S.countingTotal || canBrowseLayer1) ? 'flex' : 'none';
    if (S.countingTotal) {
      meta.textContent = 'Finding suitable stones…';
    } else if (shown > recommendedCount) {
      meta.textContent = 'Showing ' + recommendedCount + ' recommended stone' + (recommendedCount === 1 ? '' : 's') + ' plus ' + (shown - recommendedCount) + ' more diamond' + ((shown - recommendedCount) === 1 ? '' : 's') + ' in this range';
    } else {
      meta.textContent = shown
        ? 'These stones have been shortlisted based on beauty, value, availability, and suitability for your selected ring design.'
        : '';
    }
    btn.style.display = (CFG.enableBrowseMore !== false && (canBrowseLayer1 || S.hasMore || S.filteredDiamonds.length > shown)) ? 'inline-flex' : 'none';
    btn.disabled      = S.dLoading;
    btn.classList.toggle('jir-loading', !!(S.dLoading && S.isAppending));
    btn.setAttribute('aria-busy', (S.dLoading && S.isAppending) ? 'true' : 'false');
    btn.innerHTML     = (S.dLoading && S.isAppending)
      ? '<span class="jir-btn-spin" aria-hidden="true"></span><span>Loading more diamonds…</span>'
      : '<span>' + escapeHtml(textCfg('browseMoreLabel', 'Browse more diamonds in this range')) + '</span>';
    if (loadingStatus) {
      loadingStatus.classList.toggle('jir-show', !!(S.dLoading && S.isAppending));
      loadingStatus.setAttribute('aria-hidden', (S.dLoading && S.isAppending) ? 'false' : 'true');
    }
    if (advancedBtn) {
      advancedBtn.style.display = CFG.enableAdvancedSearch === false ? 'none' : 'inline-flex';
      advancedBtn.classList.toggle('jir-open', !!S.advancedFiltersOpened);
      advancedBtn.setAttribute('aria-expanded', S.advancedFiltersOpened ? 'true' : 'false');
      advancedBtn.setAttribute('aria-controls', 'jir-filter-adv');
    }
    if (teamBtn) {
      teamBtn.style.display = 'inline-flex';
      teamBtn.classList.toggle('jir-pressed', S.decisionMode === 'team');
    }
  }

  function fetchDiamonds(forceReplace, opts) {
    opts = opts || {};
    if (!S.setting || !CFG.proxyUrl) return;
    var requestSeq = ++S.diamondRequestSeq;
    var preserveVisible = !!(opts.preserveVisible && S.allFetchedDiamonds.length);
    if (forceReplace) {
      S.offset     = 0;
      S.totalCount = 0;
      S.hasMore    = false;
      S.allPagesLoaded = false;
      S.countingTotal = false;
      S.browseMoreOpened = false;
      S.advancedFiltersOpened = false;
      S.selectedTier = 'recommended';
      S.morePageNumber = 0;
      S.recommendationsEventKey = '';
      if (!preserveVisible) {
        S.allFetchedDiamonds = [];
        S.filteredDiamonds   = [];
        S.diamonds           = [];
        S.lastDiamondFetchKey = '';
      }
      S.isAppending = false;
      S.visibleDiamondCount = getRecommendedLimit();
    }
    var nextKey = diamondFetchKey();
    var cacheKey = getDiamondPageCacheKey(nextKey);
    var query = buildNivodaQuery();
    var inventoryCacheKey = getDiamondInventoryCacheKey(query);
    var usingCachedPage = false;
    if (isRecommendedOnlyResultScope() && !hasRecommendedGradePoolForShape(S.shape)) {
      S.lastDiamondFetchKey = nextKey;
      S.hasMore = false;
      S.allPagesLoaded = true;
      S.dLoading = false;
      if (!opts.silent) renderDiamondGrid([]);
      return;
    }
    if (forceReplace) {
      /* Quality First and Size First use different rankings over the same
       * inventory query, so they can share the fetched candidate pool. */
      var cachedPage = readSessionCache(cacheKey, DIAMOND_PAGE_CACHE_TTL_MS)
        || readSessionCache(inventoryCacheKey, DIAMOND_PAGE_CACHE_TTL_MS);
      if (cachedPage && Array.isArray(cachedPage.allFetchedDiamonds)) {
        S.offset = Number(cachedPage.offset || 0);
        S.totalCount = Number(cachedPage.totalCount || 0);
        S.hasMore = !!cachedPage.hasMore;
        S.allPagesLoaded = !!cachedPage.allPagesLoaded;
        S.allFetchedDiamonds = cachedPage.allFetchedDiamonds.slice();
        S.filteredDiamonds = [];
        S.diamonds = [];
        S.lastDiamondFetchKey = nextKey;
        S.isAppending = false;
        S.visibleDiamondCount = getRecommendedLimit();
        applyClientSideDiamondFilters();
        S.visibleDiamondCount = Math.min(
          Number(S.visibleDiamondCount || getRecommendedLimit()),
          S.filteredDiamonds.length || getRecommendedLimit()
        );
        usingCachedPage = true;
        if (!opts.silent) {
          updatePriceSliderBounds();
          syncCurrentFromPriceFromVisibleDiamonds();
          renderDiamondGrid(getVisibleDiamonds());
        }
        restorePendingDiamondIfPossible();
        return;
      }
    }
    if (!forceReplace && nextKey === S.lastDiamondFetchKey && S.diamonds.length && !S.isAppending) {
      if (!opts.silent) renderDiamondGrid(getVisibleDiamonds());
      return;
    }
    if (S.diamondFetchAbort) S.diamondFetchAbort.abort();
    S.diamondFetchAbort = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var requestIsAppending = !!S.isAppending;
    S.dLoading = true;
    var requestStartMs = nowMs();
    if (!opts.silent && requestIsAppending) renderDiamondResultsFooter();
    if (!opts.silent && !usingCachedPage && !preserveVisible) renderDiamondLoading();
    var payload = { query: query };
    fetch(CFG.proxyUrl + '/diamonds', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Shop-Domain': getShopDomain(), 'x-jir-token': CFG.proxyToken || '' },
      body: JSON.stringify(payload),
      signal: S.diamondFetchAbort ? S.diamondFetchAbort.signal : undefined
    })
    .then(function(r) {
      if (!r.ok) return r.text().then(function(text) { throw new Error('Proxy returned ' + r.status + ' :: ' + text); });
      return r.json();
    })
    .then(function(data) {
      if (requestSeq !== S.diamondRequestSeq || nextKey !== diamondFetchKey()) return null;
      S.lastResponseMs = Math.max(0, Math.round(nowMs() - requestStartMs));
      if (data.errors && data.errors.length) throw new Error(data.errors[0].message || 'GraphQL error');
      return filterDiamondsWithValidMedia(extractDiamonds(data)).then(function(pageDiamonds) {
        if (requestSeq !== S.diamondRequestSeq || nextKey !== diamondFetchKey()) return;
      /* rawItemsCount = how many items Nivoda actually returned this page.
       * total_count from Nivoda is unreliable — some accounts return the page
       * count (e.g. 40) instead of the true inventory total, making
       * S.offset < total_count always false and Load More never appearing.
       *
       * Heuristic instead:
       *   rawItemsCount >= pageSize → Nivoda gave a full page → more likely exist
       *   rawItemsCount <  pageSize → Nivoda gave a partial page → we're at the end
       * Edge case: inventory exactly equals pageSize → Load More appears but
       * the next fetch returns 0 items → renderDiamondGrid handles that gracefully. */
        var rawItemsCount = data && data.data && data.data.diamonds_by_query
          ? (data.data.diamonds_by_query.items || []).length
          : 0;
        var totalCount    = data && data.data && data.data.diamonds_by_query
          ? Number(data.data.diamonds_by_query.total_count || 0)
          : 0;
        var keepVisibleFallback = preserveVisible && !requestIsAppending && !pageDiamonds.length && S.allFetchedDiamonds.length;
        S.totalCount = Math.max(Number(S.totalCount || 0), totalCount);
        if (requestIsAppending) {
          S.allFetchedDiamonds = S.allFetchedDiamonds.concat(pageDiamonds);
        } else if (!keepVisibleFallback) {
          S.allFetchedDiamonds = pageDiamonds;
        }
        S.offset  += getCuratedFetchLimit();
        /* Primary: use raw items count heuristic (page-size comparison).
         * Secondary: also honour total_count if Nivoda does return it reliably. */
        S.hasMore = rawItemsCount >= getCuratedFetchLimit()
                    || (totalCount > 0 && S.offset < totalCount);
        S.allPagesLoaded = !S.hasMore;
        S.lastDiamondFetchKey = nextKey;
        applyClientSideDiamondFilters();
        if (requestIsAppending) {
          S.visibleDiamondCount = Math.min(
            Math.max(Number(S.visibleDiamondCount || 0) + Number(S.browseMorePageSize || 20), getRecommendedLimit()),
            S.filteredDiamonds.length
          );
        } else {
          S.visibleDiamondCount = Math.min(getRecommendedLimit(), Number(S.visibleDiamondCount || getRecommendedLimit()), S.filteredDiamonds.length || getRecommendedLimit());
        }
        /* The active response is now conclusive. Clear loading before rendering
         * so a genuine empty response can show the fallback, while incidental
         * renders during the request continue to show the loading state. */
        S.dLoading = false;
        if (forceReplace && !keepVisibleFallback) {
          var pageCacheData = {
            offset: S.offset,
            totalCount: S.totalCount,
            hasMore: S.hasMore,
            allPagesLoaded: S.allPagesLoaded,
            visibleDiamondCount: S.visibleDiamondCount,
            allFetchedDiamonds: S.allFetchedDiamonds
          };
          writeSessionCache(cacheKey, pageCacheData);
          writeSessionCache(inventoryCacheKey, pageCacheData);
        }
        if (!opts.silent) {
          updatePriceSliderBounds();   /* update slider bounds from real diamond prices */
          syncCurrentFromPriceFromVisibleDiamonds();
          renderDiamondGrid(getVisibleDiamonds());
          if (requestIsAppending) {
            trackBuilderEvent('byor_more_diamonds_loaded', {
              page_number: S.morePageNumber || 1,
              result_count: pageDiamonds.length,
              visible_more_count: Math.max(0, getVisibleDiamonds().length - getRecommendedCount()),
              response_time_ms: S.lastResponseMs || undefined
            });
          }
        }
        restorePendingDiamondIfPossible();
      });
    })
    .catch(function(err) {
      if (err && err.name === 'AbortError') return;
      if (requestSeq !== S.diamondRequestSeq || nextKey !== diamondFetchKey()) return;
      console.error('[JIR] Diamond fetch error:', err);
      if (!opts.silent) {
        if ((requestIsAppending || preserveVisible) && S.filteredDiamonds.length) {
          showToast(preserveVisible ? 'Showing current recommendations. Refresh unavailable.' : 'Could not load more diamonds. Please try again.');
        } else {
          renderDiamondError(textCfg('diamondLoadErrorBody', 'Unable to load diamonds. Please try again or contact us.'));
        }
      }
    })
    .finally(function() {
      if (requestSeq !== S.diamondRequestSeq) return;
      S.dLoading    = false;
      S.isAppending = false;
      if (!opts.silent) renderDiamondResultsFooter();
    });
  }

  function scheduleDiamondFetch(forceReplace, opts) {
    opts = opts || {};
    if (!S.setting) return;
    collectSidebarFilters();
    if (S.diamondFetchTimer) { clearTimeout(S.diamondFetchTimer); S.diamondFetchTimer = null; }
    /* Invalidate and abort immediately rather than waiting for the debounce.
     * Otherwise the old request can finish during the delay and clear loading
     * state or render an error for filters that are no longer active. */
    if (S.diamondFetchAbort) {
      S.diamondFetchAbort.abort();
      S.diamondFetchAbort = null;
    }
    S.diamondRequestSeq += 1;
    S.dLoading = false;
    if (forceReplace) S.isAppending = false;
    S.diamondFetchTimer = setTimeout(function() { fetchDiamonds(!!forceReplace, opts); }, forceReplace ? 0 : FETCH_DEBOUNCE_MS);
  }

  function ensureDiamondResultsReady() {
    collectSidebarFilters();
    if (S.allFetchedDiamonds.length && diamondFetchKey() === S.lastDiamondFetchKey) {
      applyClientSideDiamondFilters();
      updatePriceSliderBounds();
      if (!S.visibleDiamondCount) S.visibleDiamondCount = getRecommendedLimit();
      renderDiamondGrid(getVisibleDiamonds());
      renderDiamondResultsFooter();
      return;
    }
    scheduleDiamondFetch(true);
  }

  function fetchLayer1DiamondPool() {
    S.offset = 0;
    S.hasMore = true;
    S.allPagesLoaded = false;
    S.isAppending = true;
    S.morePageNumber = 1;
    renderDiamondResultsFooter();
    fetchDiamonds(false);
  }

  function loadMoreDiamonds() {
    if (CFG.enableBrowseMore === false) return;
    if (S.dLoading) return;
    setButtonResponse(el('jir-load-more-btn'));
    var wasExpanded = !!S.browseMoreOpened;
    var beforeVisible = getVisibleDiamonds().length;
    S.browseMoreOpened = true;
    trackBuilderEvent('byor_browse_more_clicked', {
      tier1_result_count: getRecommendedCount(),
      visible_count: beforeVisible
    });
    trackBuilderEvent('byor_show_more_diamonds_clicked', {
      tier1_result_count: getRecommendedCount(),
      visible_count: beforeVisible
    });
    if (!wasExpanded) {
      fetchLayer1DiamondPool();
      return;
    }
    if (S.filteredDiamonds.length > beforeVisible) {
      S.visibleDiamondCount = Math.min(
        Math.max(Number(S.visibleDiamondCount || 0), beforeVisible) + Number(S.browseMorePageSize || 20),
        S.filteredDiamonds.length
      );
      renderDiamondGrid(getVisibleDiamonds());
      showToast('More diamonds shown');
      trackBuilderEvent('byor_more_diamonds_loaded', {
        page_number: S.morePageNumber || 1,
        result_count: Math.max(0, getVisibleDiamonds().length - beforeVisible),
        visible_more_count: Math.max(0, getVisibleDiamonds().length - getRecommendedCount()),
        response_time_ms: 0
      });
      return;
    }
    if (!S.hasMore) return;
    S.morePageNumber = Number(S.morePageNumber || 0) + 1;
    S.isAppending = true;
    renderDiamondResultsFooter();
    fetchDiamonds(false);
  }

  /* ─── DIAMOND DETAIL MEDIA ───────────────────────────────────────────────
   * Uses videoUrl (with /autoplay) for the detail page — autoplay, loop,
   * muted (required for autoplay in browsers). The 360-badge overlays the top
   * left. If no video somehow, falls back to imageUrl then SVG.
   * ─────────────────────────────────────────────────────────────────────── */
  function renderDiamondMediaGallery(d) {
    var main = el('jir-dpdp-media-main');
    if (!main) return;
    if (S.mediaPreviewTimer) {
      clearTimeout(S.mediaPreviewTimer);
      S.mediaPreviewTimer = null;
    }
    if (d.videoUrl) {
      /* Size from the real media slot so the square stays clear of the
       * certificate bar below on desktop and contained within the viewport
       * on mobile. */
      var isMobile = window.innerWidth <= 900;
      var panel = main.closest('.jir-dpdp-media');
      var panelStyles = panel ? window.getComputedStyle(panel) : null;
      var panelPadX = panelStyles
        ? (parseFloat(panelStyles.paddingLeft || 0) + parseFloat(panelStyles.paddingRight || 0))
        : (isMobile ? 48 : 88);
      var panelWidth = panel ? Math.max(panel.clientWidth - panelPadX, 0) : 0;
      var mainRect = main.getBoundingClientRect();
      var slotWidth = Math.max(Math.floor(mainRect.width || main.clientWidth || 0), 0);
      var slotHeight = Math.max(Math.floor(mainRect.height || main.clientHeight || 0), 0);
      var viewportWidth = Math.max(window.innerWidth || 0, 0);
      var viewportHeight = Math.max(window.innerHeight || 0, 0);
      var mobileWidthLimit = Math.max(Math.min(slotWidth || panelWidth || (viewportWidth - 24), viewportWidth - 24), 0);
      var mobileHeightLimit = Math.max(viewportHeight - 280, 220);
      var desktopWidthLimit = Math.max((slotWidth || panelWidth || 640) - 12, 0);
      var desktopHeightLimit = Math.max((slotHeight || 0) - 12, 0);
      var mobileTarget = Math.min(mobileWidthLimit, mobileHeightLimit || mobileWidthLimit);
      var desktopTarget = Math.min(desktopWidthLimit, desktopHeightLimit || desktopWidthLimit);
      var target = isMobile
        ? Math.min(Math.max(mobileTarget - 4, 220), 420)
        : Math.min(Math.max(desktopTarget, 380), 520);
      /* touch-action:none on mobile gives the iframe full gesture ownership so
       * the page scroll handler doesn't compete for the swipe sequence */
      var touchCSS = isMobile ? 'touch-action:none;' : '';
      /* The Nivoda viewer behaves more reliably when it renders at its
       * natural 500px viewport and is scaled down to the target size.
       * Use transform instead of zoom so iOS Safari scales the iframe
       * rather than cropping the 500px viewport inside the mobile frame. */
      var natural = 500;
      var scaleVal = (target / natural).toFixed(4);

      main.innerHTML =
        '<div class="jir-dpdp-video-frame" style="width:' + target + 'px;height:' + target + 'px;max-width:100%;' + touchCSS + '">' +
          '<iframe src="' + escapeHtml(d.videoUrl) + '" allow="autoplay; fullscreen"' +
            ' class="jir-dpdp-video-iframe"' +
            ' style="width:' + natural + 'px;height:' + natural + 'px;transform:scale(' + scaleVal + ');border:none;display:block;">' +
          '</iframe>' +
          '<div class="jir-360-badge">360°</div>' +
        '</div>';
    } else if (d.imageUrl) {
      main.innerHTML = '<img class="jir-dpdp-media-img" src="' + escapeHtml(d.imageUrl) + '" alt="' + escapeHtml(d.carat + 'ct ' + d.shape) + '">';
    } else {
      main.innerHTML = '<div class="jir-dpdp-media-svg">' + diamondPlaceholderMarkup(220, 'jir-theme-asset') + '</div>';
    }
  }

  function syncDiamondMediaOnResize() {
    if (S.mediaResizeTimer) clearTimeout(S.mediaResizeTimer);
    S.mediaResizeTimer = setTimeout(function() {
      if (S.currentPage === 'dpdp' && S.diamond) renderDiamondMediaGallery(S.diamond);
    }, 90);
  }

  function syncDiamondMediaAfterPageShow(diamond) {
    if (!diamond) return;
    if (S.mediaResizeTimer) clearTimeout(S.mediaResizeTimer);
    S.mediaResizeTimer = setTimeout(function() {
      if (S.currentPage === 'dpdp' && S.diamond && String((S.diamond.diamondId || S.diamond.nivodaId || '')) === String(diamond.diamondId || diamond.nivodaId || '')) {
        renderDiamondMediaGallery(diamond);
      }
    }, 60);
  }

  function selectDiamond(idx, tier) {
    var d = S.filteredDiamonds[idx];
    if (!d) return;
    S.diamond = d;
    S.lastSelectedDiamondId = d.diamondId || d.nivodaId || null;
    S.dIdx    = idx;
    S.shape   = d.shape;
    S.decisionMode = 'exact';
    S.selectedTier = tier || (idx < getRecommendedCount() ? 'recommended' : (S.advancedFiltersOpened ? 'advanced' : 'browse_more'));
    S.gradeGuideState = {};
    var totalCents = d.price + (Number(S.metalP || 0) * 100);
    setText('jir-d-eye',   'Lab Grown Diamond \u00b7 ' + d.lab + ' Certified');
    var titleNode = el('jir-d-title');
    if (titleNode) titleNode.innerHTML = diamondTitleMarkup(d);
    renderCertificateLabIcon(d.lab);
    setText('jir-cert-lab', d.lab + ' Certified');
    setText('jir-cert-no',  'Certificate ' + getMaskedCertificateNumber(d.certNo));
    updateCertificatePdfLink(d);
    setText('jir-ph-price', fmtPrice(totalCents));
    setText('jir-ph-includes', 'Includes ' + (S.setting ? S.setting.name : 'your setting') + ' in ' + S.metal + ' + this centre diamond');
    renderPriceBreakdown(d);
    renderStickyDiamondSummary(d);
    qAll('[data-decision-mode]').forEach(function(node) {
      node.classList.toggle('jir-on', node.dataset.decisionMode === 'exact');
    });
    updateAddToCartCtas(totalCents);
    renderFourCGrid(d);
    renderDiamondGuideTabs('carat');
    renderSpecGrid(d);
    toggleBreakdown(false);
    updateSSB();
    saveBuildToURL();
    var addBtn = el('jir-add-btn');
    if (addBtn) addBtn.disabled = false;
    var stickyAddBtn = el('jir-dpdp-sticky-add');
    if (stickyAddBtn) stickyAddBtn.disabled = false;
    updateDecisionModeUI();
    trackBuilderEvent('stone_selected', {
      stone_id: d.diamondId || d.nivodaId || '',
      carat: d.carat,
      price_snapshot: fmtPrice(totalCents)
    });
    trackBuilderEvent('byor_stone_selected', {
      tier: S.selectedTier,
      stone_id_hash: hashString(d.diamondId || d.nivodaId || ''),
      carat: d.carat,
      price_snapshot: fmtPrice(totalCents)
    });
    goto('dpdp');
    renderDiamondMediaGallery(d);
    syncDiamondMediaAfterPageShow(d);
  }

  function getFourCContext(type, value, diamond) {
    var current = String(value || '').toUpperCase();
    if (type === 'cut') {
      var cut = String(value || '').toLowerCase();
      if (!value || value === '—') return 'Use the guide below to understand its light performance.';
      if (cut === 'excellent' || cut === 'ideal') return 'Maximises brilliance and light return.';
      if (cut === 'very good') return 'Strong sparkle with balanced everyday performance.';
      if (cut === 'good') return 'A softer light return with a more value-led profile.';
      return 'Cut describes how the diamond handles light.';
    }
    if (type === 'lwratio') {
      var ratio = getLengthWidthRatio(diamond);
      if (!ratio) return 'Helps compare how balanced or elongated the outline appears.';
      var shapeName = String(diamond && diamond.shape || 'diamond').toLowerCase();
      return 'Helps compare the outline balance and face-up shape of this ' + shapeName + '.';
    }
    if (type === 'colour') {
      if (current === 'D') return 'Colourless and among the rarest white grades.';
      if (current === 'E' || current === 'F') return 'Very white in appearance with minimal visible warmth.';
      if (current === 'G' || current === 'H') return 'Near-colourless and often chosen for balanced value.';
      if (current) return 'Shows a slightly warmer white look depending on lighting and metal colour.';
      return 'Colour measures how colourless the diamond appears.';
    }
    if (type === 'clarity') {
      if (current === 'IF') return 'Internally flawless under 10× magnification.';
      if (current.indexOf('VVS') === 0) return 'Minute inclusions that are very difficult to find.';
      if (current.indexOf('VS') === 0) return 'Very slight inclusions, typically eye-clean.';
      if (current.indexOf('SI') === 0) return 'Small inclusions that may or may not be visible without magnification.';
      return 'Clarity describes internal characteristics in the diamond.';
    }
    if (type === 'carat') {
      var carat = Number(diamond && diamond.carat || 0);
      if (!carat) return 'Carat measures weight rather than visible size alone.';
      if (carat < 1) return 'A refined size for a lighter, everyday look.';
      if (carat < 2) return 'A popular range for balanced presence and wearability.';
      return 'A stronger visual presence where spread and proportions matter more.';
    }
    return '';
  }

  function getFourCTooltip(type) {
    if (type === 'cut') return 'How well the diamond reflects light.';
    if (type === 'lwratio') return 'How balanced or elongated the shape appears face-up.';
    if (type === 'colour') return 'How colourless the diamond appears. D is the highest white grade.';
    if (type === 'clarity') return 'The presence of internal characteristics under magnification.';
    if (type === 'carat') return 'The diamond’s weight, not its visible size alone.';
    return '';
  }

  function renderFourCGrid(d) {
    var grid = el('jir-fourC-grid');
    if (!grid) return;
    var isRound = String(d && d.shape || '').toLowerCase() === 'round';
    var primaryLabel = isRound ? 'Cut' : 'L/W Ratio';
    var primaryValue = isRound ? String(d.cut || '—') : getLwRatio(d);
    var primaryDesc = isRound ? 'Light performance' : 'Shape proportions';
    var primaryType = isRound ? 'cut' : 'lwratio';
    var caratValue = Number(d && d.carat || 0);
    var caratDisplay = Number.isFinite(caratValue) && caratValue > 0
      ? caratValue.toFixed(1) + ' ct'
      : '—';
    function card(label, value, desc, type) {
      return '<div class="jir-fourC-cell">' +
        '<div class="jir-fourC-lbl-row">' +
          '<div class="jir-fourC-lbl">' + escapeHtml(label) + '</div>' +
          '<button class="jir-fourC-info" type="button" aria-label="' + escapeHtml(getFourCTooltip(type)) + '" data-tooltip="' + escapeHtml(getFourCTooltip(type)) + '">i</button>' +
        '</div>' +
        '<div class="jir-fourC-val">' + escapeHtml(value) + '</div>' +
        '<div class="jir-fourC-desc">' + escapeHtml(desc) + '</div>' +
        '<div class="jir-fourC-copy">' + escapeHtml(getFourCContext(type, value, d)) + '</div>' +
      '</div>';
    }
    grid.innerHTML =
      card(primaryLabel, primaryValue, primaryDesc, primaryType) +
      card('Colour', d.color, 'Body colour', 'colour') +
      card('Clarity', d.clarity, 'Internal features', 'clarity') +
      card('Carat', caratDisplay, 'Weight', 'carat');
  }

  function getGuideCaratItems() {
    return [
      { key: '0.20', label: '0.20ct', note: 'Light and delicate on the hand, with a subtle face-up look.', intro: 'Carat is a weight measurement, not a direct size measurement. Shape and cut can make two equal-carat diamonds look different in spread.', size: 22, fill: 10 },
      { key: '0.50', label: '0.50ct', note: 'A refined everyday size that feels understated and easy to wear.', intro: 'Around half a carat is often chosen for a fine, balanced look without chasing major price jumps.', size: 30, fill: 20 },
      { key: '1.00', label: '1.00ct', note: 'A highly requested benchmark with balanced presence and wearability.', intro: 'One carat is a popular reference point, but a well-cut stone can matter more visually than the number alone.', size: 40, fill: 32 },
      { key: '1.50', label: '1.50ct', note: 'Noticeably larger face-up and often chosen for stronger visual presence.', intro: 'Beyond one carat, millimetre spread becomes more noticeable, especially in elongated shapes.', size: 50, fill: 45 },
      { key: '2.00', label: '2.00ct', note: 'A statement size where proportion and cut quality become more important.', intro: 'At this size, warmth, inclusions, and spread differences are easier to notice, so the full combination of the 4Cs matters more.', size: 60, fill: 60 },
      { key: '3.00', label: '3.00ct', note: 'Bold and prominent, usually selected for high visual impact.', intro: 'Larger diamonds reward careful matching of cut, colour, and clarity because visual differences show more clearly.', size: 74, fill: 74 },
      { key: '5.00', label: '5.00ct', note: 'Very dramatic in finger coverage and overall presence.', intro: 'At higher carat weights, buyers usually pay close attention to spread and face-up appearance, not just total weight.', size: 92, fill: 100 }
    ];
  }

  function getGuideColourItems() {
    return [
      { key: 'J', label: 'J', note: 'Warmth is easier to notice face-up and from the side compared with higher grades.', intro: 'Colour grades measure how little body colour a white diamond shows. Lower grades carry more warmth, especially in larger stones and white metals.', tone: '#efe3c8', fill: 12 },
      { key: 'I', label: 'I', note: 'A softer white look with a warm undertone.', intro: 'I colour can still look attractive, particularly in yellow or rose gold where warmth blends more naturally.', tone: '#f2e6cd', fill: 24 },
      { key: 'H', label: 'H', note: 'Near-colourless, with mild warmth visible in some lighting.', intro: 'H often balances appearance and value well, which is why it is commonly considered a smart buying range.', tone: '#f4ead8', fill: 36 },
      { key: 'G', label: 'G', note: 'Bright and near-colourless to most eyes.', intro: 'G is a very popular range for buyers who want a crisp white look without moving into the highest colour premiums.', tone: '#f7eee5', fill: 50 },
      { key: 'F', label: 'F', note: 'Very white appearance with little visible warmth.', intro: 'F sits at the top of the near-colourless range and appears bright in almost all settings.', tone: '#faf4ed', fill: 66 },
      { key: 'E', label: 'E', note: 'Extremely subtle colour, usually only distinguishable from D by an expert.', intro: 'E is a premium high-colour grade chosen for an icy appearance and added rarity.', tone: '#fcf8f3', fill: 84 },
      { key: 'D', label: 'D', note: 'Colourless and the highest standard white-diamond grade.', intro: 'D colour is prized for its rare, icy look, though visual differences from neighbouring top grades can be subtle to most eyes.', tone: '#ffffff', fill: 100 }
    ];
  }

  function getGuideClarityItems() {
    return [
      { key: 'I1', label: 'I1', note: 'Inclusions are often visible to the naked eye and can affect transparency.', intro: 'Clarity grades inclusions and blemishes under 10x magnification, but lower grades can also affect what you see in everyday wear.', inclusions: 10, fill: 12 },
      { key: 'SI2', label: 'SI2', note: 'Inclusions are easier to spot and may be noticeable face-up, depending on shape and placement.', intro: 'Slightly Included grades can still offer value, but each stone needs closer visual checking.', inclusions: 8, fill: 24 },
      { key: 'SI1', label: 'SI1', note: 'Can be eye-clean in some diamonds, though visibility varies by shape and inclusion location.', intro: 'SI1 is often considered when balancing budget and appearance, especially if the stone looks clean to the naked eye.', inclusions: 6, fill: 36 },
      { key: 'VS2', label: 'VS2', note: 'Minor inclusions are usually hard to notice without magnification.', intro: 'VS2 is widely seen as a practical sweet spot for clean appearance and sensible pricing.', inclusions: 4, fill: 50 },
      { key: 'VS1', label: 'VS1', note: 'Small inclusions that are typically very difficult to see without magnification.', intro: 'VS1 is often chosen for a crisp, eye-clean look while avoiding top-end clarity premiums.', inclusions: 3, fill: 64 },
      { key: 'VVS2', label: 'VVS2', note: 'Extremely tiny inclusions, difficult even for trained graders to find.', intro: 'VVS grades are highly clean and appeal to buyers who want rarity beyond everyday eye-clean standards.', inclusions: 2, fill: 78 },
      { key: 'VVS1', label: 'VVS1', note: 'Minute inclusions with exceptional visual cleanliness.', intro: 'VVS1 offers a near-pristine appearance with extremely subtle internal features under magnification.', inclusions: 1, fill: 90 },
      { key: 'IF', label: 'IF', note: 'Internally flawless under 10x magnification.', intro: 'IF diamonds have no internal inclusions visible under standard grading magnification and sit near the top of the clarity scale.', inclusions: 0, fill: 100 }
    ];
  }

  function getGuideCutItems() {
    return [
      { key: 'Good', label: 'Good', note: 'Can still look attractive, but usually shows less brightness and contrast than higher cut grades.', intro: 'Cut is the easiest quality factor to notice because it controls how well the diamond returns light to the eye.', rays: 7, fill: 35 },
      { key: 'Very Good', label: 'Very Good', note: 'Strong light performance with lively sparkle and balanced value.', intro: 'Very Good often appeals to buyers who want strong visual performance without moving into the highest cut premiums.', rays: 10, fill: 66 },
      { key: 'Excellent', label: 'Excellent', note: 'High brilliance, crisp patterning, and strong overall light return.', intro: 'Excellent cut is often where sparkle, fire, and balance come together most noticeably in everyday viewing.', rays: 13, fill: 88 },
      { key: 'Ideal', label: 'Ideal', note: 'Top-end precision with exceptional brightness and facet balance.', intro: 'Ideal is used by some grading systems for the highest level of cut precision and light performance.', rays: 15, fill: 100 }
    ];
  }

  function parseMeasurementParts(measurements) {
    var parts = String(measurements || '')
      .split(/(?:x|×|\*|X)/)
      .map(function(part) { return Number(String(part).replace(/[^\d.]/g, '')); })
      .filter(function(value) { return Number.isFinite(value) && value > 0; });
    return parts;
  }

  function formatMeasurements(measurements) {
    var parts = parseMeasurementParts(measurements);
    if (!parts.length) return '—';
    return parts.map(function(value) {
      return Number(value).toFixed(2).replace(/\.00$/, '').replace(/(\.\d)0$/, '$1');
    }).join(' × ') + ' mm';
  }

  function formatPercentValue(value) {
    var num = Number(value || 0);
    if (!num) return '—';
    return num.toFixed(1).replace(/\.0$/, '') + '%';
  }

  function getMeasurementsDisplay(diamond) {
    return formatMeasurements(diamond && diamond.measurements);
  }

  function getLwRatio(diamond) {
    var ratio = getLengthWidthRatio(diamond);
    return ratio ? ratio.toFixed(2) : '—';
  }

  const DIAMOND_CUT_GUIDE = {
    round: {
      title: 'How to read Cut for a round diamond',
      intro: 'Round diamonds have an official Cut Grade on the report. Start with Cut Grade first, then refine with proportions and finish.',
      table: [
        { label: 'Cut Grade', guide: 'Excellent (preferred)', why: 'Primary indicator of sparkle and light performance', type: 'grade', preferred: ['Excellent'], acceptable: ['Very Good'] },
        { label: 'Depth', guide: '60–62.5%', why: 'Helps maintain brightness and avoid a darker appearance', type: 'range', min: 60, max: 62.5, tolerance: 0.5 },
        { label: 'Table', guide: '54–58%', why: 'Helps balance brilliance and fire', type: 'range', min: 54, max: 58, tolerance: 0.5 },
        { label: 'Symmetry', guide: 'Excellent or Very Good', why: 'Supports even light reflection', type: 'grade', preferred: ['Excellent', 'Ideal'], acceptable: ['Very Good'] },
        { label: 'Polish', guide: 'Excellent or Very Good', why: 'Indicates well-finished facet surfaces', type: 'grade', preferred: ['Excellent', 'Ideal'], acceptable: ['Very Good'] }
      ],
      note: 'For round diamonds, Cut Grade is the main starting point. Proportions and finish help refine within strong options.'
    },
    oval: {
      title: 'How to read Cut for an oval diamond',
      intro: 'Non-round diamonds do not have a cut grading in the report. Use the related report measurements and finish factors below as a guide when considering the cut factor.',
      table: [
        { label: 'L/W Ratio', guide: '1.30–1.50', why: 'Controls whether the oval looks more balanced or more elongated', type: 'ratio', min: 1.30, max: 1.50, tolerance: 0.03 },
        { label: 'Measurements', guide: 'Compare mm spread', why: 'Shows face-up size more clearly than carat alone', type: 'measurements' },
        { label: 'Depth', guide: '60–63%', why: 'Useful guide for overall proportion balance', type: 'range', min: 60, max: 63, tolerance: 0.5 },
        { label: 'Table', guide: '53–63%', why: 'Useful guide for overall proportion balance', type: 'range', min: 53, max: 63, tolerance: 0.5 },
        { label: 'Symmetry', guide: 'Very Good or Excellent', why: 'Helps the outline look even', type: 'grade', preferred: ['Excellent', 'Ideal'], acceptable: ['Very Good'] },
        { label: 'Polish', guide: 'Very Good or Excellent', why: 'Indicates a well-finished surface', type: 'grade', preferred: ['Excellent', 'Ideal'], acceptable: ['Very Good'] }
      ],
      note: 'Use these report factors as a general guide only. Fancy-shape appearance can still vary from stone to stone.'
    },
    pear: {
      title: 'How to read Cut for a pear diamond',
      intro: 'Non-round diamonds do not have a cut grading in the report. Use the related report measurements and finish factors below as a guide when considering the cut factor.',
      table: [
        { label: 'L/W Ratio', guide: '1.45–1.65', why: 'Affects whether the shape looks elegant or too wide', type: 'ratio', min: 1.45, max: 1.65, tolerance: 0.03 },
        { label: 'Measurements', guide: 'Compare mm spread', why: 'Helps judge face-up size', type: 'measurements' },
        { label: 'Depth', guide: '58–62%', why: 'Useful guide for overall balance', type: 'range', min: 58, max: 62, tolerance: 0.5 },
        { label: 'Table', guide: '53–63%', why: 'Useful guide for overall balance', type: 'range', min: 53, max: 63, tolerance: 0.5 },
        { label: 'Symmetry', guide: 'Excellent preferred', why: 'Important for tip and shoulder alignment', type: 'grade', preferred: ['Excellent', 'Ideal'], acceptable: ['Very Good'] },
        { label: 'Polish', guide: 'Very Good or Excellent', why: 'Indicates a well-finished surface', type: 'grade', preferred: ['Excellent', 'Ideal'], acceptable: ['Very Good'] }
      ],
      note: 'For pear shapes, balanced outline and symmetry matter a lot to overall appearance.'
    },
    cushion: {
      title: 'How to read Cut for a cushion diamond',
      intro: 'Non-round diamonds do not have a cut grading in the report. Use the related report measurements and finish factors below as a guide when considering the cut factor.',
      table: [
        { label: 'L/W Ratio', guide: '1.00–1.15', why: 'Shows whether the cushion looks square or slightly rectangular', type: 'ratio', min: 1.00, max: 1.15, tolerance: 0.03 },
        { label: 'Depth', guide: '60–68%', why: 'Useful guide for proportion balance', type: 'range', min: 60, max: 68, tolerance: 0.5 },
        { label: 'Table', guide: '55–65%', why: 'Useful guide for proportion balance', type: 'range', min: 55, max: 65, tolerance: 0.5 },
        { label: 'Symmetry', guide: 'Very Good or Excellent', why: 'Helps the shape appear even', type: 'grade', preferred: ['Excellent', 'Ideal'], acceptable: ['Very Good'] },
        { label: 'Polish', guide: 'Very Good or Excellent', why: 'Indicates a well-finished surface', type: 'grade', preferred: ['Excellent', 'Ideal'], acceptable: ['Very Good'] }
      ],
      note: 'Cushion cuts vary widely, so report factors help shortlist balanced options rather than guarantee appearance.'
    },
    radiant: {
      title: 'How to read Cut for a radiant diamond',
      intro: 'Non-round diamonds do not have a cut grading in the report. Use the related report measurements and finish factors below as a guide when considering the cut factor.',
      table: [
        { label: 'L/W Ratio', guide: '1.00–1.35', why: 'Shows whether the radiant looks square or elongated', type: 'ratio', min: 1.00, max: 1.35, tolerance: 0.03 },
        { label: 'Depth', guide: '61–67%', why: 'Useful guide for proportion balance', type: 'range', min: 61, max: 67, tolerance: 0.5 },
        { label: 'Table', guide: '61–69%', why: 'Useful guide for proportion balance', type: 'range', min: 61, max: 69, tolerance: 0.5 },
        { label: 'Symmetry', guide: 'Very Good or Excellent', why: 'Supports a clean outline', type: 'grade', preferred: ['Excellent', 'Ideal'], acceptable: ['Very Good'] },
        { label: 'Polish', guide: 'Very Good or Excellent', why: 'Indicates a well-finished surface', type: 'grade', preferred: ['Excellent', 'Ideal'], acceptable: ['Very Good'] }
      ],
      note: 'Use these values to shortlist well-balanced stones, then compare overall look across options.'
    },
    emerald: {
      title: 'How to read Cut for an emerald-cut diamond',
      intro: 'Non-round diamonds do not have a cut grading in the report. Use the related report measurements and finish factors below as a guide when considering the cut factor.',
      table: [
        { label: 'L/W Ratio', guide: '1.30–1.50', why: 'Controls the classic elongated emerald look', type: 'ratio', min: 1.30, max: 1.50, tolerance: 0.03 },
        { label: 'Depth', guide: '60–68%', why: 'Useful guide for proportion balance', type: 'range', min: 60, max: 68, tolerance: 0.5 },
        { label: 'Table', guide: '58–68%', why: 'Useful guide for proportion balance', type: 'range', min: 58, max: 68, tolerance: 0.5 },
        { label: 'Symmetry', guide: 'Excellent preferred', why: 'Important for step-pattern alignment', type: 'grade', preferred: ['Excellent', 'Ideal'], acceptable: ['Very Good'] },
        { label: 'Polish', guide: 'Very Good or Excellent', why: 'Important for clean facet appearance', type: 'grade', preferred: ['Excellent', 'Ideal'], acceptable: ['Very Good'] }
      ],
      note: 'For emerald cuts, symmetry and clean facet appearance are especially important.'
    },
    asscher: {
      title: 'How to read Cut for an asscher diamond',
      intro: 'Non-round diamonds do not have a cut grading in the report. Use the related report measurements and finish factors below as a guide when considering the cut factor.',
      table: [
        { label: 'L/W Ratio', guide: '1.00–1.05', why: 'Keeps the asscher close to a square outline', type: 'ratio', min: 1.00, max: 1.05, tolerance: 0.03 },
        { label: 'Depth', guide: '61–68%', why: 'Useful guide for proportion balance', type: 'range', min: 61, max: 68, tolerance: 0.5 },
        { label: 'Table', guide: '60–68%', why: 'Useful guide for proportion balance', type: 'range', min: 60, max: 68, tolerance: 0.5 },
        { label: 'Symmetry', guide: 'Excellent preferred', why: 'Important for step-pattern precision', type: 'grade', preferred: ['Excellent', 'Ideal'], acceptable: ['Very Good'] },
        { label: 'Polish', guide: 'Very Good or Excellent', why: 'Important for crisp facet appearance', type: 'grade', preferred: ['Excellent', 'Ideal'], acceptable: ['Very Good'] }
      ],
      note: 'For asscher cuts, balanced symmetry and clean facet definition matter a lot.'
    },
    marquise: {
      title: 'How to read Cut for a marquise diamond',
      intro: 'Non-round diamonds do not have a cut grading in the report. Use the related report measurements and finish factors below as a guide when considering the cut factor.',
      table: [
        { label: 'L/W Ratio', guide: '1.75–2.20', why: 'Controls how elongated the marquise looks', type: 'ratio', min: 1.75, max: 2.20, tolerance: 0.03 },
        { label: 'Depth', guide: '58–62%', why: 'Useful guide for proportion balance', type: 'range', min: 58, max: 62, tolerance: 0.5 },
        { label: 'Table', guide: '53–63%', why: 'Useful guide for proportion balance', type: 'range', min: 53, max: 63, tolerance: 0.5 },
        { label: 'Symmetry', guide: 'Excellent preferred', why: 'Important for even pointed ends and outline', type: 'grade', preferred: ['Excellent', 'Ideal'], acceptable: ['Very Good'] },
        { label: 'Polish', guide: 'Very Good or Excellent', why: 'Indicates a well-finished surface', type: 'grade', preferred: ['Excellent', 'Ideal'], acceptable: ['Very Good'] }
      ],
      note: 'For marquise shapes, a balanced outline is especially important.'
    },
    princess: {
      title: 'How to read Cut for a princess diamond',
      intro: 'Non-round diamonds do not have a cut grading in the report. Use the related report measurements and finish factors below as a guide when considering the cut factor.',
      table: [
        { label: 'L/W Ratio', guide: '1.00–1.05', why: 'Keeps the princess close to a square outline', type: 'ratio', min: 1.00, max: 1.05, tolerance: 0.03 },
        { label: 'Depth', guide: '64–75%', why: 'Useful guide for overall proportion balance', type: 'range', min: 64, max: 75, tolerance: 0.5 },
        { label: 'Table', guide: '62–75%', why: 'Useful guide for overall proportion balance', type: 'range', min: 62, max: 75, tolerance: 0.5 },
        { label: 'Symmetry', guide: 'Very Good or Excellent', why: 'Helps keep corners and shape even', type: 'grade', preferred: ['Excellent', 'Ideal'], acceptable: ['Very Good'] },
        { label: 'Polish', guide: 'Very Good or Excellent', why: 'Indicates a well-finished surface', type: 'grade', preferred: ['Excellent', 'Ideal'], acceptable: ['Very Good'] }
      ],
      note: 'Princess cuts often run deeper, so use proportions as a guide rather than a guarantee of appearance.'
    },
    generic_fancy: {
      title: 'How to read Cut for this shape',
      intro: 'Non-round diamonds do not have a cut grading in the report. Use the related report measurements and finish factors below as a guide when considering the cut factor.',
      table: [
        { label: 'L/W Ratio', guide: 'Shape dependent', why: 'Helps describe outline balance', type: 'measurements' },
        { label: 'Measurements', guide: 'Compare mm spread', why: 'Shows face-up size more clearly than carat alone', type: 'measurements' },
        { label: 'Depth', guide: 'Use as a general guide', why: 'Helps assess overall proportion balance', type: 'measurements' },
        { label: 'Table', guide: 'Use as a general guide', why: 'Helps assess overall proportion balance', type: 'measurements' },
        { label: 'Symmetry', guide: 'Very Good or better', why: 'Helps the outline look even', type: 'grade', preferred: ['Excellent', 'Ideal'], acceptable: ['Very Good'] },
        { label: 'Polish', guide: 'Very Good or better', why: 'Indicates a well-finished surface', type: 'grade', preferred: ['Excellent', 'Ideal'], acceptable: ['Very Good'] }
      ],
      note: 'For fancy shapes, use L/W ratio, measurements, depth, table, symmetry and polish as a general guide to overall balance.'
    }
  };

  const GLOBAL_CUT_GUIDE_NOTE = 'For round diamonds, start with Cut Grade. For other shapes, use L/W ratio, measurements, depth, table, symmetry and polish as a general guide to overall balance.';

  function getFaceUpMm(diamond) {
    var parts = parseMeasurementParts(diamond && diamond.measurements);
    if (parts.length >= 2) return (parts[0] + parts[1]) / 2;
    return 0;
  }

  function getLengthWidthRatio(diamond) {
    var ratio = Number(diamond && diamond.lwRatio || 0);
    if (ratio > 0) return ratio;
    var parts = parseMeasurementParts(diamond && diamond.measurements);
    if (parts.length >= 2 && parts[1] > 0) return parts[0] / parts[1];
    return 0;
  }

  function getRatioRangeForShape(shape) {
    var normalised = String(shape || '').toLowerCase();
    if (normalised === 'oval') return { min: 1.20, idealMin: 1.30, idealMax: 1.50, max: 1.70 };
    if (normalised === 'pear') return { min: 1.30, idealMin: 1.45, idealMax: 1.70, max: 1.95 };
    if (normalised === 'emerald') return { min: 1.15, idealMin: 1.30, idealMax: 1.45, max: 1.65 };
    if (normalised === 'marquise') return { min: 1.60, idealMin: 1.80, idealMax: 2.10, max: 2.30 };
    if (normalised === 'radiant') return { min: 1.00, idealMin: 1.10, idealMax: 1.30, max: 1.45 };
    if (normalised === 'cushion') return { min: 1.00, idealMin: 1.00, idealMax: 1.10, max: 1.25 };
    if (normalised === 'princess') return { min: 0.96, idealMin: 0.98, idealMax: 1.04, max: 1.10 };
    return { min: 0.96, idealMin: 0.98, idealMax: 1.03, max: 1.08 };
  }

  function getTableRangeForShape(shape) {
    var normalised = String(shape || '').toLowerCase();
    if (normalised === 'oval') return { min: 50, idealMin: 53, idealMax: 63, max: 70 };
    if (normalised === 'pear') return { min: 50, idealMin: 53, idealMax: 63, max: 70 };
    if (normalised === 'emerald') return { min: 55, idealMin: 61, idealMax: 69, max: 75 };
    if (normalised === 'marquise') return { min: 52, idealMin: 53, idealMax: 63, max: 70 };
    if (normalised === 'radiant') return { min: 55, idealMin: 61, idealMax: 69, max: 75 };
    if (normalised === 'cushion') return { min: 52, idealMin: 57, idealMax: 66, max: 72 };
    if (normalised === 'princess') return { min: 62, idealMin: 68, idealMax: 75, max: 80 };
    return { min: 50, idealMin: 54, idealMax: 61, max: 68 };
  }

  function getDepthRangeForShape(shape) {
    var normalised = String(shape || '').toLowerCase();
    if (normalised === 'oval') return { min: 56, idealMin: 59, idealMax: 63, max: 68 };
    if (normalised === 'pear') return { min: 54, idealMin: 58, idealMax: 64, max: 69 };
    if (normalised === 'emerald') return { min: 56, idealMin: 61, idealMax: 68, max: 74 };
    if (normalised === 'marquise') return { min: 54, idealMin: 58, idealMax: 64, max: 70 };
    if (normalised === 'radiant') return { min: 58, idealMin: 62, idealMax: 69, max: 74 };
    if (normalised === 'cushion') return { min: 58, idealMin: 62, idealMax: 68, max: 74 };
    if (normalised === 'princess') return { min: 62, idealMin: 68, idealMax: 75, max: 80 };
    return { min: 54, idealMin: 59, idealMax: 63, max: 68 };
  }

  function getMeasurementRangeForDiamond(diamond) {
    var carat = Number(diamond && diamond.carat || 0);
    var baseline = Math.max(3.2, Math.sqrt(Math.max(carat, 0.1)) * 6.1);
    return {
      min: Math.max(2.8, baseline - 1.2),
      idealMin: baseline - 0.35,
      idealMax: baseline + 0.35,
      max: baseline + 1.6
    };
  }

  function clampMetricValue(value, range) {
    return Math.min(range.max, Math.max(range.min, Number(value || 0)));
  }

  function metricPercent(value, range) {
    var min = Number(range.min || 0);
    var max = Number(range.max || 0);
    if (max <= min) return 50;
    return ((clampMetricValue(value, range) - min) / (max - min)) * 100;
  }

  function metricStatusCopy(value, range, withinCopy, lowCopy, highCopy) {
    if (!Number(value || 0)) return 'Live certificate value unavailable for this stone.';
    if (value < range.idealMin) return lowCopy;
    if (value > range.idealMax) return highCopy;
    return withinCopy;
  }

  function getCurrentValue(label, diamond) {
    switch (label) {
      case 'Cut Grade':
        return diamond && diamond.cut ? diamond.cut : '—';
      case 'L/W Ratio':
        return getLwRatio(diamond);
      case 'Measurements':
        return getMeasurementsDisplay(diamond);
      case 'Depth':
        return diamond && diamond.depthPct ? formatPercentValue(diamond.depthPct) : '—';
      case 'Table':
        return diamond && diamond.tablePct ? formatPercentValue(diamond.tablePct) : '—';
      case 'Symmetry':
        return diamond && diamond.symmetry ? diamond.symmetry : '—';
      case 'Polish':
        return diamond && diamond.polish ? diamond.polish : '—';
      default:
        return '—';
    }
  }

  function getCutGuideShapeKey(shape) {
    var key = String(shape || '').trim().toLowerCase();
    return DIAMOND_CUT_GUIDE[key] ? key : (key === 'round' ? 'round' : 'generic_fancy');
  }

  function valueWithinRange(value, min, max) {
    var n = Number(value);
    if (!Number.isFinite(n)) return false;
    return n >= Number(min) && n <= Number(max);
  }

  function isRoundCutGuideShape(shapeKey) {
    return shapeKey === 'round';
  }

  function buildCutGuideChips(diamond, shapeKey) {
    if (!diamond) return [];
    var chips = [];
    var ratio = getLengthWidthRatio(diamond);
    var depth = Number(diamond.depthPct || 0);
    var table = Number(diamond.tablePct || 0);
    var guide = DIAMOND_CUT_GUIDE[shapeKey] || DIAMOND_CUT_GUIDE.generic_fancy;
    var ratioRow = guide.table.find(function(row) { return row.label === 'L/W Ratio' && row.type === 'ratio'; });
    var depthRow = guide.table.find(function(row) { return row.label === 'Depth' && row.type === 'range'; });
    var tableRow = guide.table.find(function(row) { return row.label === 'Table' && row.type === 'range'; });
    var balancedProportions = !!(depthRow && tableRow && valueWithinRange(depth, depthRow.min, depthRow.max) && valueWithinRange(table, tableRow.min, tableRow.max));

    if (isRoundCutGuideShape(shapeKey)) {
      if (String(diamond.cut || '') === 'Excellent') chips.push('Excellent Cut');
      if (balancedProportions) chips.push('Balanced Proportions');
      if (String(diamond.symmetry || '') === 'Excellent') chips.push('Excellent Symmetry');
      if (String(diamond.polish || '') === 'Excellent') chips.push('Excellent Polish');
      return chips.slice(0, 2);
    }

    if (balancedProportions) chips.push('Balanced Proportions');
    if (ratioRow && valueWithinRange(ratio, ratioRow.min, ratioRow.max)) chips.push('Preferred L/W Ratio');
    if (String(diamond.symmetry || '') === 'Excellent') chips.push('Excellent Symmetry');
    if (String(diamond.polish || '') === 'Excellent') chips.push('Excellent Polish');
    else if (String(diamond.polish || '') === 'Very Good') chips.push('Very Good Polish');
    return chips.slice(0, 2);
  }

  function buildCutGuideRows(diamond) {
    var shapeKey = getCutGuideShapeKey(diamond && diamond.shape);
    var guide = DIAMOND_CUT_GUIDE[shapeKey] || DIAMOND_CUT_GUIDE.generic_fancy;
    return guide.table.map(function(row) {
      return {
        label: row.label,
        current: getCurrentValue(row.label, diamond),
        guide: row.guide,
        why: row.why
      };
    });
  }

  function buildCutGuideSummary(diamond, rows, shapeKey) {
    var guide = DIAMOND_CUT_GUIDE[shapeKey] || DIAMOND_CUT_GUIDE.generic_fancy;
    var chips = buildCutGuideChips(diamond, shapeKey);
    var shapeLabel = String(diamond && diamond.shape || 'diamond').toLowerCase();
    if (shapeKey === 'round') {
      if (!diamond || !diamond.cut) return 'This round diamond does not have enough Cut data available to place confidently against the general guide.';
      if (chips.indexOf('Excellent Cut') > -1 && chips.indexOf('Balanced Proportions') > -1) return 'This round diamond sits within the preferred cut range for strong brightness and sparkle.';
      if (chips.indexOf('Excellent Cut') > -1 || chips.indexOf('Balanced Proportions') > -1) return 'This round diamond shows strong cut signals and can be compared against the general guide below.';
      return 'This round diamond can be reviewed against the general guide below to understand how its cut-related factors compare.';
    }
    if (chips.indexOf('Balanced Proportions') > -1 || chips.indexOf('Preferred L/W Ratio') > -1) return 'This ' + shapeLabel + ' diamond sits within the general guide for balanced proportions and outline.';
    return 'This ' + shapeLabel + ' diamond can be reviewed against the general guide below to understand its cut-related balance.';
  }

  function buildCutGuideQuickTakeaway(diamond, shapeKey) {
    var chips = buildCutGuideChips(diamond, shapeKey);
    var shapeLabel = String(diamond && diamond.shape || 'diamond').toLowerCase();
    if (shapeKey === 'round') {
      if (chips.indexOf('Excellent Cut') > -1 && chips.indexOf('Balanced Proportions') > -1) return 'Quick takeaway: strong round cut signals for brightness, sparkle, and overall balance.';
      if (chips.indexOf('Excellent Cut') > -1) return 'Quick takeaway: the report shows a strong round cut grade, supported by the guide below.';
      if (chips.indexOf('Balanced Proportions') > -1) return 'Quick takeaway: the proportions sit in a balanced range for a round diamond.';
      return 'Quick takeaway: use the comparison below to judge how this round diamond’s cut-related factors sit against the general guide.';
    }
    if (chips.indexOf('Balanced Proportions') > -1 && chips.indexOf('Preferred L/W Ratio') > -1) return 'Quick takeaway: this ' + shapeLabel + ' looks well balanced on both proportions and outline.';
    if (chips.indexOf('Balanced Proportions') > -1) return 'Quick takeaway: this ' + shapeLabel + ' sits in a balanced proportion range based on the report data.';
    if (chips.indexOf('Preferred L/W Ratio') > -1) return 'Quick takeaway: this ' + shapeLabel + ' has a preferred outline ratio for its shape.';
    return 'Quick takeaway: use this ' + shapeLabel + '\'s report measurements and finish factors as a guide to cut balance.';
  }

  function metricIconMarkup(type) {
    if (type === 'measurements') {
      return '<svg viewBox="0 0 44 44" fill="none" aria-hidden="true">' +
        '<rect x="9" y="11" width="26" height="22" rx="5" stroke="#caa96a" stroke-width="1.6"/>' +
        '<path d="M9 8h26M9 36h26" stroke="#b6afa2" stroke-width="1.4" stroke-linecap="round"/>' +
        '<path d="M6 11v22M38 11v22" stroke="#b6afa2" stroke-width="1.4" stroke-linecap="round"/>' +
        '<path d="M12 7l-3 3 3 3M32 7l3 3-3 3M7 14l3-3 3 3M7 30l3 3 3-3" stroke="#6f7b86" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';
    }
    if (type === 'ratio') {
      return '<svg viewBox="0 0 44 44" fill="none" aria-hidden="true">' +
        '<rect x="11" y="10" width="22" height="24" rx="11" stroke="#caa96a" stroke-width="1.6"/>' +
        '<path d="M8 22h28" stroke="#6f7b86" stroke-width="1.5" stroke-linecap="round"/>' +
        '<path d="M22 7v30" stroke="#b6afa2" stroke-width="1.5" stroke-linecap="round"/>' +
        '<path d="M8 22l3-3M8 22l3 3M36 22l-3-3M36 22l-3 3" stroke="#6f7b86" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';
    }
    if (type === 'table') {
      return '<svg viewBox="0 0 44 44" fill="none" aria-hidden="true">' +
        '<polygon points="22,7 33,16 28,31 16,31 11,16" fill="rgba(255,255,255,.78)" stroke="#caa96a" stroke-width="1.6"/>' +
        '<path d="M16 15h12" stroke="#6f7b86" stroke-width="1.5" stroke-linecap="round"/>' +
        '<path d="M13 12l3 3 3-3M31 12l-3 3-3-3" stroke="#6f7b86" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';
    }
    if (type === 'cut-grade') {
      return '<svg viewBox="0 0 44 44" fill="none" aria-hidden="true">' +
        '<path d="M22 7l4.6 9.2 10.2 1.5-7.4 7.2 1.8 10.1L22 30.3 12.8 35l1.8-10.1-7.4-7.2 10.2-1.5L22 7Z" fill="rgba(201,169,110,.18)" stroke="#caa96a" stroke-width="1.6" stroke-linejoin="round"/>' +
      '</svg>';
    }
    if (type === 'symmetry') {
      return '<svg viewBox="0 0 44 44" fill="none" aria-hidden="true">' +
        '<path d="M22 8v28M9 22h26" stroke="#6f7b86" stroke-width="1.5" stroke-linecap="round"/>' +
        '<polygon points="22,10 31,22 22,34 13,22" fill="rgba(201,169,110,.18)" stroke="#caa96a" stroke-width="1.6"/>' +
      '</svg>';
    }
    if (type === 'polish') {
      return '<svg viewBox="0 0 44 44" fill="none" aria-hidden="true">' +
        '<circle cx="22" cy="22" r="10" fill="rgba(201,169,110,.18)" stroke="#caa96a" stroke-width="1.6"/>' +
        '<path d="M22 12v20M12 22h20" stroke="#6f7b86" stroke-width="1.5" stroke-linecap="round"/>' +
      '</svg>';
    }
    return '<svg viewBox="0 0 44 44" fill="none" aria-hidden="true">' +
      '<polygon points="22,7 33,16 28,31 16,31 11,16" fill="rgba(255,255,255,.78)" stroke="#caa96a" stroke-width="1.6"/>' +
      '<path d="M22 11v20" stroke="#6f7b86" stroke-width="1.5" stroke-linecap="round"/>' +
      '<path d="M18 13l4-4 4 4M18 29l4 4 4-4" stroke="#6f7b86" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';
  }

  function renderCutMetricCards(diamond) {
    if (!diamond) return '';
    var shapeKey = getCutGuideShapeKey(diamond.shape);
    var guide = DIAMOND_CUT_GUIDE[shapeKey] || DIAMOND_CUT_GUIDE.generic_fancy;
    var isRound = shapeKey === 'round';
    var rows = buildCutGuideRows(diamond);
    var chips = buildCutGuideChips(diamond, shapeKey);
    var quickTakeaway = buildCutGuideQuickTakeaway(diamond, shapeKey);
    var summary = buildCutGuideSummary(diamond, rows, shapeKey);
    var note = guide.note || GLOBAL_CUT_GUIDE_NOTE;
    return '' +
      (isRound ? (
        '<div class="jir-gdg-cut-summary">' +
          '<div class="jir-gdg-cut-summary-title">' + escapeHtml(guide.title) + '</div>' +
          '<div class="jir-gdg-cut-summary-body">' + escapeHtml(guide.intro) + '</div>' +
        '</div>'
      ) : '') +
      '<div class="jir-cut-guide-takeaway">' + escapeHtml(quickTakeaway) + '</div>' +
      (chips.length ? (
        '<div class="jir-cut-guide-chips">' +
          chips.map(function(chip) {
            return '<span class="jir-cut-guide-chip">' + escapeHtml(chip) + '</span>';
          }).join('') +
        '</div>'
      ) : '') +
      '<div class="jir-cut-guide-table-wrap">' +
        '<table class="jir-cut-guide-table" role="table" aria-label="Cut guide comparison">' +
          '<thead><tr>' +
            '<th>Factor</th><th>This diamond</th><th>General guide</th><th>What it means</th>' +
          '</tr></thead>' +
          '<tbody>' +
            rows.map(function(row) {
              return '' +
                '<tr>' +
                  '<td class="jir-cut-guide-factor">' + escapeHtml(row.label) + '</td>' +
                  '<td class="jir-cut-guide-current">' +
                    '<span class="jir-cut-guide-current-value">' + escapeHtml(row.current) + '</span>' +
                  '</td>' +
                  '<td class="jir-cut-guide-guide">' + escapeHtml(row.guide) + '</td>' +
                  '<td class="jir-cut-guide-why">' + escapeHtml(row.why) + '</td>' +
                '</tr>';
            }).join('') +
          '</tbody>' +
        '</table>' +
      '</div>' +
      '<div class="jir-cut-guide-cards">' +
        rows.map(function(row) {
          return '' +
            '<article class="jir-cut-guide-card">' +
              '<div class="jir-cut-guide-card-head">' +
                '<div class="jir-cut-guide-card-factor">' + escapeHtml(row.label) + '</div>' +
              '</div>' +
              '<div class="jir-cut-guide-card-grid">' +
                '<div class="jir-cut-guide-mini-label">This diamond</div>' +
                '<div class="jir-cut-guide-mini-value jir-cut-guide-mini-value-strong">' + escapeHtml(row.current) + '</div>' +
                '<div class="jir-cut-guide-mini-label">General guide</div>' +
                '<div class="jir-cut-guide-mini-value">' + escapeHtml(row.guide) + '</div>' +
                '<div class="jir-cut-guide-mini-label">What it means</div>' +
                '<div class="jir-cut-guide-mini-copy">' + escapeHtml(row.why) + '</div>' +
              '</div>' +
            '</article>';
        }).join('') +
      '</div>' +
      '<div class="jir-cut-guide-summary-line">' + escapeHtml(summary) + '</div>' +
      '<div class="jir-cut-guide-note">' + escapeHtml(note) + '</div>';
  }

  function getGuideItems(type) {
    if (type === 'carat') return getGuideCaratItems();
    if (type === 'colour') return getGuideColourItems();
    if (type === 'clarity') return getGuideClarityItems();
    return getGuideCutItems();
  }

  function getGuideSelectionKey(type, diamond) {
    if (!diamond) return null;
    if (type === 'carat') {
      var items = getGuideCaratItems();
      var carat = Number(diamond.carat || 0);
      var nearest = items.reduce(function(best, item) {
        var delta = Math.abs(Number(item.key) - carat);
        if (!best || delta < best.delta) return { key: item.key, delta: delta };
        return best;
      }, null);
      return nearest ? nearest.key : items[0].key;
    }
    if (type === 'colour') return String(diamond.color || '').toUpperCase();
    if (type === 'clarity') return String(diamond.clarity || '').toUpperCase();
    return String(diamond.cut || '');
  }

  function interpolateGuidePercent(values, actualValue) {
    var nums = (values || []).map(function(value) { return Number(value); }).filter(function(value) {
      return Number.isFinite(value);
    });
    if (!nums.length) return 50;
    if (nums.length === 1) return 50;
    var actual = Number(actualValue);
    if (!Number.isFinite(actual)) return 0;
    if (actual <= nums[0]) return 0;
    if (actual >= nums[nums.length - 1]) return 100;

    for (var i = 0; i < nums.length - 1; i += 1) {
      var from = nums[i];
      var to = nums[i + 1];
      if (actual >= from && actual <= to) {
        var local = to > from ? ((actual - from) / (to - from)) : 0;
        return ((i + local) / (nums.length - 1)) * 100;
      }
    }
    return 0;
  }

  function getGuidePositionPercent(type, diamond, items, fallbackIndex) {
    if (!diamond || !items || !items.length) return 50;
    if (type === 'carat') {
      return interpolateGuidePercent(items.map(function(item) { return item.key; }), Number(diamond.carat || 0));
    }
    if (fallbackIndex <= 0) return 0;
    if (fallbackIndex >= items.length - 1) return 100;
    return (fallbackIndex / (items.length - 1)) * 100;
  }

  function getGuidePercentForIndex(type, diamond, items, index, hasExplicitSelection) {
    if (hasExplicitSelection) {
      if (!items || items.length <= 1) return 50;
      if (index <= 0) return 0;
      if (index >= items.length - 1) return 100;
      return (index / (items.length - 1)) * 100;
    }
    return getGuidePositionPercent(type, diamond, items, index);
  }

  function getGuideDisplayLabel(type, diamond, active, hasExplicitSelection) {
    if (type === 'carat' && !hasExplicitSelection && diamond) {
      var caratValue = Number(diamond.carat || 0);
      if (!Number.isFinite(caratValue) || caratValue <= 0) return '—';
      if (Math.abs(caratValue - Math.round(caratValue)) < 0.001) return caratValue.toFixed(1) + 'ct';
      if (Math.abs(caratValue * 10 - Math.round(caratValue * 10)) < 0.001) return caratValue.toFixed(1) + 'ct';
      return caratValue.toFixed(2) + 'ct';
    }
    return active && active.label ? active.label : '—';
  }

  function guideVisualMarkup(type, item, diamond) {
    var uploadedGuide = getGuideStopImage(type, item) || getGuideFallbackImage(type);
    if (uploadedGuide) {
      var caption = type === 'carat'
        ? 'Diamond presence at this weight'
        : type === 'colour'
          ? 'Colour appearance guide for grade ' + escapeHtml(item.label)
          : type === 'clarity'
            ? 'Illustrative inclusion visibility at ' + escapeHtml(item.label)
            : 'Indicative brilliance pattern for ' + escapeHtml(item.label) + ' cut';
      return '<div class="jir-gdg-visual-inner">' +
        themeImageMarkup(uploadedGuide, type + ' guide', 'jir-gdg-visual-asset') +
        '<div class="jir-gdg-caption">' + caption + '</div>' +
      '</div>';
    }
    if (type === 'carat') return '';
    if (type === 'colour') {
      return '<div class="jir-gdg-visual-inner">' +
        '<svg class="jir-gdg-colour-svg" viewBox="0 0 240 220" fill="none" aria-hidden="true">' +
          '<polygon points="120,14 206,90 120,206 34,90" fill="' + escapeHtml(item.tone || '#fff') + '" stroke="#b8b8b8" stroke-width="2"/>' +
          '<line x1="120" y1="14" x2="120" y2="206" stroke="#b8b8b8" stroke-width="2"/>' +
          '<line x1="34" y1="90" x2="206" y2="90" stroke="#b8b8b8" stroke-width="2"/>' +
          '<line x1="77" y1="52" x2="120" y2="90" stroke="#b8b8b8" stroke-width="2"/>' +
          '<line x1="163" y1="52" x2="120" y2="90" stroke="#b8b8b8" stroke-width="2"/>' +
          '<line x1="77" y1="52" x2="34" y2="90" stroke="#b8b8b8" stroke-width="2"/>' +
          '<line x1="163" y1="52" x2="206" y2="90" stroke="#b8b8b8" stroke-width="2"/>' +
        '</svg>' +
        '<div class="jir-gdg-caption">Colour appearance guide for grade ' + escapeHtml(item.label) + '</div>' +
      '</div>';
    }
    if (type === 'clarity') {
      var dots = '';
      var count = Number(item.inclusions || 0);
      for (var i = 0; i < count; i += 1) {
        dots += '<circle cx="' + (110 + (i * 12 % 40)) + '" cy="' + (120 + (i * 9 % 34)) + '" r="2.2" fill="#6b7488"/>';
      }
      return '<div class="jir-gdg-visual-inner">' +
        '<svg class="jir-gdg-clarity-svg" viewBox="0 0 260 220" fill="none" aria-hidden="true">' +
          '<polygon points="90,28 160,28 208,104 130,184 52,104" stroke="#b8b8b8" stroke-width="2"/>' +
          '<circle cx="166" cy="114" r="54" class="jir-gdg-clarity-focus"/>' +
          '<line x1="202" y1="150" x2="228" y2="176" stroke="#73b9da" stroke-width="4"/>' +
          dots +
        '</svg>' +
        '<div class="jir-gdg-caption">Illustrative inclusion visibility at ' + escapeHtml(item.label) + '</div>' +
      '</div>';
    }
    var rays = '';
    var rayCount = Number(item.rays || 10);
    for (var j = 0; j < rayCount; j += 1) {
      var angle = (Math.PI * 2 * j) / rayCount;
      var x2 = 130 + Math.cos(angle) * 88;
      var y2 = 110 + Math.sin(angle) * 88;
      rays += '<line x1="130" y1="110" x2="' + x2.toFixed(1) + '" y2="' + y2.toFixed(1) + '"></line>';
    }
    return '<div class="jir-gdg-visual-inner">' +
      '<svg class="jir-gdg-cut-svg" viewBox="0 0 260 220" fill="none" aria-hidden="true">' +
        '<g class="jir-gdg-cut-rays">' + rays + '</g>' +
        '<polygon points="130,28 190,80 170,146 90,146 70,80" fill="rgba(255,255,255,.78)" stroke="#caa96a" stroke-width="2"/>' +
        '<polygon points="90,146 170,146 130,192" fill="rgba(201,169,110,.16)" stroke="#caa96a" stroke-width="2"/>' +
      '</svg>' +
      '<div class="jir-gdg-caption">Indicative brilliance pattern for ' + escapeHtml(item.label) + ' cut</div>' +
    '</div>';
  }

  function renderDiamondGuidePanel(type) {
    var panel = el('jir-gdg-panel');
    if (!panel || !S.diamond) return;
    if (type === 'cut') {
      var cutShapeKey = getCutGuideShapeKey(S.diamond.shape);
      if (cutShapeKey !== 'round') {
        var shapeName = String(S.diamond.shape || 'This diamond');
        panel.innerHTML = '' +
          '<div class="jir-gdg-title">' + escapeHtml('Cut for ' + shapeName) + '</div>' +
          '<div class="jir-gdg-body jir-gdg-cut-direct">' +
            '<div class="jir-gdg-copy">' + escapeHtml(shapeName + ' diamonds do not receive an official cut grade on the report. Instead, use L/W ratio, measurements, depth, table, symmetry, and polish to judge shape balance and finish.') + '</div>' +
          '</div>' +
          renderCutMetricCards(S.diamond);
        return;
      }
    }
    var items = getGuideItems(type);
    var hasExplicitSelection = Object.prototype.hasOwnProperty.call(S.gradeGuideState, type);
    var selectedKey = hasExplicitSelection ? S.gradeGuideState[type] : getGuideSelectionKey(type, S.diamond);
    var index = items.findIndex(function(item) { return item.key === selectedKey; });
    if (index < 0) index = 0;
    var active = items[index];
    var leftPct = getGuidePercentForIndex(type, S.diamond, items, index, hasExplicitSelection);
    var fillPct = leftPct;
    var badgeLabel = getGuideDisplayLabel(type, S.diamond, active, hasExplicitSelection);
    var intro = active.intro || '';
    var note = active.note || '';
    var visualMarkup = type === 'cut' ? '' : guideVisualMarkup(type, active, S.diamond);

    panel.innerHTML = '' +
      '<div class="jir-gdg-title">' + escapeHtml(
        type === 'carat' ? ('Carat: ' + Number(S.diamond.carat || 0).toFixed(2) + 'ct') :
        type === 'colour' ? ('Colour: ' + String(S.diamond.color || '—')) :
        type === 'clarity' ? ('Clarity: ' + String(S.diamond.clarity || '—')) :
        ('Cut: ' + String(S.diamond.cut || '—'))
      ) + '</div>' +
      '<div class="jir-gdg-body">' +
        '<div class="jir-gdg-copy">' + escapeHtml(intro) + '</div>' +
        '<div class="jir-gdg-scale">' +
          '<div class="jir-gdg-track-wrap">' +
            '<div class="jir-gdg-indicator" style="--left:' + leftPct + '%;">' +
              '<div class="jir-gdg-pill" data-gdg-badge-label="true">' + escapeHtml(badgeLabel) + '</div>' +
              '<div class="jir-gdg-indicator-line"></div>' +
            '</div>' +
            '<div class="jir-gdg-track" style="--left:' + leftPct + '%;--fill:' + fillPct + '%;">' +
              '<div class="jir-gdg-track-fill"></div>' +
            '</div>' +
            '<div class="jir-gdg-handle" style="--left:' + leftPct + '%;"></div>' +
            '<input class="jir-gdg-range" type="range" min="0" max="' + Math.max(items.length - 1, 0) + '" step="1" value="' + index + '" aria-label="' + escapeHtml(type) + ' guide slider">' +
          '</div>' +
          '<div class="jir-gdg-steps">' +
            items.map(function(item, itemIndex) {
              var itemLeft = items.length > 1 ? ((itemIndex / (items.length - 1)) * 100) : 50;
              return '<button class="jir-gdg-step' + (item.key === active.key ? ' jir-on' : '') + '" style="--left:' + itemLeft + '%;" type="button" data-gdg-type="' + escapeHtml(type) + '" data-gdg-key="' + escapeHtml(item.key) + '">' + escapeHtml(item.label) + '</button>';
            }).join('') +
          '</div>' +
        '</div>' +
        '<div class="jir-gdg-note" data-gdg-note="true">' + escapeHtml(note) + '</div>' +
        (visualMarkup ? '<div class="jir-gdg-visual" data-gdg-visual="true">' + visualMarkup + '</div>' : '') +
      '</div>' +
      (type === 'cut' ? renderCutMetricCards(S.diamond) : '');

    function syncGuideUI(nextIndex, explicitSelection) {
      var safeIndex = Math.max(0, Math.min(items.length - 1, Number(nextIndex || 0)));
      var nextActive = items[safeIndex];
      if (!nextActive) return;
      S.gradeGuideState[type] = nextActive.key;
      var nextPct = getGuidePercentForIndex(type, S.diamond, items, safeIndex, !!explicitSelection);
      var nextLabel = getGuideDisplayLabel(type, S.diamond, nextActive, !!explicitSelection);
      var indicator = panel.querySelector('.jir-gdg-indicator');
      var track = panel.querySelector('.jir-gdg-track');
      var handle = panel.querySelector('.jir-gdg-handle');
      var badge = panel.querySelector('[data-gdg-badge-label="true"]');
      var noteNode = panel.querySelector('[data-gdg-note="true"]');
      var visualNode = panel.querySelector('[data-gdg-visual="true"]');
      var rangeNode = panel.querySelector('.jir-gdg-range');
      if (indicator) indicator.style.setProperty('--left', nextPct + '%');
      if (track) {
        track.style.setProperty('--left', nextPct + '%');
        track.style.setProperty('--fill', nextPct + '%');
      }
      if (handle) handle.style.setProperty('--left', nextPct + '%');
      if (badge) badge.textContent = nextLabel;
      if (noteNode) noteNode.textContent = nextActive.note || '';
      if (visualNode) visualNode.innerHTML = type === 'cut' ? '' : guideVisualMarkup(type, nextActive, S.diamond);
      if (rangeNode && Number(rangeNode.value) !== safeIndex) rangeNode.value = String(safeIndex);
      panel.querySelectorAll('.jir-gdg-step').forEach(function(btn, btnIndex) {
        btn.classList.toggle('jir-on', btnIndex === safeIndex);
      });
    }

    var range = panel.querySelector('.jir-gdg-range');
    var trackWrap = panel.querySelector('.jir-gdg-track-wrap');
    var handleNode = panel.querySelector('.jir-gdg-handle');
    var indicatorNode = panel.querySelector('.jir-gdg-indicator');

    function getGuideIndexFromClientX(clientX) {
      if (!trackWrap || !items.length) return 0;
      var rect = trackWrap.getBoundingClientRect();
      if (!rect.width) return 0;
      var ratio = (clientX - rect.left) / rect.width;
      ratio = Math.max(0, Math.min(1, ratio));
      return Math.round(ratio * Math.max(items.length - 1, 0));
    }

    function bindGuidePointerDrag(node) {
      if (!node) return;
      node.addEventListener('pointerdown', function(event) {
        if (!items.length) return;
        if (event.cancelable) event.preventDefault();
        var pointerId = event.pointerId;
        syncGuideUI(getGuideIndexFromClientX(event.clientX), true);
        function handleMove(moveEvent) {
          if (moveEvent.pointerId !== pointerId) return;
          syncGuideUI(getGuideIndexFromClientX(moveEvent.clientX), true);
        }
        function handleEnd(endEvent) {
          if (endEvent.pointerId !== pointerId) return;
          window.removeEventListener('pointermove', handleMove);
          window.removeEventListener('pointerup', handleEnd);
          window.removeEventListener('pointercancel', handleEnd);
        }
        window.addEventListener('pointermove', handleMove);
        window.addEventListener('pointerup', handleEnd);
        window.addEventListener('pointercancel', handleEnd);
      });
    }

    if (range) {
      bindGuidePointerDrag(range);
      range.addEventListener('input', function() {
        var nextIndex = Math.max(0, Math.min(items.length - 1, Number(this.value || 0)));
        syncGuideUI(nextIndex, true);
      });
    }
    bindGuidePointerDrag(trackWrap);
    bindGuidePointerDrag(handleNode);
    bindGuidePointerDrag(indicatorNode);

    panel.querySelectorAll('.jir-gdg-step').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var nextIndex = items.findIndex(function(item) { return item.key === btn.dataset.gdgKey; });
        if (nextIndex < 0) return;
        syncGuideUI(nextIndex, true);
      });
    });
  }

  function renderDiamondGuideTabs(activeType) {
    var tabs = el('jir-gdg-tabs');
    if (!tabs || !S.diamond) return;
    activeType = activeType || 'carat';
    tabs.innerHTML = DETAIL_GUIDE_ORDER.map(function(type) {
      var label = type === 'carat' ? 'Carat' : (type === 'colour' ? 'Colour' : (type === 'clarity' ? 'Clarity' : 'Cut'));
      return '<button class="jir-gdg-tab' + (type === activeType ? ' jir-on' : '') + '" type="button" role="tab" data-gdg-tab="' + escapeHtml(type) + '" aria-selected="' + (type === activeType ? 'true' : 'false') + '">' + escapeHtml(label) + '</button>';
    }).join('');
    tabs.querySelectorAll('.jir-gdg-tab').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var type = this.dataset.gdgTab;
        tabs.querySelectorAll('.jir-gdg-tab').forEach(function(tab) {
          tab.classList.toggle('jir-on', tab.dataset.gdgTab === type);
          tab.setAttribute('aria-selected', tab.dataset.gdgTab === type ? 'true' : 'false');
        });
        renderDiamondGuidePanel(type);
      });
    });
    renderDiamondGuidePanel(activeType);
  }

  function renderSpecGrid(d) {
    var grid = el('jir-spec-grid');
    if (!grid) return;
    var isRound = String(d && d.shape || '').toLowerCase() === 'round';
    var rows = [
      ['Shape', d.shape, 'grade'],
      ['Cut', isRound ? expandGrade(d.cut) : 'Not graded', 'grade'],
      ['Polish', expandGrade(d.polish), 'grade'],
      ['Symmetry', expandGrade(d.symmetry), 'grade'],
      ['Colour', d.color, 'grade'],
      ['Clarity', d.clarity, 'grade'],
      ['Measurements', formatMeasurements(d.measurements), 'numeric'],
      ['L/W Ratio', getLengthWidthRatio(d) ? getLengthWidthRatio(d).toFixed(2) : '—', 'numeric'],
      ['Table', formatPercentValue(d.tablePct), 'numeric'],
      ['Depth', formatPercentValue(d.depthPct), 'numeric'],
      ['Certificate', d.lab, 'grade'],
      ['Cert. Number', getMaskedCertificateNumber(d.certNo), 'cert-num']
    ];
    grid.innerHTML = rows.map(function(row) {
      return '<div class="jir-sg-cell"><div class="jir-sg-lbl">' + escapeHtml(row[0]) + '</div><div class="jir-sg-val ' + escapeHtml(row[2]) + '">' + escapeHtml(row[1]) + '</div></div>';
    }).join('');
  }

  function saveBuildToURL() {
    if (!S.setting || !S.diamond) return;
    try {
      var buildState = { settingId: S.setting.id, metal: S.metal, shape: S.shape, size: S.size, profile: S.profile, diamondId: S.diamond.diamondId || S.diamond.nivodaId };
      var encoded = btoa(JSON.stringify(buildState));
      var url = new URL(window.location.href);
      url.searchParams.set(BUILD_PARAM, encoded);
      window.history.replaceState({}, '', url.toString());
      writeBuildSnapshot(buildState, S.diamond);
    } catch (e) { console.warn('[JIR] Failed to save build:', e); }
  }

  function clearBuildFromURL() {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has(BUILD_PARAM)) return;
      url.searchParams.delete(BUILD_PARAM);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}
  }

  function restoreBuildFromURL() {
    var params  = new URLSearchParams(window.location.search);
    var encoded = params.get(BUILD_PARAM);
    if (!encoded) return false;
    try {
      var state = JSON.parse(atob(encoded));
      if (!state || !state.settingId) return false;
      var sessionState = getAppSessionState();
      var sameSessionBuild = !!(
        sessionState &&
        sessionState.page &&
        sessionState.page !== 'landing' &&
        String(sessionState.settingId || '') === String(state.settingId || '') &&
        String(sessionState.diamondId || '') === String(state.diamondId || '')
      );
      /* The build URL identifies the selected ring, but the session identifies
       * the page the customer is actively browsing. Preserve that page on
       * refresh when both refer to the same build. */
      if (sameSessionBuild && restoreAppSessionState()) return true;
      var restoreToken = S.pendingRestoreToken + 1;
      S.pendingRestore = { settingId: state.settingId, metal: state.metal || null, shape: state.shape || null, size: state.size || null, profile: state.profile || 'Standard', diamondId: state.diamondId || null };
      S.pendingRestoreToken = restoreToken;
      var setting = S.settings.find(function(s) { return String(s.id) === String(state.settingId); });
      if (setting) {
        var cachedDiamond = readBuildSnapshot(state);
        selectSetting(state.settingId, { preserveState: true, metal: state.metal, shape: state.shape, size: state.size, profile: state.profile, diamondId: state.diamondId, restorePage: state.diamondId ? 'dpdp' : 'pdp' });
        if (cachedDiamond && state.diamondId && S.pendingRestoreToken === restoreToken && S.pendingRestore && String(S.pendingRestore.diamondId) === String(state.diamondId)) {
          hydrateDiamondDetailFromRecord(cachedDiamond);
        }
        if (state.diamondId) {
          fetchDiamondById(state.diamondId).then(function(diamond) {
            if (S.pendingRestoreToken !== restoreToken) return;
            if (!S.pendingRestore || String(S.pendingRestore.diamondId) !== String(state.diamondId)) return;
            if (!diamond) return;
            hydrateDiamondDetailFromRecord(diamond);
            S.pendingRestore = null;
          });
        } else {
          cancelPendingRestore();
        }
        return true;
      }
    } catch (e) { console.warn('[JIR] Could not restore build:', e); }
    return false;
  }

  function restorePendingDiamondIfPossible() {
    if (!S.pendingRestore || !S.pendingRestore.diamondId) return;
    var idx = S.filteredDiamonds.findIndex(function(d) {
      return String(d.diamondId || d.nivodaId || '') === String(S.pendingRestore.diamondId);
    });
    if (idx > -1) { selectDiamond(idx); cancelPendingRestore(); }
  }

  function checkDiamondAvailability(diamondId) {
    if (!CFG.proxyUrl || !diamondId) return Promise.resolve(true);
    return fetch(CFG.proxyUrl + '/diamonds/check', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Shop-Domain': getShopDomain(), 'x-jir-token': CFG.proxyToken || '' },
      body: JSON.stringify({ diamondId: diamondId, nivodaId: diamondId })
    }).then(function(r) { if (!r.ok) throw new Error('check failed'); return r.json(); })
    .then(function(d) { return d.available !== false; })
    .catch(function() { return false; });
  }

  function formatCentsNaked(cents) {
    return new Intl.NumberFormat(CFG.locale || 'en-AU', { style: 'currency', currency: CFG.currency || 'AUD', minimumFractionDigits: 0 }).format((Number(cents) || 0) / 100);
  }

  function formatAddToCartLabel(totalCents) {
    return totalCents ? ('Add Complete Ring to Cart \u2014 ' + fmtPrice(totalCents)) : 'Add Complete Ring to Cart';
  }

  function diamondTitleMarkup(diamond) {
    if (!diamond) return 'Diamond';
    var carat = Number(diamond.carat || 0);
    var caratText = Number.isFinite(carat) && carat > 0
      ? carat.toFixed(2).replace(/\.00$/, '').replace(/(\.\d)0$/, '$1') + 'ct'
      : '';
    var shapeText = [String(diamond.shape || '').trim(), 'Brilliant'].filter(Boolean).join(' ');
    return escapeHtml(caratText) + ' <em>' + escapeHtml(shapeText) + '</em>';
  }

  function getDiamondSummaryLine(diamond) {
    if (!diamond) return 'Diamond summary';
    var parts = [
      Number(diamond.carat || 0).toFixed(2).replace(/\.00$/, '').replace(/(\.\d)0$/, '$1') + 'ct',
      String(diamond.clarity || '').trim(),
      String(diamond.color || '').trim()
    ].filter(Boolean);
    var summary = parts.join(' ');
    var shape = String(diamond.shape || '').trim();
    return shape ? (summary + ' · ' + shape) : summary;
  }

  function getStickyRingSummaryLine(diamond) {
    if (!diamond) return 'Ring summary';
    var carat = Number(diamond.carat || 0);
    var caratText = Number.isFinite(carat) && carat > 0
      ? carat.toFixed(2).replace(/\.00$/, '').replace(/(\.\d)0$/, '$1') + 'ct'
      : '';
    var shape = String(diamond.shape || '').trim();
    var diamondShort = [caratText, shape].filter(Boolean).join(' ');
    return [
      S.setting && S.setting.name ? String(S.setting.name).trim() : '',
      S.metal ? String(S.metal).trim() : '',
      diamondShort
    ].filter(Boolean).join(' · ') || 'Ring summary';
  }

  function formatCartDiamondTitle(diamond) {
    if (!diamond) return 'Selected Lab Grown Diamond';
    var carat = Number(diamond.carat || 0);
    var caratText = Number.isFinite(carat) && carat > 0
      ? carat.toFixed(2).replace(/\.00$/, '').replace(/(\.\d)0$/, '$1') + 'ct'
      : '';
    return [
      caratText,
      String(diamond.color || '').trim(),
      String(diamond.clarity || '').trim(),
      String(diamond.shape || '').trim() ? (String(diamond.shape || '').trim() + ' Lab Grown Diamond') : 'Lab Grown Diamond'
    ].filter(Boolean).join(' – ');
  }

  function getDiamondCartImage(diamond) {
    if (!diamond || typeof diamond !== 'object') return '';
    if (typeof diamond.imageUrl === 'string' && diamond.imageUrl.trim()) return diamond.imageUrl.trim();
    if (typeof diamond.image === 'string' && diamond.image.trim()) return diamond.image.trim();
    if (typeof diamond.image_url === 'string' && diamond.image_url.trim()) return diamond.image_url.trim();
    if (diamond.image && typeof diamond.image.url === 'string' && diamond.image.url.trim()) return diamond.image.url.trim();
    if (typeof diamond.thumbnailUrl === 'string' && diamond.thumbnailUrl.trim()) return diamond.thumbnailUrl.trim();
    if (typeof diamond.thumbnail === 'string' && diamond.thumbnail.trim()) return diamond.thumbnail.trim();
    return '';
  }

  function updateAddToCartCtas(totalCents, overrideText) {
    var label = overrideText || formatAddToCartLabel(totalCents);
    setText('jir-add-txt', label);
    var stickyAdd = el('jir-dpdp-sticky-add');
    if (stickyAdd) stickyAdd.textContent = overrideText || 'Add Complete Ring to Cart';
  }

  function updateDecisionModeUI() {
    var mode = S.decisionMode || 'exact';
    var totalCents = S.diamond ? Number(S.diamond.price || 0) + Math.round(Number(S.metalP || 0) * 100) : 0;
    if (mode === 'team') {
      updateAddToCartCtas(totalCents, 'Find My Perfect Stone');
      setText('jir-ph-finance', 'We will review available inventory and recommend the most suitable stone options for your design.');
      return;
    }
    updateAddToCartCtas(totalCents);
    setText('jir-ph-finance', 'This exact stone will be locked into your design.');
  }

  function renderPriceBreakdown(diamond) {
    if (!diamond) return;
    var settingCents = Math.round(Number(S.metalP || 0) * 100);
    var diamondCents = Number(diamond.price || 0);
    var totalCents = settingCents + diamondCents;
    var settingPct = totalCents > 0 ? Math.max(0, Math.min(100, (settingCents / totalCents) * 100)) : 0;
    var goldBar = q('.jir-ph-breakdown-bar-gold');
    var restBar = q('.jir-ph-breakdown-bar-rest');
    setText('jir-ph-setting-price', fmtPrice(settingCents));
    setText('jir-ph-diamond-price', fmtPrice(diamondCents));
    setText('jir-ph-total-price', fmtPrice(totalCents));
    setText('jir-ph-finance', 'Flexible payment options available at checkout');
    if (goldBar) goldBar.style.width = settingPct.toFixed(1) + '%';
    if (restBar) restBar.style.width = (100 - settingPct).toFixed(1) + '%';
  }

  function renderStickyDiamondSummary(diamond) {
    if (!diamond) return;
    var totalCents = Number(diamond.price || 0) + Math.round(Number(S.metalP || 0) * 100);
    setText('jir-dpdp-sticky-summary', getStickyRingSummaryLine(diamond));
    setText('jir-dpdp-sticky-price', fmtPrice(totalCents));
  }

  function toggleBreakdown(forceOpen) {
    var panel = el('jir-ph-breakdown');
    var btn = el('jir-ph-breakdown-toggle');
    if (!panel || !btn) return;
    var willOpen = typeof forceOpen === 'boolean' ? forceOpen : panel.hidden;
    panel.hidden = !willOpen;
    btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  }

  function toggleGuideAccordion(forceOpen) {
    return;
  }

  function syncMobileStickyBars() {
    var pdpBar = el('jir-pdp-sticky-cta');
    var dpdpBar = el('jir-dpdp-sticky-cta');
    if (window.innerWidth > 768) {
      if (pdpBar) pdpBar.classList.remove('jir-show');
      if (dpdpBar) dpdpBar.classList.remove('jir-show');
      return;
    }
    if (pdpBar) pdpBar.classList.remove('jir-show');
    if (dpdpBar) dpdpBar.classList.remove('jir-show');
    if (S.currentPage === 'dpdp' && dpdpBar) {
      dpdpBar.classList.add('jir-show');
    }
  }

  function sanitizeGlobalFooterUI() {
    qAll('footer a, footer p, footer div, footer span, footer small, footer li').forEach(function(node) {
      var text = String(node.textContent || '').trim();
      var href = String(node.getAttribute && node.getAttribute('href') || '');
      if (!text && !href) return;
      if (/graphql/i.test(text) || /api explorer/i.test(text) || /graphql/i.test(href)) {
        node.style.display = 'none';
        return;
      }
      if (/©\s*2023/i.test(text)) {
        node.textContent = text.replace(/©\s*2023/ig, '© 2026');
      }
    });
  }

  function extractCartErrorMessage(err, fallback) {
    var defaultMsg = fallback || 'Could not add to cart. Please try again.';
    if (!err) return defaultMsg;
    if (typeof err === 'string') return err;
    if (err && typeof err.message === 'string' && err.message.trim()) return err.message.trim();
    if (err && typeof err.description === 'string' && err.description.trim()) return err.description.trim();
    return defaultMsg;
  }

  function validateCartVariantId(variantId, label) {
    var id = Number(variantId || 0);
    if (!id) return Promise.reject(new Error((label || 'Product') + ' variant is missing'));
    return fetch('/variants/' + id + '.js', {
      method: 'GET',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function(r) {
      if (!r.ok) throw new Error((label || 'Product') + ' variant could not be found');
      return r.json();
    });
  }

  function createTemporaryDiamondVariant(diamond) {
    if (!CFG.proxyUrl) return Promise.reject(new Error('Diamond cart service is not configured'));

    return fetch(String(CFG.proxyUrl).replace(/\/+$/, '') + '/shopify/diamond-variant', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Shop-Domain': getShopDomain(),
        'x-jir-token': CFG.proxyToken || ''
      },
      body: JSON.stringify({
        shopDomain: getShopDomain(),
        diamond: {
          diamondId: diamond.diamondId || diamond.nivodaId || ''
        }
      })
    }).then(function(response) {
      return response.text().then(function(text) {
        var data = {};
        try { data = text ? JSON.parse(text) : {}; } catch (err) { data = {}; }
        if (!response.ok) {
          throw new Error(data.detail || data.error || text || 'Could not create the selected diamond cart item');
        }
        if (!Number(data.variantId || 0)) {
          throw new Error('Diamond cart service did not return a valid Shopify variant');
        }
        return data;
      });
    });
  }

  function addToCart() {
    if (!S.setting) { showToast('Please complete your selection first'); return; }
    if (S.decisionMode === 'team') {
      trackBuilderEvent('expert_select_chosen', {});
      trackBuilderEvent('byor_team_pick_selected', {
        tier1_result_count: getRecommendedCount(),
        source: 'add_to_cart'
      });
      trackBuilderEvent('byor_let_team_choose_clicked', {
        tier1_result_count: getRecommendedCount(),
        source: 'add_to_cart'
      });
      trackBuilderEvent('stone_decision_completed', {
        selected_path: 'find_my_perfect_stone'
      });
      openEnquiry();
      return;
    }
    if (!S.diamond) { showToast('Please complete your selection first'); return; }
    var addBtn = el('jir-add-btn');
    var stickyAddBtn = el('jir-dpdp-sticky-add');
    if (addBtn) addBtn.disabled = true;
    if (stickyAddBtn) stickyAddBtn.disabled = true;
    updateAddToCartCtas(null, 'Validating availability…');
    trackBuilderEvent('stone_decision_completed', {
      selected_path: 'select_this_stone'
    });
    trackBuilderEvent('byor_checkout_started_or_deposit_requested', {
      decision_mode: S.decisionMode || 'exact',
      stone_id_hash: hashString(S.diamond && (S.diamond.diamondId || S.diamond.nivodaId || ''))
    });
    var buildRef   = 'JIBLD-' + Date.now().toString(36).toUpperCase();
    var diamondPriceCents = roundDisplayCents(Number(S.diamond.price || 0));
    var settingPriceCents = Math.round(Number(S.metalP || 0) * 100);
    var totalCents = diamondPriceCents + settingPriceCents;
    var settingVariantId = S.metalVariantId;
    var diamondVariantId = 0;
    var authoritativeDiamond = null;
    if (Number(S.diamond.price || 0) <= 0) {
      showToast('The selected diamond price could not be verified. Please choose the stone again.');
      if (addBtn) addBtn.disabled = false;
      if (stickyAddBtn) stickyAddBtn.disabled = false;
      updateAddToCartCtas(totalCents);
      return;
    }
    if (!settingVariantId) {
      showToast('Please select a valid metal option for this setting');
      if (addBtn) addBtn.disabled = false;
      if (stickyAddBtn) stickyAddBtn.disabled = false;
      updateAddToCartCtas(totalCents);
      return;
    }
    checkDiamondAvailability(S.diamond.diamondId || S.diamond.nivodaId)
    .then(function(available) {
      if (!available) {
        showToast(textCfg('stoneUnavailableFallback', 'This diamond is no longer available. We can help you choose the closest available option.'));
        trackBuilderEvent('byor_stone_validation_failed', {
          reason_code: 'unavailable',
          tier: S.selectedTier || 'recommended',
          stone_id_hash: hashString(S.diamond && (S.diamond.diamondId || S.diamond.nivodaId || ''))
        });
        goto('diamonds');
        if (addBtn) addBtn.disabled = false;
        if (stickyAddBtn) stickyAddBtn.disabled = false;
        updateAddToCartCtas(totalCents);
        return null;
      }
      return validateCartVariantId(settingVariantId, 'Setting')
      .then(function() {
        updateAddToCartCtas(totalCents, 'Preparing Diamond…');
        return createTemporaryDiamondVariant(S.diamond);
      })
      .then(function(diamondProduct) {
        authoritativeDiamond = diamondProduct;
        diamondVariantId = Number(diamondProduct.variantId || 0);
        diamondPriceCents = Number(diamondProduct.priceCents || 0);
        totalCents = diamondPriceCents + settingPriceCents;
        return validateCartVariantId(diamondVariantId, 'Selected diamond');
      })
      .then(function() {
        var combinedPriceDisplay = fmtPrice(totalCents);
        var diamondTitle = authoritativeDiamond.title || formatCartDiamondTitle(S.diamond);
        var diamondImage = authoritativeDiamond.imageUrl || getDiamondCartImage(S.diamond);
        var settingImage = S.setting && S.setting.image ? String(S.setting.image) : '';
        var settingTitle = S.setting && S.setting.name ? String(S.setting.name) : '';
        var settingSummary = [S.metal || '', S.size || 'To be confirmed'].filter(Boolean).join(' / ');
        var sharedProperties = {
          '_build_reference': buildRef,
          '_diamond_price_cents': diamondPriceCents,
          '_setting_price_cents': settingPriceCents,
          '_combined_price_display': combinedPriceDisplay,
          '_setting_title': settingTitle,
          '_setting_image': settingImage,
          '_setting_summary': settingSummary,
          '_diamond_title': diamondTitle,
          '_diamond_image': diamondImage
        };
        if (WINTER_CONTEXT.active) {
          sharedProperties._winter_sale_event = WINTER_CONTEXT.saleTag;
          sharedProperties._winter_sale_return = WINTER_CONTEXT.returnUrl;
        }
        var settingProperties = Object.assign({}, sharedProperties, {
          '_ring_component': 'setting',
          'Item': 'Setting',
          'Metal': S.metal,
          'Ring Size': S.size || 'To be confirmed',
          'Profile': S.profile,
          'Shape Compatibility': S.shape,
          'Lead Time': getSettingLeadTime(S.setting)
        });
        var diamondProperties = Object.assign({}, sharedProperties, {
          '_ring_component': 'diamond',
          '_nivoda_offer_id': authoritativeDiamond.offerId || '',
          '_nivoda_diamond_id': authoritativeDiamond.diamondId || '',
          'Item': 'Selected Diamond',
          'Diamond Title': diamondTitle,
          'Diamond Shape': S.diamond.shape,
          'Diamond Carat': S.diamond.carat + 'ct',
          'Diamond Colour': S.diamond.color,
          'Diamond Clarity': S.diamond.clarity,
          'Diamond Cut': S.diamond.cut,
          'Diamond Polish': S.diamond.polish,
          'Diamond Symmetry': S.diamond.symmetry,
          'Certificate Lab': S.diamond.lab,
          'Certificate Number': getMaskedCertificateNumber(S.diamond.certNo)
        });
        updateAddToCartCtas(totalCents, 'Adding Complete Ring…');
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            items: [
              { id: settingVariantId, quantity: 1, properties: settingProperties },
              { id: diamondVariantId, quantity: 1, properties: diamondProperties }
            ]
          })
        });
      });
    })
    .then(function(response) {
      if (!response) return null;
      if (!response.ok) return response.text().then(function(text) { throw new Error(text || 'Could not add ring build to cart'); });
      return response.json();
    })
    .then(function(data) {
      if (!data) return;
      updateAddToCartCtas(totalCents, '✓ Complete Ring Added');
      trackBuilderEvent('builder_add_to_cart', {
        estimated_price: fmtPrice(totalCents),
        selected_stone_id: S.diamond ? (S.diamond.diamondId || S.diamond.nivodaId || '') : ''
      });
      if (window.JIRContinueShoppingMemory && typeof window.JIRContinueShoppingMemory.setUrl === 'function') {
        window.JIRContinueShoppingMemory.setUrl(WINTER_CONTEXT.active ? WINTER_CONTEXT.returnUrl : '/pages/build-your-own');
      }
      showToast('Ring build added to cart');
      return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function(cartResponse) {
          if (!cartResponse.ok) throw new Error('Could not refresh cart');
          return cartResponse.json();
        })
        .then(function(cart) {
          document.dispatchEvent(new CustomEvent('theme:cart:change', {
            detail: { cart: cart },
            bubbles: true
          }));
          document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
          var drawer = document.querySelector('[data-drawer="drawer-cart"]');
          if (drawer) {
            drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: true }));
          } else {
            window.location.href = '/cart';
          }
        });
    })
    .catch(function(err) {
      console.error('[JIR] Cart error:', err);
      showToast(extractCartErrorMessage(err, 'Could not add to cart. Please try again.'));
      if (addBtn) addBtn.disabled = false;
      if (stickyAddBtn) stickyAddBtn.disabled = false;
      updateAddToCartCtas(totalCents);
    });
  }

  function initSettingsFilterBar() {
    qAll('.jir-fpill').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var group = this.dataset.group;
        var val   = this.dataset.val;
        qAll('.jir-fpill[data-group="' + group + '"]').forEach(function(p) { p.classList.remove('jir-on'); });
        this.classList.add('jir-on');
        S.settingFilters[group] = val;
        updateActiveChips();
        renderSettings();
      });
    });
  }

  function syncSettingSortControls() {
    qAll('.jir-settings-sort-select').forEach(function(select) {
      if (select.value !== S.settingSort) select.value = S.settingSort;
    });
  }

  function initSettingsSortControls() {
    qAll('.jir-settings-sort-select').forEach(function(select) {
      select.addEventListener('change', function() {
        var nextSort = this.value || 'collection';
        if (['collection', 'price-asc', 'price-desc'].indexOf(nextSort) === -1) nextSort = 'collection';
        if (nextSort === S.settingSort) return;
        S.settingSort = nextSort;
        syncSettingSortControls();
        renderSettings();
      });
    });
    syncSettingSortControls();
  }

  function initSettingsFilterScroller() {
    var track   = el('jir-filter-bar-inner');
    var leftBtn = el('jir-filter-scroll-left');
    var rightBtn = el('jir-filter-scroll-right');
    if (!track || !leftBtn || !rightBtn) return;
    function updateButtons() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      leftBtn.disabled  = track.scrollLeft <= 4;
      rightBtn.disabled = track.scrollLeft >= maxScroll - 4;
    }
    leftBtn.addEventListener('click',  function() { track.scrollBy({ left: -260, behavior: 'smooth' }); });
    rightBtn.addEventListener('click', function() { track.scrollBy({ left:  260, behavior: 'smooth' }); });
    track.addEventListener('scroll', updateButtons);
    window.addEventListener('resize', updateButtons);
    _filterScrollUpdate = updateButtons; /* expose so goto() can re-run after page shows */
    updateButtons();
  }

  function updateActiveChips() {
    var holder = el('jir-active-chips');
    var row    = el('jir-chips-row');
    var mobile = el('jir-mob-chips-row');
    var count  = el('jir-mob-f-count');
    if (!holder) return;
    var entries = Object.keys(S.settingFilters).filter(function(k) { return S.settingFilters[k] !== 'All'; });
    holder.innerHTML = entries.map(function(k) {
      return '<div class="jir-chip">' + escapeHtml(S.settingFilters[k]) + '<span class="jir-chip-x" data-group="' + escapeHtml(k) + '">\u00d7</span></div>';
    }).join('');
    if (row)    row.classList.toggle('jir-has', entries.length > 0);
    if (mobile) mobile.innerHTML = holder.innerHTML;
    if (count)  { count.style.display = entries.length ? 'inline-flex' : 'none'; count.textContent = entries.length; }
    qAll('.jir-chip-x').forEach(function(x) {
      x.addEventListener('click', function() {
        var group  = this.dataset.group;
        S.settingFilters[group] = 'All';
        var allBtn = q('.jir-fpill[data-group="' + group + '"][data-val="All"]');
        if (allBtn) { qAll('.jir-fpill[data-group="' + group + '"]').forEach(function(p) { p.classList.remove('jir-on'); }); allBtn.classList.add('jir-on'); }
        updateActiveChips();
        renderSettings();
      });
    });
  }

  function clearAllFilters() {
    S.settingFilters = { shape: 'All', style: 'All', col: 'All' };
    qAll('.jir-fpill').forEach(function(btn) { btn.classList.toggle('jir-on', btn.dataset.val === 'All'); });
    updateActiveChips();
    renderSettings();
  }

  function initAccordions() {
    qAll('.jir-acc-hd').forEach(function(hd) {
      function toggleAccordion() {
        var bd = hd.nextElementSibling;
        if (!bd) return;
        bd.classList.toggle('jir-open');
        hd.setAttribute('aria-expanded', bd.classList.contains('jir-open') ? 'true' : 'false');
      }
      hd.addEventListener('click', toggleAccordion);
      hd.addEventListener('keydown', function(e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        toggleAccordion();
      });
    });
  }

  function initDiamondSidebarFilters() {
    qAll('[data-size-range]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (S.sizeRange === (this.dataset.sizeRange || 'classic')) return;
        S.sizeRange = this.dataset.sizeRange || 'classic';
        S.diamond = null;
        S.dIdx = 0;
        S.visibleDiamondCount = getRecommendedLimit();
        qAll('[data-size-range]').forEach(function(node) { node.classList.toggle('jir-on', node === btn); });
        collectSidebarFilters();
        renderDiamondMobileChips();
        saveAppSessionState();
        scheduleDiamondFetch(true);
      });
    });
    qAll('[data-quality-pref]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (S.qualityPreference === (this.dataset.qualityPref || 'balanced')) return;
        S.qualityPreference = this.dataset.qualityPref || 'balanced';
        S.diamond = null;
        S.dIdx = 0;
        S.visibleDiamondCount = getRecommendedLimit();
        qAll('[data-quality-pref]').forEach(function(node) { node.classList.toggle('jir-on', node === btn); });
        collectSidebarFilters();
        renderDiamondMobileChips();
        saveAppSessionState();
        applyClientSideDiamondFilters();
        renderDiamondGrid(getVisibleDiamonds());
        scheduleDiamondFetch(true, { preserveVisible: true });
      });
    });
    document.querySelectorAll('.jir-df-ck input').forEach(function(input) {
      input.addEventListener('change', function() {
        collectSidebarFilters();
        renderDiamondMobileChips();
        applyClientSideDiamondFilters();
        if (getVisibleDiamonds().length) {
          renderDiamondGrid(getVisibleDiamonds());
        } else {
          renderDiamondLoading();
        }
        scheduleDiamondFetch(true);
      });
    });
    qAll('[data-decision-mode]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        S.decisionMode = this.dataset.decisionMode || 'exact';
        qAll('[data-decision-mode]').forEach(function(node) { node.classList.toggle('jir-on', node === btn); });
        trackBuilderEvent('stone_decision_option_selected', {
          option_type: S.decisionMode === 'team' ? 'find_my_perfect_stone' : 'select_this_stone'
        });
        trackBuilderEvent('stone_decision_completed', {
          selected_path: S.decisionMode === 'team' ? 'find_my_perfect_stone' : 'select_this_stone'
        });
        updateDecisionModeUI();
        saveAppSessionState();
      });
    });
  }

  function countDiamondActiveFilters() {
    if (!S.customerFilters || !S.adminRules) return 0;
    var total = 0;
    if (S.sizeRange && S.sizeRange !== 'classic') total += 1;
    if (S.qualityPreference && S.qualityPreference !== 'balanced') total += 1;
    if (safeJsonStringify(cleanArray(S.customerFilters.cuts || [])) !== safeJsonStringify(cleanArray(S.adminRules.cuts || []))) total += 1;
    if (safeJsonStringify(cleanArray(S.customerFilters.colors || [])) !== safeJsonStringify(cleanArray(S.adminRules.colors || []))) total += 1;
    if (safeJsonStringify(cleanArray(S.customerFilters.clarities || [])) !== safeJsonStringify(cleanArray(S.adminRules.clarities || []))) total += 1;
    if (safeJsonStringify(cleanArray(S.customerFilters.fluors || [])) !== safeJsonStringify(cleanArray(S.adminRules.fluors || []))) total += 1;
    if (safeJsonStringify(cleanArray(S.customerFilters.labs || [])) !== safeJsonStringify(cleanArray(S.adminRules.labs || []))) total += 1;
    if (cleanArray(S.customerFilters.polish || []).length) total += 1;
    return total;
  }

  function renderDiamondMobileChips() {
    var row = el('jir-d-mob-chips-row');
    var count = el('jir-d-mob-f-count');
    if (!row || !count || !S.customerFilters || !S.adminRules) return;

    var chips = [];
    var range = SIZE_RANGES[S.sizeRange] || SIZE_RANGES.classic;
    chips.push('Size: ' + range.label + ' \u00b7 ' + formatSizeRangeLabel(range));
    var qualityOption = getQualityPreferenceOptions().find(function(option) {
      return option.value === (S.qualityPreference || 'balanced');
    });
    chips.push((qualityOption && qualityOption.label) || 'Best value');
    if (safeJsonStringify(cleanArray(S.customerFilters.cuts || [])) !== safeJsonStringify(cleanArray(S.adminRules.cuts || []))) chips.push('Cut');
    if (safeJsonStringify(cleanArray(S.customerFilters.colors || [])) !== safeJsonStringify(cleanArray(S.adminRules.colors || []))) chips.push('Colour');
    if (safeJsonStringify(cleanArray(S.customerFilters.clarities || [])) !== safeJsonStringify(cleanArray(S.adminRules.clarities || []))) chips.push('Clarity');
    if (safeJsonStringify(cleanArray(S.customerFilters.fluors || [])) !== safeJsonStringify(cleanArray(S.adminRules.fluors || []))) chips.push('Fluorescence');
    if (safeJsonStringify(cleanArray(S.customerFilters.labs || [])) !== safeJsonStringify(cleanArray(S.adminRules.labs || []))) chips.push('Lab');
    if (cleanArray(S.customerFilters.polish || []).length) chips.push('Polish');

    row.innerHTML = chips.map(function(label, index) {
      var extraClass = index === 0 ? ' jir-d-size-chip' : '';
      return '<button class="jir-chip jir-d-filter-chip' + extraClass + '" type="button" onclick="JIR.openBS(\'diamonds\')" aria-label="Refine diamonds: ' + escapeHtml(label) + '">' + escapeHtml(label) + '</button>';
    }).join('');
    var activeCount = countDiamondActiveFilters();
    count.style.display = activeCount ? 'inline' : 'none';
    count.textContent = '\u00b7 ' + activeCount;
    count.parentNode.setAttribute('aria-label', activeCount
      ? 'Open diamond filters, ' + activeCount + ' active'
      : 'Open diamond filters');
  }

  function buildDiamondCheckboxSection(label, group, allowedValues, selectedValues) {
    return [
      '<div class="jir-bs-section">',
      '<div class="jir-bs-sec-lbl">' + escapeHtml(label) + '</div>',
      '<div class="jir-bs-checks">',
      allowedValues.map(function(v) {
        var checked = selectedValues.indexOf(v) > -1 ? ' checked' : '';
        return '<label class="jir-bs-ck"><input type="checkbox" data-bs-filter-group="' + escapeHtml(group) + '" value="' + escapeHtml(v) + '"' + checked + '><span>' + escapeHtml(v) + '</span></label>';
      }).join(''),
      '</div>',
      '</div>'
    ].join('');
  }

  function openBS(context) {
    var overlay = el('jir-bs-overlay');
    var sheet   = el('jir-bottom-sheet');
    var body    = el('jir-bs-body');
    var title   = el('jir-bs-title');
    var apply   = el('jir-bs-apply');
    if (!overlay || !sheet || !body) return;
    sheet.dataset.context = context || 'settings';
    title.textContent = context === 'diamonds'
      ? textCfg('filterDiamondsTitle', 'Refine Diamonds')
      : textCfg('filterSettingsTitle', 'Filter settings');
    if (apply) {
      apply.textContent = context === 'diamonds'
        ? 'Show Recommended Diamonds'
        : (apply.dataset.defaultLabel || 'Show results');
    }
    if (context === 'settings') {
      var collectionOptions = ['All'].concat(getSettingCollectionOptions());
      body.innerHTML = [
        '<div class="jir-bs-section"><div class="jir-bs-sec-lbl">Shape</div><div class="jir-bs-pills">',
        ['All', 'Round', 'Oval', 'Pear', 'Cushion', 'Emerald', 'Marquise', 'Princess', 'Radiant'].map(function(v) {
          return '<button class="jir-bs-pill' + (S.settingFilters.shape === v ? ' jir-on' : '') + '" data-bs-group="shape" data-bs-val="' + escapeHtml(v) + '">' + escapeHtml(v) + '</button>';
        }).join(''),
        '</div></div>',
        '<div class="jir-bs-section"><div class="jir-bs-sec-lbl">Style</div><div class="jir-bs-pills">',
        ['All', 'Solitaire', 'Halo', 'Trilogy', 'Cluster', 'Bezel'].map(function(v) {
          return '<button class="jir-bs-pill' + (S.settingFilters.style === v ? ' jir-on' : '') + '" data-bs-group="style" data-bs-val="' + escapeHtml(v) + '">' + escapeHtml(v) + '</button>';
        }).join(''),
        '</div></div>',
        '<div class="jir-bs-section"><div class="jir-bs-sec-lbl">Collection</div><div class="jir-bs-pills">',
        collectionOptions.map(function(v) {
          return '<button class="jir-bs-pill' + (S.settingFilters.col === v ? ' jir-on' : '') + '" data-bs-group="col" data-bs-val="' + escapeHtml(v) + '">' + escapeHtml(v) + '</button>';
        }).join(''),
        '</div></div>'
      ].join('');
      body.querySelectorAll('.jir-bs-pill').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var group = this.dataset.bsGroup;
          body.querySelectorAll('.jir-bs-pill[data-bs-group="' + group + '"]').forEach(function(p) { p.classList.remove('jir-on'); });
          this.classList.add('jir-on');
        });
      });
    } else {
      body.innerHTML = [
        '<div class="jir-bs-section">',
        '<div class="jir-bs-sec-lbl">Preferred diamond size</div>',
        '<div class="jir-bs-pills">',
        Object.keys(SIZE_RANGES).map(function(key) {
          var range = SIZE_RANGES[key] || {};
          return '<button class="jir-bs-pill jir-bs-pill--stacked' + (S.sizeRange === key ? ' jir-on' : '') + '" data-bs-group="size" data-bs-val="' + escapeHtml(key) + '">' +
            '<span>' + escapeHtml(range.label || key) + '</span>' +
            '<small>' + escapeHtml(formatSizeRangeLabel(range)) + '</small>' +
          '</button>';
        }).join(''),
        '</div>',
        '</div>',
        '<div class="jir-bs-section">',
        '<div class="jir-bs-sec-lbl">Quality preference</div>',
        '<div class="jir-bs-pills">',
        getQualityPreferenceOptions().map(function(item) {
          return '<button class="jir-bs-pill' + (S.qualityPreference === item.value ? ' jir-on' : '') + '" data-bs-group="quality" data-bs-val="' + escapeHtml(item.value) + '">' + escapeHtml(item.label) + '</button>';
        }).join(''),
        '</div>',
        '</div>',
        buildDiamondCheckboxSection('Cut grade', 'cut', cleanArray(S.adminRules.cuts || []), cleanArray(S.customerFilters.cuts || [])),
        buildDiamondCheckboxSection('Colour', 'colour', cleanArray(S.adminRules.colors || []), cleanArray(S.customerFilters.colors || [])),
        buildDiamondCheckboxSection('Clarity', 'clarity', cleanArray(S.adminRules.clarities || []), cleanArray(S.customerFilters.clarities || [])),
        buildDiamondCheckboxSection('Fluorescence', 'fluor', cleanArray(S.adminRules.fluors || []), cleanArray(S.customerFilters.fluors || [])),
        buildDiamondCheckboxSection('Certificate lab', 'lab', cleanArray(S.adminRules.labs || []), cleanArray(S.customerFilters.labs || [])),
        '<div class="jir-bs-section"><div class="jir-bs-note">These refinements narrow the recommended diamonds selected for your setting.</div></div>'
      ].join('');

      body.querySelectorAll('.jir-bs-pill').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var group = this.dataset.bsGroup;
          body.querySelectorAll('.jir-bs-pill[data-bs-group="' + group + '"]').forEach(function(p) { p.classList.remove('jir-on'); });
          this.classList.add('jir-on');
        });
      });
    }
    overlay.classList.add('jir-show');
    sheet.classList.add('jir-open');
  }

  function closeBS() {
    var overlay = el('jir-bs-overlay');
    var sheet   = el('jir-bottom-sheet');
    if (overlay) overlay.classList.remove('jir-show');
    if (sheet)   sheet.classList.remove('jir-open');
  }

  function clearBS() {
    var sheet = el('jir-bottom-sheet');
    var body  = el('jir-bs-body');
    if (!sheet || !body) return;

    if (sheet.dataset.context === 'settings') {
      body.querySelectorAll('.jir-bs-pill').forEach(function(btn) {
        btn.classList.toggle('jir-on', btn.dataset.bsVal === 'All');
      });
      return;
    }

    body.querySelectorAll('.jir-bs-pill[data-bs-group="size"]').forEach(function(btn) { btn.classList.toggle('jir-on', btn.dataset.bsVal === getConfiguredDefaultSizeRange()); });
    body.querySelectorAll('.jir-bs-pill[data-bs-group="budget"]').forEach(function(btn) { btn.classList.toggle('jir-on', btn.dataset.bsVal === 'any'); });
    body.querySelectorAll('.jir-bs-pill[data-bs-group="quality"]').forEach(function(btn) { btn.classList.toggle('jir-on', btn.dataset.bsVal === getConfiguredDefaultQualityPreference()); });
    body.querySelectorAll('[data-bs-filter-group]').forEach(function(node) {
      var group = node.dataset.bsFilterGroup;
      var defaults = {
        cut: S.adminRules.cuts,
        colour: S.adminRules.colors,
        clarity: S.adminRules.clarities,
        fluor: S.adminRules.fluors,
        lab: S.adminRules.labs
      };
      node.checked = !!(defaults[group] && defaults[group].indexOf(node.value) > -1);
    });
  }

  function applyBS() {
    var sheet = el('jir-bottom-sheet');
    var body  = el('jir-bs-body');
    if (!sheet || !body) return;
    if (sheet.dataset.context === 'settings') {
      var activeShape = body.querySelector('.jir-bs-pill.jir-on[data-bs-group="shape"]');
      var activeStyle = body.querySelector('.jir-bs-pill.jir-on[data-bs-group="style"]');
      var activeCollection = body.querySelector('.jir-bs-pill.jir-on[data-bs-group="col"]');
      if (activeShape) S.settingFilters.shape = activeShape.dataset.bsVal;
      if (activeStyle) S.settingFilters.style = activeStyle.dataset.bsVal;
      if (activeCollection) S.settingFilters.col = activeCollection.dataset.bsVal;
      qAll('.jir-fpill[data-group="shape"]').forEach(function(btn) { btn.classList.toggle('jir-on', btn.dataset.val === S.settingFilters.shape); });
      qAll('.jir-fpill[data-group="style"]').forEach(function(btn) { btn.classList.toggle('jir-on', btn.dataset.val === S.settingFilters.style); });
      qAll('.jir-fpill[data-group="col"]').forEach(function(btn) { btn.classList.toggle('jir-on', btn.dataset.val === S.settingFilters.col); });
      updateActiveChips();
      renderSettings();
    } else {
      var activeSize = body.querySelector('.jir-bs-pill.jir-on[data-bs-group="size"]');
      var activeQuality = body.querySelector('.jir-bs-pill.jir-on[data-bs-group="quality"]');
      var groups = ['cut', 'colour', 'clarity', 'fluor', 'lab'];
      var previousDiamondFetchKey = diamondFetchKey();

      if (activeSize) S.sizeRange = activeSize.dataset.bsVal || 'classic';
      if (activeQuality) S.qualityPreference = activeQuality.dataset.bsVal || 'balanced';
      qAll('[data-size-range]').forEach(function(btn) { btn.classList.toggle('jir-on', btn.dataset.sizeRange === S.sizeRange); });
      qAll('[data-quality-pref]').forEach(function(btn) { btn.classList.toggle('jir-on', btn.dataset.qualityPref === S.qualityPreference); });

      groups.forEach(function(group) {
        var selected = [];
        body.querySelectorAll('[data-bs-filter-group="' + group + '"]:checked').forEach(function(node) { selected.push(node.value); });
        qAll('[data-filter-group="' + group + '"] input').forEach(function(node) {
          node.checked = selected.indexOf(node.value) > -1;
        });
      });

      collectSidebarFilters();
      if (previousDiamondFetchKey !== diamondFetchKey()) {
        S.diamond = null;
        S.dIdx = 0;
        S.visibleDiamondCount = getRecommendedLimit();
      }
      renderDiamondMobileChips();
      saveAppSessionState();
      scheduleDiamondFetch(true);
    }
    closeBS();
  }

  function closeOverlay(id) { var node = el(id); if (node) node.classList.remove('jir-show'); }
  function openOverlay(id)  { var node = el(id); if (node) node.classList.add('jir-show'); }

  function renderGradeTab(type) {
    var ed = getGradeModalContent(type);
    if (!ed) return;
    var tabs = el('jir-grade-tabs');
    if (tabs) {
      tabs.querySelectorAll('.jir-grade-tab').forEach(function(tab) {
        var isActive = tab.dataset.gradeTab === type;
        tab.classList.toggle('jir-on', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });
    }
    setText('jir-grade-title', ed.title);
    setText('jir-grade-body',  ed.intro);
    var grid = el('jir-grade-grid');
    if (grid) {
      grid.innerHTML = ed.rows.map(function(row) {
        return '<div class="jir-grade-item"><div class="jir-grade-item-name">' + escapeHtml(row.g) + '</div><div class="jir-grade-item-desc">' + escapeHtml(row.d) + '</div></div>';
      }).join('');
    }
  }

  function showGrade(type) {
    var ed = getGradeModalContent(type);
    if (!ed) return;
    var tabs = el('jir-grade-tabs');
    var tabOrder = getGradeModalTabOrder(type);
    if (tabs) {
      tabs.innerHTML = tabOrder.map(function(key) {
        var tabContent = getGradeModalContent(key);
        if (!tabContent) return '';
        return '<button class="jir-grade-tab' + (key === type ? ' jir-on' : '') + '" type="button" role="tab" data-grade-tab="' + escapeHtml(key) + '" aria-selected="' + (key === type ? 'true' : 'false') + '">' + escapeHtml(GRADE_TAB_LABELS[key] || tabContent.title) + '</button>';
      }).join('');
      tabs.querySelectorAll('.jir-grade-tab').forEach(function(tab) {
        tab.addEventListener('click', function() { renderGradeTab(this.dataset.gradeTab); });
      });
    }
    renderGradeTab(type);
    openOverlay('jir-grade-overlay');
  }

  function toggleAdvancedFilters() {
    var adv = el('jir-filter-adv');
    var btn = el('jir-more-btn');
    if (!adv || !btn) return;
    setButtonResponse(btn);
    adv.classList.toggle('jir-open');
    btn.classList.toggle('jir-open');
    btn.setAttribute('aria-expanded', adv.classList.contains('jir-open') ? 'true' : 'false');
    S.advancedFiltersOpened = adv.classList.contains('jir-open');
    if (S.advancedFiltersOpened) {
      trackBuilderEvent('byor_advanced_filters_opened', {
        source: 'filter_panel'
      });
      trackBuilderEvent('byor_advanced_search_opened', {
        source: 'filter_panel'
      });
      showToast('Advanced filters opened');
      if (!S.browseMoreOpened && !S.dLoading) fetchLayer1DiamondPool();
    }
    if (S.filteredDiamonds.length) renderDiamondGrid(getVisibleDiamonds());
    renderDiamondResultsFooter();
  }

  function openAdvancedFilters() {
    if (CFG.enableAdvancedSearch === false) return;
    var adv = el('jir-filter-adv');
    var btn = el('jir-more-btn');
    var footerBtn = el('jir-advanced-filters-btn');
    setButtonResponse(footerBtn);
    S.advancedFiltersOpened = true;
    if (!S.browseMoreOpened && !S.dLoading) fetchLayer1DiamondPool();
    if (window.matchMedia && window.matchMedia('(max-width: 900px)').matches) {
      trackBuilderEvent('byor_advanced_filters_opened', {
        source: 'results_footer_mobile'
      });
      trackBuilderEvent('byor_advanced_search_opened', {
        source: 'results_footer_mobile'
      });
      showToast('Advanced filters opened');
      renderDiamondResultsFooter();
      openBS('diamonds');
      return;
    }
    if (adv && btn) {
      adv.classList.add('jir-open');
      btn.classList.add('jir-open');
      btn.setAttribute('aria-expanded', 'true');
      adv.setAttribute('tabindex', '-1');
    }
    trackBuilderEvent('byor_advanced_filters_opened', {
      source: 'results_footer'
    });
    trackBuilderEvent('byor_advanced_search_opened', {
      source: 'results_footer'
    });
    showToast('Advanced filters opened');
    if (S.filteredDiamonds.length) renderDiamondGrid(getVisibleDiamonds());
    renderDiamondResultsFooter();
    setTimeout(function() {
      if (!adv) return;
      adv.scrollIntoView({ behavior: 'smooth', block: 'start' });
      adv.focus({ preventScroll: true });
    }, 80);
  }

  function toggleSpec() {
    var panel = el('jir-spec-panel');
    var btn   = el('jir-spec-toggle-btn');
    if (!panel || !btn) return;
    panel.classList.toggle('jir-open');
    btn.classList.toggle('jir-open');
    btn.setAttribute('aria-expanded', panel.classList.contains('jir-open') ? 'true' : 'false');
  }

  function copyBuildLink() {
    navigator.clipboard.writeText(window.location.href)
      .then(function() { showToast(textCfg('copyBuildSuccess', 'Build link copied')); })
      .catch(function() { showToast(textCfg('copyBuildFallback', 'Copy this page URL to save your build')); });
  }

  function openEnquiry() {
    var ctx = el('jir-enq-ctx');
    if (ctx) {
      var range = SIZE_RANGES[S.sizeRange] || SIZE_RANGES.classic;
      var summary = S.setting
        ? [
            S.setting.name,
            S.metal,
            S.diamond ? (S.diamond.carat + 'ct ' + S.diamond.shape) : (S.shape + ' ' + range.label + ' range'),
            S.decisionMode === 'team' ? 'Find My Perfect Stone requested' : ''
          ].filter(Boolean).join(' \u00b7 ')
        : textCfg('enquiryNoSelectionText', 'No setting selected yet');
      ctx.innerHTML = escapeHtml(textCfg('enquiryContextPrefix', 'Current build:')) + ' <strong>' + escapeHtml(summary) + '</strong>';
    }
    openOverlay('jir-enq-overlay');
  }

  function chooseExpertSelection(event) {
    if (event && event.stopPropagation) event.stopPropagation();
    var trigger = event && event.currentTarget ? event.currentTarget : (event && event.target ? event.target.closest('button') : null);
    setButtonResponse(trigger, 'Opening expert request form');
    S.decisionMode = 'team';
    trackBuilderEvent('expert_select_chosen', {});
    trackBuilderEvent('byor_team_pick_selected', {
      tier1_result_count: getRecommendedCount(),
      source: event && event.target ? 'diamond_results' : 'unknown'
    });
    trackBuilderEvent('byor_let_team_choose_clicked', {
      tier1_result_count: getRecommendedCount(),
      source: event && event.target ? 'diamond_results' : 'unknown'
    });
    trackBuilderEvent('stone_decision_option_selected', {
      option_type: 'find_my_perfect_stone'
    });
    trackBuilderEvent('stone_decision_completed', {
      selected_path: 'find_my_perfect_stone'
    });
    openEnquiry();
  }

  function submitEnquiry() {
    var name  = el('jir-enq-name');
    var email = el('jir-enq-email');
    var msg   = el('jir-enq-msg');
    if (!name || !name.value.trim() || !email || !email.value.trim()) { showToast(textCfg('validationNameEmail', 'Please enter your name and email')); return; }
    var fd = new FormData();
    fd.append('form_type', 'contact');
    fd.append('utf8', '\u2713');
    fd.append('contact[name]',  name.value);
    fd.append('contact[email]', email.value);
    var range = SIZE_RANGES[S.sizeRange] || SIZE_RANGES.classic;
    var context = [
      'Decision path: ' + (S.decisionMode === 'team' ? 'Find My Perfect Stone' : 'Select This Diamond'),
      S.setting ? ('Setting: ' + S.setting.name) : '',
      S.metal ? ('Metal: ' + S.metal) : '',
      S.shape ? ('Shape: ' + S.shape) : '',
      'Size range: ' + range.label,
      S.diamond ? ('Selected stone: ' + formatCartDiamondTitle(S.diamond)) : ''
    ].filter(Boolean).join('\n');
    fd.append('contact[body]',  context + '\n\n' + ((msg && msg.value) ? msg.value : 'Ring builder enquiry'));
    fetch('/contact', { method: 'POST', body: fd })
      .then(function()  { trackBuilderEvent('builder_enquiry_submit', { selected_preferences: context }); closeOverlay('jir-enq-overlay'); showToast(textCfg('enquirySentText', 'Enquiry sent')); })
      .catch(function() { trackBuilderEvent('builder_enquiry_submit', { selected_preferences: context }); closeOverlay('jir-enq-overlay'); showToast(textCfg('enquirySentText', 'Enquiry sent')); });
  }

  function prevDiamond() {
    if (!S.filteredDiamonds.length) return;
    var next = S.dIdx - 1;
    if (next < 0) next = S.filteredDiamonds.length - 1;
    selectDiamond(next);
  }

  function nextDiamond() {
    if (!S.filteredDiamonds.length) return;
    var next = S.dIdx + 1;
    if (next >= S.filteredDiamonds.length) next = 0;
    selectDiamond(next);
  }

  function demoStalePrice() { openOverlay('jir-stale-overlay'); }

  /* ── Price slider bounds helpers ─────────────────────────────────────────
   * sliderStep: pick a round step size based on the price range
   * roundDown / roundUp: snap prices to the nearest step for clean labels
   * ─────────────────────────────────────────────────────────────────────── */
  function sliderStep(range) {
    if (range > 80000) return 2000;
    if (range > 30000) return 1000;
    return 500;
  }
  function roundDown(val, step) { return Math.floor(val / step) * step; }
  function roundUp(val, step)   { return Math.ceil(val  / step) * step; }

  /* ── updatePriceSliderBounds ─────────────────────────────────────────────
   * Called at init (from settings data) and after each diamond fetch
   * (from real diamond price spread). Updates the slider min/max/step/value
   * and both left (#jir-pr-min) and right (#jir-pr-v) labels.
   *
   * calcMin: lowest fromPrice across all settings (setting + entry diamond)
   * calcMax: after diamonds are fetched — highest (diamondPrice + metalP);
   *          before fetch — 5× the min, floored to a sensible ceiling
   * ─────────────────────────────────────────────────────────────────────── */
  function updatePriceSliderBounds() {
    var priceRange = el('jir-df-price');
    if (!priceRange) return;

    /* ── Min: lowest declared fromPrice across all settings ── */
    var availableFromPrices = S.settings.map(function(s) { return getSettingFromPrice(s); }).filter(function(value) {
      return Number(value) > 0;
    });
    var rawMin = availableFromPrices.length
      ? Math.min.apply(null, availableFromPrices)
      : Math.max.apply(null, [2000].concat(S.settings.map(function(s) { return Number(s.basePrice || 0); })));
    rawMin = Math.max(rawMin, 0);

    /* ── Max: from fetched diamonds if available, otherwise estimate ── */
    var rawMax;
    if (S.allFetchedDiamonds.length) {
      var sp = Number(S.metalP || 0);
      rawMax = Math.max.apply(null, S.allFetchedDiamonds.map(function(d) {
        return Math.round(d.price / 100) + sp;
      }));
    } else {
      /* Estimate: 5× the min, minimum ceiling of $10,000 */
      rawMax = Math.max(rawMin * 5, 10000);
    }

    var step  = sliderStep(rawMax - rawMin);
    var pMin  = roundDown(rawMin, step);
    var pMax  = roundUp(rawMax, step);

    /* Guard: max must always exceed min */
    if (pMax <= pMin) pMax = pMin + step * 10;

    /* Only reset slider value if user hasn't filtered yet (value is at old max) */
    var currentVal = Number(priceRange.value);
    var atMax      = currentVal >= Number(priceRange.max) - step;

    priceRange.min  = pMin;
    priceRange.max  = pMax;
    priceRange.step = step;

    if (atMax || currentVal < pMin || currentVal > pMax) {
      priceRange.value = pMax;
      setText('jir-pr-v', fmtSliderPrice(pMax));
    }

    setText('jir-pr-min', fmtSliderPrice(pMin));
    S.priceSliderMin = pMin;
    S.priceSliderMax = pMax;
  }

  function initDiamondRuleUI() {
    var priceRange = el('jir-df-price');
    if (priceRange) {
      /* Seed from settings data — will update again after diamonds are fetched */
      updatePriceSliderBounds();
      priceRange.addEventListener('input', function() {
        setText('jir-pr-v', fmtSliderPrice(Number(this.value)));
      });
      priceRange.addEventListener('change', function() {
        collectSidebarFilters();
        scheduleDiamondFetch(true);
      });
    }
    qAll('[data-size-range]').forEach(function(node) { node.classList.toggle('jir-on', node.dataset.sizeRange === S.sizeRange); });
    qAll('[data-quality-pref]').forEach(function(node) { node.classList.toggle('jir-on', node.dataset.qualityPref === S.qualityPreference); });
    function syncChecks(group, values) {
      qAll('[data-filter-group="' + group + '"] input').forEach(function(node) {
        var allowed = values.indexOf(node.value) > -1;
        node.checked  = allowed;
        node.disabled = !allowed;
        var row = node.closest('.jir-df-ck');
        if (row) row.style.display = allowed ? '' : 'none';
      });
    }
    syncChecks('colour',  S.adminRules.colors);
    syncChecks('clarity', S.adminRules.clarities);
    syncChecks('cut',     S.adminRules.cuts);
    syncChecks('fluor',   S.adminRules.fluors);
    syncChecks('lab',     S.adminRules.labs);
  }

  function retryDiamonds() {
    var defaultSizeRange = getConfiguredDefaultSizeRange();
    var defaultQualityPreference = getConfiguredDefaultQualityPreference();
    S.customerFilters = {
      caratMin: S.adminRules.caratMin, caratMax: S.adminRules.caratMax,
      qualityPreference: defaultQualityPreference,
      colors:    S.adminRules.colors.slice(),
      clarities: S.adminRules.clarities.slice(),
      cuts:      S.adminRules.cuts.slice(),
      fluors:    S.adminRules.fluors.slice(),
      labs:      S.adminRules.labs.slice(),
      polish:    []
    };
    S.sizeRange = defaultSizeRange;
    S.qualityPreference = defaultQualityPreference;
    initDiamondRuleUI();
    collectSidebarFilters();
    qAll('[data-filter-group="polish"] input').forEach(function(node) { node.checked = false; });
    renderDiamondMobileChips();
    scheduleDiamondFetch(true);
  }

  /* ─── INJECT LOAD-MORE FOOTER ───────────────────────────────────────────
   * The liquid HTML has no footer elements for the load-more UI.
   * renderDiamondResultsFooter() was silently exiting every call because
   * #jir-d-results-footer / #jir-d-results-meta / #jir-load-more-btn
   * never existed in the DOM. We inject them here once at init time.
   * ─────────────────────────────────────────────────────────────────────── */
  function injectDiamondFooter() {
    var main = q('.jir-d-main');   /* class, not ID — must use querySelector */
    if (!main || el('jir-d-results-footer')) return; /* already injected */
    var footer = document.createElement('div');
    footer.id = 'jir-d-results-footer';
    footer.style.cssText = [
      'display:none',
      'flex-direction:column',
      'align-items:center',
      'gap:14px',
      'padding:28px 20px 32px',
      'border-top:1px solid var(--jir-ivm)',
      'margin-top:8px'
    ].join(';');
    footer.innerHTML =
      '<div id="jir-d-results-meta" style="font-size:11px;color:var(--jir-ins);font-weight:300;letter-spacing:.5px;"></div>' +
      '<div class="jir-d-results-actions">' +
        '<button id="jir-load-more-btn" class="jir-btn-ghost" type="button" style="font-size:9px;letter-spacing:2px;min-width:220px;justify-content:center;display:none;" onclick="window.JIR.loadMoreDiamonds()">Load more diamonds</button>' +
        '<button id="jir-advanced-filters-btn" class="jir-link-btn" type="button" aria-expanded="false" aria-controls="jir-filter-adv" onclick="window.JIR.openAdvancedFilters()">' + escapeHtml(textCfg('advancedFiltersLabel', 'Advanced diamond filters')) + '</button>' +
        '<button id="jir-team-pick-footer-btn" class="jir-btn-gem" type="button" onclick="window.JIR.chooseExpertSelection(event)">' + escapeHtml(textCfg('shortlistFallbackCta', 'Ask our team to select')) + '</button>' +
      '</div>' +
      '<div id="jir-d-results-loading" class="jir-d-results-loading" role="status" aria-live="polite" aria-hidden="true">' +
        '<span class="jir-d-results-loading-text">Searching for more diamonds in your selected range…</span>' +
        '<span class="jir-d-results-loading-bar" aria-hidden="true"></span>' +
      '</div>';
    main.appendChild(footer);
  }

  /* Re-render all price labels when currency changes */
  function refreshCurrencyLabels() {
    var priceRange = el('jir-df-price');
    if (priceRange) {
      setText('jir-pr-min', fmtSliderPrice(Number(priceRange.min)));
      setText('jir-pr-v',   fmtSliderPrice(Number(priceRange.value)));
    }
    /* Re-render diamond grid price labels if diamonds are loaded */
    if (S.filteredDiamonds.length) renderDiamondGrid(getVisibleDiamonds());
    /* Re-render diamond detail price if one is selected */
    if (S.diamond && S.setting) {
      var totalCents = S.diamond.price + (Number(S.metalP || 0) * 100);
      setText('jir-ph-price', fmtPrice(totalCents));
      setText('jir-ph-includes', 'Includes ' + S.setting.name + ' in ' + S.metal + ' + this centre diamond');
      renderPriceBreakdown(S.diamond);
      renderStickyDiamondSummary(S.diamond);
      updateAddToCartCtas(totalCents);
    }
  }

  function init() {
    S.settings    = Array.isArray(window.JIR_SETTINGS) ? window.JIR_SETTINGS : [];
    S.adminRules  = normaliseAdminRules(CFG.diamondRules || {});
    S.pageSize    = Math.max(3, Math.min(CURATED_VISIBLE_MAX, Number(S.adminRules.pageSize || CURATED_VISIBLE_MAX)));
    S.browseMorePageSize = Math.max(1, Math.min(30, Number(S.adminRules.browseMorePageSize || 20)));
    S.sizeRange = getConfiguredDefaultSizeRange();
    S.qualityPreference = getConfiguredDefaultQualityPreference();

    S.customerFilters = {
      caratMin: S.adminRules.caratMin, caratMax: S.adminRules.caratMax,
      qualityPreference: S.qualityPreference,
      colors:    S.adminRules.colors.slice(),
      clarities: S.adminRules.clarities.slice(),
      cuts:      S.adminRules.cuts.slice(),
      fluors:    S.adminRules.fluors.slice(),
      labs:      S.adminRules.labs.slice(),
      polish:    []
    };

    injectDiamondFooter();    /* must run before any diamond fetch */
    initAccordions();
    initSettingsFilterBar();
    initSettingsFilterScroller();
    initSettingsSortControls();
    initPDPSizeSelector();
    initDiamondRuleUI();
    initDiamondSidebarFilters();
    collectSidebarFilters();
    updateActiveChips();
    renderDiamondMobileChips();
    renderSettings();
    preloadSettingCardPrices();
    if (!initWinterEventEntry() && !restoreBuildFromURL()) restoreAppSessionState();
    revealRestoredBuilder();
    var breakdownToggle = el('jir-ph-breakdown-toggle');
    if (breakdownToggle) breakdownToggle.addEventListener('click', function() { toggleBreakdown(); });
    window.addEventListener('resize', syncDiamondMediaOnResize, { passive: true });
    window.addEventListener('resize', syncMobileStickyBars, { passive: true });
    syncMobileStickyBars();
    sanitizeGlobalFooterUI();

    document.addEventListener('click', function(e) {
      if (e.target.id === 'jir-cert-overlay') closeCertificate();
      else if (e.target.classList.contains('jir-overlay')) e.target.classList.remove('jir-show');
      if (e.target.id === 'jir-bs-overlay') closeBS();
    });

    /* ── Shopify Markets currency change ──────────────────────────────────
     * When the customer switches currency, Shopify fires a custom event and
     * updates Shopify.currency.active + Shopify.currency.rate. We re-render
     * all price labels so they stay in sync with the storefront currency.
     * ─────────────────────────────────────────────────────────────────── */
    document.addEventListener('shopify:section:load', refreshCurrencyLabels);
    window.addEventListener('currency:changed', refreshCurrencyLabels); /* some currency apps */
    /* Observe Shopify's currency attribute if present */
    if (window.Shopify && window.Shopify.currency) {
      var _lastCurrency = window.Shopify.currency.active;
      setInterval(function() {
        var current = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
        if (current && current !== _lastCurrency) {
          _lastCurrency = current;
          refreshCurrencyLabels();
        }
      }, 800);
    }
  }

  window.JIR = {
    goto: goto, startBuilding: startBuilding, selectSetting: selectSetting,
    backFromSettingPdp: backFromSettingPdp,
    editSetting: editSetting,
    goToSettingStep: goToSettingStep,
    goToDiamondsFromPdp: goToDiamondsFromPdp,
    goBackToDiamonds: goBackToDiamonds,
    addToCart: addToCart, retryDiamonds: retryDiamonds, loadMoreDiamonds: loadMoreDiamonds,
    openBS: openBS, closeBS: closeBS, applyBS: applyBS, clearBS: clearBS, clearAllFilters: clearAllFilters,
    openOverlay: openOverlay,
    closeOverlay: closeOverlay, openEnquiry: openEnquiry, chooseExpertSelection: chooseExpertSelection, submitEnquiry: submitEnquiry,
    openCertificate: openCertificate, closeCertificate: closeCertificate,
    showGrade: showGrade, toggleAdvancedFilters: toggleAdvancedFilters, openAdvancedFilters: openAdvancedFilters,
    toggleSpec: toggleSpec, copyBuildLink: copyBuildLink,
    prevDiamond: prevDiamond, nextDiamond: nextDiamond, demoStalePrice: demoStalePrice
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
